import * as q from "react";
import $, { createContext as $e, useMemo as xe, createElement as A, useContext as Je, useCallback as W, forwardRef as S, Children as be, isValidElement as Me, cloneElement as at, Fragment as Ze, useRef as N, useEffect as Y, useState as V, useLayoutEffect as Yr, useReducer as yc, Component as Lu, PureComponent as wc } from "react";
import * as zu from "react-dom";
import Hi, { flushSync as qn, createPortal as Ui } from "react-dom";
import I, { css as j, createGlobalStyle as Gu, keyframes as Re } from "styled-components";
import { NavLink as Hr, Link as Yu } from "react-router-dom";
function Hu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ri = { exports: {} }, Dn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ga;
function Uu() {
  if (Ga)
    return Dn;
  Ga = 1;
  var e = $, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, c, l) {
    var u, d = {}, m = null, p = null;
    l !== void 0 && (m = "" + l), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (u in c)
      r.call(c, u) && !i.hasOwnProperty(u) && (d[u] = c[u]);
    if (s && s.defaultProps)
      for (u in c = s.defaultProps, c)
        d[u] === void 0 && (d[u] = c[u]);
    return { $$typeof: t, type: s, key: m, ref: p, props: d, _owner: o.current };
  }
  return Dn.Fragment = n, Dn.jsx = a, Dn.jsxs = a, Dn;
}
var Mn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ya;
function Wu() {
  return Ya || (Ya = 1, process.env.NODE_ENV !== "production" && function() {
    var e = $, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), h = Symbol.iterator, f = "@@iterator";
    function g(y) {
      if (y === null || typeof y != "object")
        return null;
      var k = h && y[h] || y[f];
      return typeof k == "function" ? k : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(y) {
      {
        for (var k = arguments.length, H = new Array(k > 1 ? k - 1 : 0), oe = 1; oe < k; oe++)
          H[oe - 1] = arguments[oe];
        w("error", y, H);
      }
    }
    function w(y, k, H) {
      {
        var oe = v.ReactDebugCurrentFrame, he = oe.getStackAddendum();
        he !== "" && (k += "%s", H = H.concat([he]));
        var ge = H.map(function(fe) {
          return String(fe);
        });
        ge.unshift("Warning: " + k), Function.prototype.apply.call(console[y], console, ge);
      }
    }
    var C = !1, T = !1, P = !1, M = !1, R = !1, G;
    G = Symbol.for("react.module.reference");
    function Q(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === r || y === i || R || y === o || y === l || y === u || M || y === p || C || T || P || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === d || y.$$typeof === a || y.$$typeof === s || y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === G || y.getModuleId !== void 0));
    }
    function U(y, k, H) {
      var oe = y.displayName;
      if (oe)
        return oe;
      var he = k.displayName || k.name || "";
      return he !== "" ? H + "(" + he + ")" : H;
    }
    function te(y) {
      return y.displayName || "Context";
    }
    function X(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case s:
            var k = y;
            return te(k) + ".Consumer";
          case a:
            var H = y;
            return te(H._context) + ".Provider";
          case c:
            return U(y, y.render, "ForwardRef");
          case d:
            var oe = y.displayName || null;
            return oe !== null ? oe : X(y.type) || "Memo";
          case m: {
            var he = y, ge = he._payload, fe = he._init;
            try {
              return X(fe(ge));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, L = 0, z, Z, ne, K, B, ee, se;
    function re() {
    }
    re.__reactDisabledLog = !0;
    function ie() {
      {
        if (L === 0) {
          z = console.log, Z = console.info, ne = console.warn, K = console.error, B = console.group, ee = console.groupCollapsed, se = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: re,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        L++;
      }
    }
    function ue() {
      {
        if (L--, L === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, y, {
              value: z
            }),
            info: F({}, y, {
              value: Z
            }),
            warn: F({}, y, {
              value: ne
            }),
            error: F({}, y, {
              value: K
            }),
            group: F({}, y, {
              value: B
            }),
            groupCollapsed: F({}, y, {
              value: ee
            }),
            groupEnd: F({}, y, {
              value: se
            })
          });
        }
        L < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = v.ReactCurrentDispatcher, ye;
    function De(y, k, H) {
      {
        if (ye === void 0)
          try {
            throw Error();
          } catch (he) {
            var oe = he.stack.trim().match(/\n( *(at )?)/);
            ye = oe && oe[1] || "";
          }
        return `
` + ye + y;
      }
    }
    var Ce = !1, He;
    {
      var On = typeof WeakMap == "function" ? WeakMap : Map;
      He = new On();
    }
    function kt(y, k) {
      if (!y || Ce)
        return "";
      {
        var H = He.get(y);
        if (H !== void 0)
          return H;
      }
      var oe;
      Ce = !0;
      var he = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ge;
      ge = Te.current, Te.current = null, ie();
      try {
        if (k) {
          var fe = function() {
            throw Error();
          };
          if (Object.defineProperty(fe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(fe, []);
            } catch (ft) {
              oe = ft;
            }
            Reflect.construct(y, [], fe);
          } else {
            try {
              fe.call();
            } catch (ft) {
              oe = ft;
            }
            y.call(fe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ft) {
            oe = ft;
          }
          y();
        }
      } catch (ft) {
        if (ft && oe && typeof ft.stack == "string") {
          for (var de = ft.stack.split(`
`), Ne = oe.stack.split(`
`), Ae = de.length - 1, we = Ne.length - 1; Ae >= 1 && we >= 0 && de[Ae] !== Ne[we]; )
            we--;
          for (; Ae >= 1 && we >= 0; Ae--, we--)
            if (de[Ae] !== Ne[we]) {
              if (Ae !== 1 || we !== 1)
                do
                  if (Ae--, we--, we < 0 || de[Ae] !== Ne[we]) {
                    var Ue = `
` + de[Ae].replace(" at new ", " at ");
                    return y.displayName && Ue.includes("<anonymous>") && (Ue = Ue.replace("<anonymous>", y.displayName)), typeof y == "function" && He.set(y, Ue), Ue;
                  }
                while (Ae >= 1 && we >= 0);
              break;
            }
        }
      } finally {
        Ce = !1, Te.current = ge, ue(), Error.prepareStackTrace = he;
      }
      var on = y ? y.displayName || y.name : "", za = on ? De(on) : "";
      return typeof y == "function" && He.set(y, za), za;
    }
    function Sn(y, k, H) {
      return kt(y, !1);
    }
    function wt(y) {
      var k = y.prototype;
      return !!(k && k.isReactComponent);
    }
    function xt(y, k, H) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return kt(y, wt(y));
      if (typeof y == "string")
        return De(y);
      switch (y) {
        case l:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case c:
            return Sn(y.render);
          case d:
            return xt(y.type, k, H);
          case m: {
            var oe = y, he = oe._payload, ge = oe._init;
            try {
              return xt(ge(he), k, H);
            } catch {
            }
          }
        }
      return "";
    }
    var Et = Object.prototype.hasOwnProperty, dt = {}, _t = v.ReactDebugCurrentFrame;
    function et(y) {
      if (y) {
        var k = y._owner, H = xt(y.type, y._source, k ? k.type : null);
        _t.setExtraStackFrame(H);
      } else
        _t.setExtraStackFrame(null);
    }
    function Ct(y, k, H, oe, he) {
      {
        var ge = Function.call.bind(Et);
        for (var fe in y)
          if (ge(y, fe)) {
            var de = void 0;
            try {
              if (typeof y[fe] != "function") {
                var Ne = Error((oe || "React class") + ": " + H + " type `" + fe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[fe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ne.name = "Invariant Violation", Ne;
              }
              de = y[fe](k, fe, oe, H, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ae) {
              de = Ae;
            }
            de && !(de instanceof Error) && (et(he), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", oe || "React class", H, fe, typeof de), et(null)), de instanceof Error && !(de.message in dt) && (dt[de.message] = !0, et(he), b("Failed %s type: %s", H, de.message), et(null));
          }
      }
    }
    var en = Array.isArray;
    function Rn(y) {
      return en(y);
    }
    function Ma(y) {
      {
        var k = typeof Symbol == "function" && Symbol.toStringTag, H = k && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return H;
      }
    }
    function ut(y) {
      try {
        return Ke(y), !1;
      } catch {
        return !0;
      }
    }
    function Ke(y) {
      return "" + y;
    }
    function tt(y) {
      if (ut(y))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ma(y)), Ke(y);
    }
    var Be = v.ReactCurrentOwner, Pn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, tn, nn, To;
    To = {};
    function Eu(y) {
      if (Et.call(y, "ref")) {
        var k = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (k && k.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function Cu(y) {
      if (Et.call(y, "key")) {
        var k = Object.getOwnPropertyDescriptor(y, "key").get;
        if (k && k.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Iu(y, k) {
      if (typeof y.ref == "string" && Be.current && k && Be.current.stateNode !== k) {
        var H = X(Be.current.type);
        To[H] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(Be.current.type), y.ref), To[H] = !0);
      }
    }
    function Tu(y, k) {
      {
        var H = function() {
          tn || (tn = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", k));
        };
        H.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: H,
          configurable: !0
        });
      }
    }
    function Ou(y, k) {
      {
        var H = function() {
          nn || (nn = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", k));
        };
        H.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: H,
          configurable: !0
        });
      }
    }
    var Su = function(y, k, H, oe, he, ge, fe) {
      var de = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: y,
        key: k,
        ref: H,
        props: fe,
        // Record the component responsible for creating this element.
        _owner: ge
      };
      return de._store = {}, Object.defineProperty(de._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(de, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: oe
      }), Object.defineProperty(de, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.freeze && (Object.freeze(de.props), Object.freeze(de)), de;
    };
    function Ru(y, k, H, oe, he) {
      {
        var ge, fe = {}, de = null, Ne = null;
        H !== void 0 && (tt(H), de = "" + H), Cu(k) && (tt(k.key), de = "" + k.key), Eu(k) && (Ne = k.ref, Iu(k, he));
        for (ge in k)
          Et.call(k, ge) && !Pn.hasOwnProperty(ge) && (fe[ge] = k[ge]);
        if (y && y.defaultProps) {
          var Ae = y.defaultProps;
          for (ge in Ae)
            fe[ge] === void 0 && (fe[ge] = Ae[ge]);
        }
        if (de || Ne) {
          var we = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          de && Tu(fe, we), Ne && Ou(fe, we);
        }
        return Su(y, de, Ne, he, oe, Be.current, fe);
      }
    }
    var Oo = v.ReactCurrentOwner, Na = v.ReactDebugCurrentFrame;
    function rn(y) {
      if (y) {
        var k = y._owner, H = xt(y.type, y._source, k ? k.type : null);
        Na.setExtraStackFrame(H);
      } else
        Na.setExtraStackFrame(null);
    }
    var So;
    So = !1;
    function Ro(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }
    function Fa() {
      {
        if (Oo.current) {
          var y = X(Oo.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function Pu(y) {
      {
        if (y !== void 0) {
          var k = y.fileName.replace(/^.*[\\\/]/, ""), H = y.lineNumber;
          return `

Check your code at ` + k + ":" + H + ".";
        }
        return "";
      }
    }
    var $a = {};
    function Du(y) {
      {
        var k = Fa();
        if (!k) {
          var H = typeof y == "string" ? y : y.displayName || y.name;
          H && (k = `

Check the top-level render call using <` + H + ">.");
        }
        return k;
      }
    }
    function ka(y, k) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var H = Du(k);
        if ($a[H])
          return;
        $a[H] = !0;
        var oe = "";
        y && y._owner && y._owner !== Oo.current && (oe = " It was passed a child from " + X(y._owner.type) + "."), rn(y), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', H, oe), rn(null);
      }
    }
    function Ba(y, k) {
      {
        if (typeof y != "object")
          return;
        if (Rn(y))
          for (var H = 0; H < y.length; H++) {
            var oe = y[H];
            Ro(oe) && ka(oe, k);
          }
        else if (Ro(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var he = g(y);
          if (typeof he == "function" && he !== y.entries)
            for (var ge = he.call(y), fe; !(fe = ge.next()).done; )
              Ro(fe.value) && ka(fe.value, k);
        }
      }
    }
    function Mu(y) {
      {
        var k = y.type;
        if (k == null || typeof k == "string")
          return;
        var H;
        if (typeof k == "function")
          H = k.propTypes;
        else if (typeof k == "object" && (k.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        k.$$typeof === d))
          H = k.propTypes;
        else
          return;
        if (H) {
          var oe = X(k);
          Ct(H, y.props, "prop", oe, y);
        } else if (k.PropTypes !== void 0 && !So) {
          So = !0;
          var he = X(k);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", he || "Unknown");
        }
        typeof k.getDefaultProps == "function" && !k.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Nu(y) {
      {
        for (var k = Object.keys(y.props), H = 0; H < k.length; H++) {
          var oe = k[H];
          if (oe !== "children" && oe !== "key") {
            rn(y), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", oe), rn(null);
            break;
          }
        }
        y.ref !== null && (rn(y), b("Invalid attribute `ref` supplied to `React.Fragment`."), rn(null));
      }
    }
    function La(y, k, H, oe, he, ge) {
      {
        var fe = Q(y);
        if (!fe) {
          var de = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (de += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ne = Pu(he);
          Ne ? de += Ne : de += Fa();
          var Ae;
          y === null ? Ae = "null" : Rn(y) ? Ae = "array" : y !== void 0 && y.$$typeof === t ? (Ae = "<" + (X(y.type) || "Unknown") + " />", de = " Did you accidentally export a JSX literal instead of a component?") : Ae = typeof y, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ae, de);
        }
        var we = Ru(y, k, H, he, ge);
        if (we == null)
          return we;
        if (fe) {
          var Ue = k.children;
          if (Ue !== void 0)
            if (oe)
              if (Rn(Ue)) {
                for (var on = 0; on < Ue.length; on++)
                  Ba(Ue[on], y);
                Object.freeze && Object.freeze(Ue);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ba(Ue, y);
        }
        return y === r ? Nu(we) : Mu(we), we;
      }
    }
    function Fu(y, k, H) {
      return La(y, k, H, !0);
    }
    function $u(y, k, H) {
      return La(y, k, H, !1);
    }
    var ku = $u, Bu = Fu;
    Mn.Fragment = r, Mn.jsx = ku, Mn.jsxs = Bu;
  }()), Mn;
}
process.env.NODE_ENV === "production" ? ri.exports = Uu() : ri.exports = Wu();
var Wi = ri.exports;
const Qi = Wi.Fragment, x = Wi.jsx, J = Wi.jsxs;
function O() {
  return O = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, O.apply(this, arguments);
}
function ke(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = /* @__PURE__ */ $e(a), c = n.length;
    n = [
      ...n,
      a
    ];
    function l(d) {
      const { scope: m, children: p, ...h } = d, f = (m == null ? void 0 : m[e][c]) || s, g = xe(
        () => h,
        Object.values(h)
      );
      return /* @__PURE__ */ A(f.Provider, {
        value: g
      }, p);
    }
    function u(d, m) {
      const p = (m == null ? void 0 : m[e][c]) || s, h = Je(p);
      if (h)
        return h;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [
      l,
      u
    ];
  }
  const o = () => {
    const i = n.map((a) => /* @__PURE__ */ $e(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return xe(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    Qu(o, ...t)
  ];
}
function Qu(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const a = r.reduce((s, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return {
          ...s,
          ...d
        };
      }, {});
      return xe(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function ju(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ji(...e) {
  return (t) => e.forEach(
    (n) => ju(n, t)
  );
}
function ve(...e) {
  return W(ji(...e), e);
}
const Ut = /* @__PURE__ */ S((e, t) => {
  const { children: n, ...r } = e, o = be.toArray(n), i = o.find(Ku);
  if (i) {
    const a = i.props.children, s = o.map((c) => c === i ? be.count(a) > 1 ? be.only(null) : /* @__PURE__ */ Me(a) ? a.props.children : null : c);
    return /* @__PURE__ */ A(oi, O({}, r, {
      ref: t
    }), /* @__PURE__ */ Me(a) ? /* @__PURE__ */ at(a, void 0, s) : null);
  }
  return /* @__PURE__ */ A(oi, O({}, r, {
    ref: t
  }), n);
});
Ut.displayName = "Slot";
const oi = /* @__PURE__ */ S((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Me(n) ? /* @__PURE__ */ at(n, {
    ...Vu(r, n.props),
    ref: t ? ji(t, n.ref) : n.ref
  }) : be.count(n) > 1 ? be.only(null) : null;
});
oi.displayName = "SlotClone";
const xc = ({ children: e }) => /* @__PURE__ */ A(Ze, null, e);
function Ku(e) {
  return /* @__PURE__ */ Me(e) && e.type === xc;
}
function Vu(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function Ur(e) {
  const t = e + "CollectionProvider", [n, r] = ke(t), [o, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (p) => {
    const { scope: h, children: f } = p, g = $.useRef(null), v = $.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ $.createElement(o, {
      scope: h,
      itemMap: v,
      collectionRef: g
    }, f);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ $.forwardRef((p, h) => {
    const { scope: f, children: g } = p, v = i(s, f), b = ve(h, v.collectionRef);
    return /* @__PURE__ */ $.createElement(Ut, {
      ref: b
    }, g);
  }), l = e + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ $.forwardRef((p, h) => {
    const { scope: f, children: g, ...v } = p, b = $.useRef(null), w = ve(h, b), C = i(l, f);
    return $.useEffect(() => (C.itemMap.set(b, {
      ref: b,
      ...v
    }), () => void C.itemMap.delete(b))), /* @__PURE__ */ $.createElement(Ut, {
      [u]: "",
      ref: w
    }, g);
  });
  function m(p) {
    const h = i(e + "CollectionConsumer", p);
    return $.useCallback(() => {
      const g = h.collectionRef.current;
      if (!g)
        return [];
      const v = Array.from(g.querySelectorAll(`[${u}]`));
      return Array.from(h.itemMap.values()).sort(
        (C, T) => v.indexOf(C.ref.current) - v.indexOf(T.ref.current)
      );
    }, [
      h.collectionRef,
      h.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: c,
      ItemSlot: d
    },
    m,
    r
  ];
}
function _(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Se(e) {
  const t = N(e);
  return Y(() => {
    t.current = e;
  }), xe(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function Ye({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = Xu({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : r, s = Se(n), c = W((l) => {
    if (i) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && s(d);
    } else
      o(l);
  }, [
    i,
    e,
    o,
    s
  ]);
  return [
    a,
    c
  ];
}
function Xu({ defaultProp: e, onChange: t }) {
  const n = V(e), [r] = n, o = N(r), i = Se(t);
  return Y(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const qu = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ce = qu.reduce((e, t) => {
  const n = /* @__PURE__ */ S((r, o) => {
    const { asChild: i, ...a } = r, s = i ? Ut : t;
    return Y(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ A(s, O({}, a, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function Ki(e, t) {
  e && qn(
    () => e.dispatchEvent(t)
  );
}
const bt = globalThis != null && globalThis.document ? Yr : () => {
};
function Ju(e, t) {
  return yc((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const st = (e) => {
  const { present: t, children: n } = e, r = Zu(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : be.only(n), i = ve(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ at(o, {
    ref: i
  }) : null;
};
st.displayName = "Presence";
function Zu(e) {
  const [t, n] = V(), r = N({}), o = N(e), i = N("none"), a = e ? "mounted" : "unmounted", [s, c] = Ju(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Y(() => {
    const l = cr(r.current);
    i.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), bt(() => {
    const l = r.current, u = o.current;
    if (u !== e) {
      const m = i.current, p = cr(l);
      e ? c("MOUNT") : p === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), bt(() => {
    if (t) {
      const l = (d) => {
        const p = cr(r.current).includes(d.animationName);
        d.target === t && p && qn(
          () => c("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (i.current = cr(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: W((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function cr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const _u = q["useId".toString()] || (() => {
});
let ef = 0;
function Wt(e) {
  const [t, n] = q.useState(_u());
  return bt(() => {
    e || n(
      (r) => r ?? String(ef++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const Ec = "Collapsible", [tf, Cc] = ke(Ec), [nf, Vi] = tf(Ec), rf = /* @__PURE__ */ S((e, t) => {
  const { __scopeCollapsible: n, open: r, defaultOpen: o, disabled: i, onOpenChange: a, ...s } = e, [c = !1, l] = Ye({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ A(nf, {
    scope: n,
    disabled: i,
    contentId: Wt(),
    open: c,
    onOpenToggle: W(
      () => l(
        (u) => !u
      ),
      [
        l
      ]
    )
  }, /* @__PURE__ */ A(ce.div, O({
    "data-state": Xi(c),
    "data-disabled": i ? "" : void 0
  }, s, {
    ref: t
  })));
}), of = "CollapsibleTrigger", af = /* @__PURE__ */ S((e, t) => {
  const { __scopeCollapsible: n, ...r } = e, o = Vi(of, n);
  return /* @__PURE__ */ A(ce.button, O({
    type: "button",
    "aria-controls": o.contentId,
    "aria-expanded": o.open || !1,
    "data-state": Xi(o.open),
    "data-disabled": o.disabled ? "" : void 0,
    disabled: o.disabled
  }, r, {
    ref: t,
    onClick: _(e.onClick, o.onOpenToggle)
  }));
}), Ic = "CollapsibleContent", sf = /* @__PURE__ */ S((e, t) => {
  const { forceMount: n, ...r } = e, o = Vi(Ic, e.__scopeCollapsible);
  return /* @__PURE__ */ A(
    st,
    {
      present: n || o.open
    },
    ({ present: i }) => /* @__PURE__ */ A(cf, O({}, r, {
      ref: t,
      present: i
    }))
  );
}), cf = /* @__PURE__ */ S((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...i } = e, a = Vi(Ic, n), [s, c] = V(r), l = N(null), u = ve(t, l), d = N(0), m = d.current, p = N(0), h = p.current, f = a.open || s, g = N(f), v = N();
  return Y(() => {
    const b = requestAnimationFrame(
      () => g.current = !1
    );
    return () => cancelAnimationFrame(b);
  }, []), bt(() => {
    const b = l.current;
    if (b) {
      v.current = v.current || {
        transitionDuration: b.style.transitionDuration,
        animationName: b.style.animationName
      }, b.style.transitionDuration = "0s", b.style.animationName = "none";
      const w = b.getBoundingClientRect();
      d.current = w.height, p.current = w.width, g.current || (b.style.transitionDuration = v.current.transitionDuration, b.style.animationName = v.current.animationName), c(r);
    }
  }, [
    a.open,
    r
  ]), /* @__PURE__ */ A(ce.div, O({
    "data-state": Xi(a.open),
    "data-disabled": a.disabled ? "" : void 0,
    id: a.contentId,
    hidden: !f
  }, i, {
    ref: u,
    style: {
      ["--radix-collapsible-content-height"]: m ? `${m}px` : void 0,
      ["--radix-collapsible-content-width"]: h ? `${h}px` : void 0,
      ...e.style
    }
  }), f && o);
});
function Xi(e) {
  return e ? "open" : "closed";
}
const lf = rf, df = af, uf = sf, ff = /* @__PURE__ */ $e(void 0);
function Wr(e) {
  const t = Je(ff);
  return e || t || "ltr";
}
const $t = "Accordion", pf = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [qi, hf, mf] = Ur($t), [Qr, pC] = ke($t, [
  mf,
  Cc
]), Ji = Cc(), Tc = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { type: n, ...r } = e, o = r, i = r;
  return /* @__PURE__ */ $.createElement(qi.Provider, {
    scope: e.__scopeAccordion
  }, n === "multiple" ? /* @__PURE__ */ $.createElement(Af, O({}, i, {
    ref: t
  })) : /* @__PURE__ */ $.createElement(bf, O({}, o, {
    ref: t
  })));
});
Tc.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [Oc, gf] = Qr($t), [Sc, vf] = Qr($t, {
  collapsible: !1
}), bf = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, collapsible: i = !1, ...a } = e, [s, c] = Ye({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ $.createElement(Oc, {
    scope: e.__scopeAccordion,
    value: s ? [
      s
    ] : [],
    onItemOpen: c,
    onItemClose: $.useCallback(
      () => i && c(""),
      [
        i,
        c
      ]
    )
  }, /* @__PURE__ */ $.createElement(Sc, {
    scope: e.__scopeAccordion,
    collapsible: i
  }, /* @__PURE__ */ $.createElement(Rc, O({}, a, {
    ref: t
  }))));
}), Af = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...i } = e, [a = [], s] = Ye({
    prop: n,
    defaultProp: r,
    onChange: o
  }), c = $.useCallback(
    (u) => s(
      (d = []) => [
        ...d,
        u
      ]
    ),
    [
      s
    ]
  ), l = $.useCallback(
    (u) => s(
      (d = []) => d.filter(
        (m) => m !== u
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ $.createElement(Oc, {
    scope: e.__scopeAccordion,
    value: a,
    onItemOpen: c,
    onItemClose: l
  }, /* @__PURE__ */ $.createElement(Sc, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ $.createElement(Rc, O({}, i, {
    ref: t
  }))));
}), [yf, jr] = Qr($t), Rc = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeAccordion: n, disabled: r, dir: o, orientation: i = "vertical", ...a } = e, s = $.useRef(null), c = ve(s, t), l = hf(n), d = Wr(o) === "ltr", m = _(e.onKeyDown, (p) => {
    var h;
    if (!pf.includes(p.key))
      return;
    const f = p.target, g = l().filter((G) => {
      var Q;
      return !((Q = G.ref.current) !== null && Q !== void 0 && Q.disabled);
    }), v = g.findIndex(
      (G) => G.ref.current === f
    ), b = g.length;
    if (v === -1)
      return;
    p.preventDefault();
    let w = v;
    const C = 0, T = b - 1, P = () => {
      w = v + 1, w > T && (w = C);
    }, M = () => {
      w = v - 1, w < C && (w = T);
    };
    switch (p.key) {
      case "Home":
        w = C;
        break;
      case "End":
        w = T;
        break;
      case "ArrowRight":
        i === "horizontal" && (d ? P() : M());
        break;
      case "ArrowDown":
        i === "vertical" && P();
        break;
      case "ArrowLeft":
        i === "horizontal" && (d ? M() : P());
        break;
      case "ArrowUp":
        i === "vertical" && M();
        break;
    }
    const R = w % b;
    (h = g[R].ref.current) === null || h === void 0 || h.focus();
  });
  return /* @__PURE__ */ $.createElement(yf, {
    scope: n,
    disabled: r,
    direction: o,
    orientation: i
  }, /* @__PURE__ */ $.createElement(qi.Slot, {
    scope: n
  }, /* @__PURE__ */ $.createElement(ce.div, O({}, a, {
    "data-orientation": i,
    ref: c,
    onKeyDown: r ? void 0 : m
  }))));
}), ii = "AccordionItem", [wf, Zi] = Qr(ii), xf = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeAccordion: n, value: r, ...o } = e, i = jr(ii, n), a = gf(ii, n), s = Ji(n), c = Wt(), l = r && a.value.includes(r) || !1, u = i.disabled || e.disabled;
  return /* @__PURE__ */ $.createElement(wf, {
    scope: n,
    open: l,
    disabled: u,
    triggerId: c
  }, /* @__PURE__ */ $.createElement(lf, O({
    "data-orientation": i.orientation,
    "data-state": Pc(l)
  }, s, o, {
    ref: t,
    disabled: u,
    open: l,
    onOpenChange: (d) => {
      d ? a.onItemOpen(r) : a.onItemClose(r);
    }
  })));
}), Ef = "AccordionHeader", Cf = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, o = jr($t, n), i = Zi(Ef, n);
  return /* @__PURE__ */ $.createElement(ce.h3, O({
    "data-orientation": o.orientation,
    "data-state": Pc(i.open),
    "data-disabled": i.disabled ? "" : void 0
  }, r, {
    ref: t
  }));
}), Ha = "AccordionTrigger", If = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, o = jr($t, n), i = Zi(Ha, n), a = vf(Ha, n), s = Ji(n);
  return /* @__PURE__ */ $.createElement(qi.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ $.createElement(df, O({
    "aria-disabled": i.open && !a.collapsible || void 0,
    "data-orientation": o.orientation,
    id: i.triggerId
  }, s, r, {
    ref: t
  })));
}), Tf = "AccordionContent", Of = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, o = jr($t, n), i = Zi(Tf, n), a = Ji(n);
  return /* @__PURE__ */ $.createElement(uf, O({
    role: "region",
    "aria-labelledby": i.triggerId,
    "data-orientation": o.orientation
  }, a, r, {
    ref: t,
    style: {
      ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
      ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function Pc(e) {
  return e ? "open" : "closed";
}
const Sf = Tc, Rf = xf, Pf = Cf, Df = If, Mf = Of;
var Dc = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Ua = $.createContext && $.createContext(Dc), Dt = globalThis && globalThis.__assign || function() {
  return Dt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Dt.apply(this, arguments);
}, Nf = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Mc(e) {
  return e && e.map(function(t, n) {
    return $.createElement(t.tag, Dt({
      key: n
    }, t.attr), Mc(t.child));
  });
}
function Ie(e) {
  return function(t) {
    return $.createElement(Ff, Dt({
      attr: Dt({}, e.attr)
    }, t), Mc(e.child));
  };
}
function Ff(e) {
  var t = function(n) {
    var r = e.attr, o = e.size, i = e.title, a = Nf(e, ["attr", "size", "title"]), s = o || n.size || "1em", c;
    return n.className && (c = n.className), e.className && (c = (c ? c + " " : "") + e.className), $.createElement("svg", Dt({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, r, a, {
      className: c,
      style: Dt(Dt({
        color: e.color || n.color
      }, n.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), i && $.createElement("title", null, i), e.children);
  };
  return Ua !== void 0 ? $.createElement(Ua.Consumer, null, function(n) {
    return t(n);
  }) : t(Dc);
}
function $f(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" } }] })(e);
}
function kf(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" } }] })(e);
}
function Bf(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: { fillRule: "evenodd" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z" } }] }] })(e);
}
function Jn(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" } }] })(e);
}
function Nc(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" } }] })(e);
}
function Lf(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M10 17l5-5-5-5v10z" } }, { tag: "path", attr: { fill: "none", d: "M0 24V0h24v24H0z" } }] })(e);
}
function Fc(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" } }] })(e);
}
function _i(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" } }] })(e);
}
function zf(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" } }] })(e);
}
function Gf(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46a.5.5 0 00-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0014 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.566.566 0 00-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46a.5.5 0 00.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" } }] })(e);
}
function Yf(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" } }] })(e);
}
function Hf(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M21.9 21.9l-6.1-6.1-2.69-2.69L5 5 3.59 3.59 2.1 2.1.69 3.51 3 5.83V19c0 1.1.9 2 2 2h13.17l2.31 2.31 1.42-1.41zM5 19V7.83l6.84 6.84-.84 1.05L9 13l-3 4h8.17l2 2H5zM7.83 5l-2-2H19c1.1 0 2 .9 2 2v13.17l-2-2V5H7.83z" } }] })(e);
}
function Uf(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z", opacity: ".87" } }, { tag: "path", attr: { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z" } }] })(e);
}
const $c = I(Jn)`
  height: 1rem;
  width: 1rem;
  transition: transform 300ms;
`, Wf = I(Df)`
  &[data-state='open'] {
    & ${$c} {
      transform: rotate(180deg);
    }
  }
`, Qf = S(
  // eslint-disable-next-line no-restricted-syntax
  function({ ...t }, n) {
    return /* @__PURE__ */ x(Sf, { ref: n, ...t });
  }
), lr = S(function({ ...t }, n) {
  return /* @__PURE__ */ x(Rf, { ...t, ref: n });
}), jf = S(function({ children: t, noArrow: n = !1, ...r }, o) {
  return /* @__PURE__ */ x(Pf, { className: "AccordionHeader", children: /* @__PURE__ */ J(Wf, { ...r, ref: o, children: [
    t,
    !n && /* @__PURE__ */ x($c, { "aria-hidden": !0 })
  ] }) });
}), Kf = S(function({ ...t }, n) {
  return /* @__PURE__ */ x(Mf, { ...t, ref: n });
});
var Vf = Object.defineProperty, Wa = Object.getOwnPropertySymbols, Xf = Object.prototype.hasOwnProperty, qf = Object.prototype.propertyIsEnumerable, Qa = (e, t, n) => t in e ? Vf(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Po = (e, t) => {
  for (var n in t || (t = {}))
    Xf.call(t, n) && Qa(e, n, t[n]);
  if (Wa)
    for (var n of Wa(t))
      qf.call(t, n) && Qa(e, n, t[n]);
  return e;
}, ae = {
  black300: "#111213",
  blackTranslucent250: "rgba(0, 0, 0, 0.250)",
  blackTranslucent400: "rgba(0, 0, 0, 0.439)",
  blue50: "#b9d8ea",
  blue100: "#6dc5ea",
  blue200: "#3eb4e4",
  blue250: "#007bad",
  blue275: "#2F80ED",
  blue300: "#145091",
  blue400: "#00426b",
  blue500: "#2f80ed",
  blueTranslucent200: "rgba(62, 180, 228, 0.15)",
  gray100: "#d2dce7",
  gray200: "#c4c4c4",
  gray250: "#8a9099",
  gray300: "#6f7780",
  gray350: "#3f434a",
  gray400: "#414042",
  gray500: "#25282d",
  green150: "#8ec64d",
  green200: "#49c96d",
  green300: "#20a144",
  green400: "#0a8852",
  greenTranslucent200: "rgba(73, 201, 109, 0.15)",
  lightGray50: "#f8f8f8",
  lightGray100: "#ededed",
  lightGray200: "#d9d9d9",
  lightGray300: "#c6c9cc",
  orange400: "#df5a29",
  orange500: "#c44829",
  orange600: "#833421",
  orangeTranslucent400: "rgba(223, 90, 41, 0.15)",
  red200: "#e14d4e",
  red300: "#f00",
  white300: "#fff",
  whiteTranslucent100: "rgba(255, 255, 255, 0.100)",
  yellow200: "#ffdb56"
}, kc = {
  backgroundHoverLight: ae.whiteTranslucent100,
  backgroundHover: "#25282d0a",
  background: "#f5f7fa",
  backgroundDarker: ae.lightGray50,
  messageBackgroundMe: "#e8ebfa",
  messageBackgroundClient: "#f5f5f5",
  messageBackgroundAdmin: "#d8d8f0"
}, Jf = {
  authPagesBackground: kc.background,
  authPagesFieldBorder: "#4aaff9",
  authPagesLink: "#304ffd",
  button: ae.blue400,
  buttonShadow: ae.blackTranslucent400,
  divider: "rgba(0, 0, 0, 0.1)",
  dropzoneBackground: ae.lightGray50,
  dropzoneBorder: ae.lightGray300,
  dropzoneBorderError: ae.red300,
  dropzoneBorderFocus: ae.blue250,
  dropzoneBorderSuccess: ae.green200,
  dropzoneText: ae.gray350,
  headerText: ae.gray350,
  fieldFocus: ae.blue250,
  inputBorder: ae.gray400,
  inputBorderLight: ae.gray200,
  inputPlaceholder: ae.gray200,
  labelText: ae.gray300,
  sidebarBackground: ae.white300,
  sidebarBackgroundActive: ae.lightGray50,
  sidebarText: ae.gray350,
  sidebarTextLight: ae.gray250,
  statusError: ae.orangeTranslucent400,
  statusTextError: ae.orange500,
  statusInfo: ae.blueTranslucent200,
  statusTextInfo: ae.blue300,
  statusSuccess: ae.greenTranslucent200,
  statusTextSuccess: ae.green300,
  statusWarning: ae.blueTranslucent200,
  statusTextWarning: ae.orange500,
  text: ae.gray350,
  textLight: ae.gray250,
  toastError: ae.orange500,
  toastTextError: ae.white300,
  toastInfo: ae.blue400,
  toastTextInfo: ae.blue400,
  toastSuccess: ae.green400,
  toastTextSuccess: ae.white300,
  toastWarning: ae.orange500,
  toastTextWarning: ae.orange500,
  scrollbar: "#6665",
  scrollbarHover: "#9998",
  statusTextComplete: "#13dc28",
  statusTextInProgress: "#DC7413",
  statusTextLow: "#13dc28",
  statusTextMedium: "#F9C400",
  statusTextHigh: "#DC1313"
}, E = Po(Po(Po({}, ae), kc), Jf), Zf = j`
  position: relative;

  &::after {
    content: '';
    background-color: currentColor;
    bottom: 0;
    height: 1px;
    left: 0;
    position: absolute;
    transform-origin: bottom right;
    transform: scaleX(0);
    transition: transform 0.25s ease-out;
    width: 100%;
  }

  &:hover::after {
    transform-origin: bottom left;
    transform: scaleX(1);
  }
`, ea = {
  default: "Montserrat, Roboto, sans-serif",
  admin: "Poppins, Montserrat, sans-serif"
}, le = {
  px: "3px",
  xs: "4px",
  sm: "6px",
  md: "8px",
  lg: "14px",
  xl: "20px",
  full: "99999px"
}, bn = j`
  &::-webkit-scrollbar {
    height: 12px;
    width: 12px;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: ${E.scrollbar};
    border: 2px solid transparent;
    border-radius: ${le.lg};
    min-height: 45px;
    &:hover {
      background-color: ${E.scrollbarHover};
    }
  }
  &:not(:hover) {
    &::-webkit-scrollbar {
      visibility: hidden;
    }
  }
`, Zn = {
  modal: "0 0 8px -2px rgba(0, 0, 0, 0.1), 0 6px 20px -3px rgba(0, 0, 0, 0.2)"
};
Gu`

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    @media (max-width: 1080px) {
      font-size: 93.75%;
    }

    @media (max-width: 720px) {
      font-size: 87.5%;
    }
  }

  body {
    -webkit-font-smoothing: antialiased;
    background-color: ${E.white300};
  }

  body,
  input,
  textarea,
  button {
    color: ${E.text};
    font-family: 'Montserrat', 'Roboto', sans-serif;
    font-weight: 400;
  }

  button {
    cursor: pointer;
  }

  html, body, #root {
    height: 100%;
  }

  [disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
function Bc(e) {
  const t = N({
    value: e,
    previous: e
  });
  return xe(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
function ta(e) {
  const [t, n] = V(void 0);
  return bt(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          a = l.inlineSize, s = l.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({
          width: a,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Lc = "Checkbox", [_f, hC] = ke(Lc), [ep, tp] = _f(Lc), np = /* @__PURE__ */ S((e, t) => {
  const { __scopeCheckbox: n, name: r, checked: o, defaultChecked: i, required: a, disabled: s, value: c = "on", onCheckedChange: l, ...u } = e, [d, m] = V(null), p = ve(
    t,
    (w) => m(w)
  ), h = N(!1), f = d ? !!d.closest("form") : !0, [g = !1, v] = Ye({
    prop: o,
    defaultProp: i,
    onChange: l
  }), b = N(g);
  return Y(() => {
    const w = d == null ? void 0 : d.form;
    if (w) {
      const C = () => v(b.current);
      return w.addEventListener("reset", C), () => w.removeEventListener("reset", C);
    }
  }, [
    d,
    v
  ]), /* @__PURE__ */ A(ep, {
    scope: n,
    state: g,
    disabled: s
  }, /* @__PURE__ */ A(ce.button, O({
    type: "button",
    role: "checkbox",
    "aria-checked": Ht(g) ? "mixed" : g,
    "aria-required": a,
    "data-state": zc(g),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: c
  }, u, {
    ref: p,
    onKeyDown: _(e.onKeyDown, (w) => {
      w.key === "Enter" && w.preventDefault();
    }),
    onClick: _(e.onClick, (w) => {
      v(
        (C) => Ht(C) ? !0 : !C
      ), f && (h.current = w.isPropagationStopped(), h.current || w.stopPropagation());
    })
  })), f && /* @__PURE__ */ A(ip, {
    control: d,
    bubbles: !h.current,
    name: r,
    value: c,
    checked: g,
    required: a,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), rp = "CheckboxIndicator", op = /* @__PURE__ */ S((e, t) => {
  const { __scopeCheckbox: n, forceMount: r, ...o } = e, i = tp(rp, n);
  return /* @__PURE__ */ A(st, {
    present: r || Ht(i.state) || i.state === !0
  }, /* @__PURE__ */ A(ce.span, O({
    "data-state": zc(i.state),
    "data-disabled": i.disabled ? "" : void 0
  }, o, {
    ref: t,
    style: {
      pointerEvents: "none",
      ...e.style
    }
  })));
}), ip = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, i = N(null), a = Bc(n), s = ta(t);
  return Y(() => {
    const c = i.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== n && d) {
      const m = new Event("click", {
        bubbles: r
      });
      c.indeterminate = Ht(n), d.call(c, Ht(n) ? !1 : n), c.dispatchEvent(m);
    }
  }, [
    a,
    n,
    r
  ]), /* @__PURE__ */ A("input", O({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: Ht(n) ? !1 : n
  }, o, {
    tabIndex: -1,
    ref: i,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Ht(e) {
  return e === "indeterminate";
}
function zc(e) {
  return Ht(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const ap = np, sp = op, cp = I(ap)`
  align-items: center;
  background-color: ${E.white300};
  border-radius: ${le.px};
  border: 1px solid currentColor;
  display: flex;
  font-size: 1rem;
  height: 1.25rem;
  justify-content: center;
  width: 1.25rem;

  &[data-state='checked'] {
    background-color: currentColor;
  }

  &[data-disabled] {
    background-color: ${E.backgroundHover};
  }

  &:hover {
    filter: brightness(0.9);
  }
`, lp = I(sp)`
  align-items: center;
  color: ${E.white300};
  display: flex;
  justify-content: center;
`, dp = I(Fc)`
  height: 100%;
  width: 100%;
`, mC = ({
  dataCy: e = "checkbox-field",
  ...t
}) => /* @__PURE__ */ x(cp, { ...t, "data-cy": e, children: /* @__PURE__ */ x(lp, { children: /* @__PURE__ */ x(dp, {}) }) });
function up(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Se(e);
  Y(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const ai = "dismissableLayer.update", fp = "dismissableLayer.pointerDownOutside", pp = "dismissableLayer.focusOutside";
let ja;
const Gc = /* @__PURE__ */ $e({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Kr = /* @__PURE__ */ S((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...l } = e, u = Je(Gc), [d, m] = V(null), p = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, h] = V({}), f = ve(
    t,
    (R) => m(R)
  ), g = Array.from(u.layers), [v] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), b = g.indexOf(v), w = d ? g.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, T = w >= b, P = mp((R) => {
    const G = R.target, Q = [
      ...u.branches
    ].some(
      (U) => U.contains(G)
    );
    !T || Q || (i == null || i(R), s == null || s(R), R.defaultPrevented || c == null || c());
  }, p), M = gp((R) => {
    const G = R.target;
    [
      ...u.branches
    ].some(
      (U) => U.contains(G)
    ) || (a == null || a(R), s == null || s(R), R.defaultPrevented || c == null || c());
  }, p);
  return up((R) => {
    w === u.layers.size - 1 && (o == null || o(R), !R.defaultPrevented && c && (R.preventDefault(), c()));
  }, p), Y(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (ja = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), Ka(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = ja);
      };
  }, [
    d,
    p,
    r,
    u
  ]), Y(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), Ka());
  }, [
    d,
    u
  ]), Y(() => {
    const R = () => h({});
    return document.addEventListener(ai, R), () => document.removeEventListener(ai, R);
  }, []), /* @__PURE__ */ A(ce.div, O({}, l, {
    ref: f,
    style: {
      pointerEvents: C ? T ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: _(e.onFocusCapture, M.onFocusCapture),
    onBlurCapture: _(e.onBlurCapture, M.onBlurCapture),
    onPointerDownCapture: _(e.onPointerDownCapture, P.onPointerDownCapture)
  }));
}), hp = /* @__PURE__ */ S((e, t) => {
  const n = Je(Gc), r = N(null), o = ve(t, r);
  return Y(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [
    n.branches
  ]), /* @__PURE__ */ A(ce.div, O({}, e, {
    ref: o
  }));
});
function mp(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Se(e), r = N(!1), o = N(() => {
  });
  return Y(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Yc(fp, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, {
          once: !0
        })) : l();
      }
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function gp(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Se(e), r = N(!1);
  return Y(() => {
    const o = (i) => {
      i.target && !r.current && Yc(pp, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Ka() {
  const e = new CustomEvent(ai);
  document.dispatchEvent(e);
}
function Yc(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? Ki(o, i) : o.dispatchEvent(i);
}
const vp = Kr, bp = hp;
let Do = 0;
function Ap() {
  Y(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Va()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Va()), Do++, () => {
      Do === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Do--;
    };
  }, []);
}
function Va() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Mo = "focusScope.autoFocusOnMount", No = "focusScope.autoFocusOnUnmount", Xa = {
  bubbles: !1,
  cancelable: !0
}, yp = /* @__PURE__ */ S((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...a } = e, [s, c] = V(null), l = Se(o), u = Se(i), d = N(null), m = ve(
    t,
    (f) => c(f)
  ), p = N({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Y(() => {
    if (r) {
      let f = function(w) {
        if (p.paused || !s)
          return;
        const C = w.target;
        s.contains(C) ? d.current = C : St(d.current, {
          select: !0
        });
      }, g = function(w) {
        if (p.paused || !s)
          return;
        const C = w.relatedTarget;
        C !== null && (s.contains(C) || St(d.current, {
          select: !0
        }));
      }, v = function(w) {
        const C = document.activeElement;
        for (const T of w)
          T.removedNodes.length > 0 && (s != null && s.contains(C) || St(s));
      };
      document.addEventListener("focusin", f), document.addEventListener("focusout", g);
      const b = new MutationObserver(v);
      return s && b.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", g), b.disconnect();
      };
    }
  }, [
    r,
    s,
    p.paused
  ]), Y(() => {
    if (s) {
      Ja.add(p);
      const f = document.activeElement;
      if (!s.contains(f)) {
        const v = new CustomEvent(Mo, Xa);
        s.addEventListener(Mo, l), s.dispatchEvent(v), v.defaultPrevented || (wp(Tp(Hc(s)), {
          select: !0
        }), document.activeElement === f && St(s));
      }
      return () => {
        s.removeEventListener(Mo, l), setTimeout(() => {
          const v = new CustomEvent(No, Xa);
          s.addEventListener(No, u), s.dispatchEvent(v), v.defaultPrevented || St(f ?? document.body, {
            select: !0
          }), s.removeEventListener(No, u), Ja.remove(p);
        }, 0);
      };
    }
  }, [
    s,
    l,
    u,
    p
  ]);
  const h = W((f) => {
    if (!n && !r || p.paused)
      return;
    const g = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, v = document.activeElement;
    if (g && v) {
      const b = f.currentTarget, [w, C] = xp(b);
      w && C ? !f.shiftKey && v === C ? (f.preventDefault(), n && St(w, {
        select: !0
      })) : f.shiftKey && v === w && (f.preventDefault(), n && St(C, {
        select: !0
      })) : v === b && f.preventDefault();
    }
  }, [
    n,
    r,
    p.paused
  ]);
  return /* @__PURE__ */ A(ce.div, O({
    tabIndex: -1
  }, a, {
    ref: m,
    onKeyDown: h
  }));
});
function wp(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (St(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function xp(e) {
  const t = Hc(e), n = qa(t, e), r = qa(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Hc(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function qa(e, t) {
  for (const n of e)
    if (!Ep(n, {
      upTo: t
    }))
      return n;
}
function Ep(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Cp(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function St(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Cp(e) && t && e.select();
  }
}
const Ja = Ip();
function Ip() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Za(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Za(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Za(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Tp(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
function An(e) {
  return e.split("-")[1];
}
function na(e) {
  return e === "y" ? "height" : "width";
}
function ht(e) {
  return e.split("-")[0];
}
function qt(e) {
  return ["top", "bottom"].includes(ht(e)) ? "x" : "y";
}
function _a(e, t, n) {
  let { reference: r, floating: o } = e;
  const i = r.x + r.width / 2 - o.width / 2, a = r.y + r.height / 2 - o.height / 2, s = qt(t), c = na(s), l = r[c] / 2 - o[c] / 2, u = s === "x";
  let d;
  switch (ht(t)) {
    case "top":
      d = { x: i, y: r.y - o.height };
      break;
    case "bottom":
      d = { x: i, y: r.y + r.height };
      break;
    case "right":
      d = { x: r.x + r.width, y: a };
      break;
    case "left":
      d = { x: r.x - o.width, y: a };
      break;
    default:
      d = { x: r.x, y: r.y };
  }
  switch (An(t)) {
    case "start":
      d[s] -= l * (n && u ? -1 : 1);
      break;
    case "end":
      d[s] += l * (n && u ? -1 : 1);
  }
  return d;
}
const Op = async (e, t, n) => {
  const { placement: r = "bottom", strategy: o = "absolute", middleware: i = [], platform: a } = n, s = i.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let l = await a.getElementRects({ reference: e, floating: t, strategy: o }), { x: u, y: d } = _a(l, r, c), m = r, p = {}, h = 0;
  for (let f = 0; f < s.length; f++) {
    const { name: g, fn: v } = s[f], { x: b, y: w, data: C, reset: T } = await v({ x: u, y: d, initialPlacement: r, placement: m, strategy: o, middlewareData: p, rects: l, platform: a, elements: { reference: e, floating: t } });
    u = b ?? u, d = w ?? d, p = { ...p, [g]: { ...p[g], ...C } }, T && h <= 50 && (h++, typeof T == "object" && (T.placement && (m = T.placement), T.rects && (l = T.rects === !0 ? await a.getElementRects({ reference: e, floating: t, strategy: o }) : T.rects), { x: u, y: d } = _a(l, m, c)), f = -1);
  }
  return { x: u, y: d, placement: m, strategy: o, middlewareData: p };
};
function At(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Uc(e) {
  return typeof e != "number" ? function(t) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function Pr(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
async function zn(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: r, y: o, platform: i, rects: a, elements: s, strategy: c } = e, { boundary: l = "clippingAncestors", rootBoundary: u = "viewport", elementContext: d = "floating", altBoundary: m = !1, padding: p = 0 } = At(t, e), h = Uc(p), f = s[m ? d === "floating" ? "reference" : "floating" : d], g = Pr(await i.getClippingRect({ element: (n = await (i.isElement == null ? void 0 : i.isElement(f))) == null || n ? f : f.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)), boundary: l, rootBoundary: u, strategy: c })), v = d === "floating" ? { ...a.floating, x: r, y: o } : a.reference, b = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), w = await (i.isElement == null ? void 0 : i.isElement(b)) && await (i.getScale == null ? void 0 : i.getScale(b)) || { x: 1, y: 1 }, C = Pr(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: v, offsetParent: b, strategy: c }) : v);
  return { top: (g.top - C.top + h.top) / w.y, bottom: (C.bottom - g.bottom + h.bottom) / w.y, left: (g.left - C.left + h.left) / w.x, right: (C.right - g.right + h.right) / w.x };
}
const Gn = Math.min, Bt = Math.max;
function si(e, t, n) {
  return Bt(e, Gn(t, n));
}
const es = (e) => ({ name: "arrow", options: e, async fn(t) {
  const { x: n, y: r, placement: o, rects: i, platform: a, elements: s } = t, { element: c, padding: l = 0 } = At(e, t) || {};
  if (c == null)
    return {};
  const u = Uc(l), d = { x: n, y: r }, m = qt(o), p = na(m), h = await a.getDimensions(c), f = m === "y", g = f ? "top" : "left", v = f ? "bottom" : "right", b = f ? "clientHeight" : "clientWidth", w = i.reference[p] + i.reference[m] - d[m] - i.floating[p], C = d[m] - i.reference[m], T = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
  let P = T ? T[b] : 0;
  P && await (a.isElement == null ? void 0 : a.isElement(T)) || (P = s.floating[b] || i.floating[p]);
  const M = w / 2 - C / 2, R = P / 2 - h[p] / 2 - 1, G = Gn(u[g], R), Q = Gn(u[v], R), U = G, te = P - h[p] - Q, X = P / 2 - h[p] / 2 + M, F = si(U, X, te), L = An(o) != null && X != F && i.reference[p] / 2 - (X < U ? G : Q) - h[p] / 2 < 0 ? X < U ? U - X : te - X : 0;
  return { [m]: d[m] - L, data: { [m]: F, centerOffset: X - F + L } };
} }), Wc = ["top", "right", "bottom", "left"];
Wc.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
const Sp = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Dr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Sp[t]);
}
function Rp(e, t, n) {
  n === void 0 && (n = !1);
  const r = An(e), o = qt(e), i = na(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Dr(a)), { main: a, cross: Dr(a) };
}
const Pp = { start: "end", end: "start" };
function Fo(e) {
  return e.replace(/start|end/g, (t) => Pp[t]);
}
const Dp = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(t) {
    var n;
    const { placement: r, middlewareData: o, rects: i, initialPlacement: a, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: m = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: h = !0, ...f } = At(e, t), g = ht(r), v = ht(a) === a, b = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), w = d || (v || !h ? [Dr(a)] : function(U) {
      const te = Dr(U);
      return [Fo(U), te, Fo(te)];
    }(a));
    d || p === "none" || w.push(...function(U, te, X, F) {
      const L = An(U);
      let z = function(Z, ne, K) {
        const B = ["left", "right"], ee = ["right", "left"], se = ["top", "bottom"], re = ["bottom", "top"];
        switch (Z) {
          case "top":
          case "bottom":
            return K ? ne ? ee : B : ne ? B : ee;
          case "left":
          case "right":
            return ne ? se : re;
          default:
            return [];
        }
      }(ht(U), X === "start", F);
      return L && (z = z.map((Z) => Z + "-" + L), te && (z = z.concat(z.map(Fo)))), z;
    }(a, h, p, b));
    const C = [a, ...w], T = await zn(t, f), P = [];
    let M = ((n = o.flip) == null ? void 0 : n.overflows) || [];
    if (l && P.push(T[g]), u) {
      const { main: U, cross: te } = Rp(r, i, b);
      P.push(T[U], T[te]);
    }
    if (M = [...M, { placement: r, overflows: P }], !P.every((U) => U <= 0)) {
      var R, G;
      const U = (((R = o.flip) == null ? void 0 : R.index) || 0) + 1, te = C[U];
      if (te)
        return { data: { index: U, overflows: M }, reset: { placement: te } };
      let X = (G = M.filter((F) => F.overflows[0] <= 0).sort((F, L) => F.overflows[1] - L.overflows[1])[0]) == null ? void 0 : G.placement;
      if (!X)
        switch (m) {
          case "bestFit": {
            var Q;
            const F = (Q = M.map((L) => [L.placement, L.overflows.filter((z) => z > 0).reduce((z, Z) => z + Z, 0)]).sort((L, z) => L[1] - z[1])[0]) == null ? void 0 : Q[0];
            F && (X = F);
            break;
          }
          case "initialPlacement":
            X = a;
        }
      if (r !== X)
        return { reset: { placement: X } };
    }
    return {};
  } };
};
function ts(e, t) {
  return { top: e.top - t.height, right: e.right - t.width, bottom: e.bottom - t.height, left: e.left - t.width };
}
function ns(e) {
  return Wc.some((t) => e[t] >= 0);
}
const Mp = function(e) {
  return e === void 0 && (e = {}), { name: "hide", options: e, async fn(t) {
    const { rects: n } = t, { strategy: r = "referenceHidden", ...o } = At(e, t);
    switch (r) {
      case "referenceHidden": {
        const i = ts(await zn(t, { ...o, elementContext: "reference" }), n.reference);
        return { data: { referenceHiddenOffsets: i, referenceHidden: ns(i) } };
      }
      case "escaped": {
        const i = ts(await zn(t, { ...o, altBoundary: !0 }), n.floating);
        return { data: { escapedOffsets: i, escaped: ns(i) } };
      }
      default:
        return {};
    }
  } };
}, Np = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(t) {
    const { x: n, y: r } = t, o = await async function(i, a) {
      const { placement: s, platform: c, elements: l } = i, u = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), d = ht(s), m = An(s), p = qt(s) === "x", h = ["left", "top"].includes(d) ? -1 : 1, f = u && p ? -1 : 1, g = At(a, i);
      let { mainAxis: v, crossAxis: b, alignmentAxis: w } = typeof g == "number" ? { mainAxis: g, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...g };
      return m && typeof w == "number" && (b = m === "end" ? -1 * w : w), p ? { x: b * f, y: v * h } : { x: v * h, y: b * f };
    }(t, e);
    return { x: n + o.x, y: r + o.y, data: o };
  } };
};
function Qc(e) {
  return e === "x" ? "y" : "x";
}
const Fp = function(e) {
  return e === void 0 && (e = {}), { name: "shift", options: e, async fn(t) {
    const { x: n, y: r, placement: o } = t, { mainAxis: i = !0, crossAxis: a = !1, limiter: s = { fn: (g) => {
      let { x: v, y: b } = g;
      return { x: v, y: b };
    } }, ...c } = At(e, t), l = { x: n, y: r }, u = await zn(t, c), d = qt(ht(o)), m = Qc(d);
    let p = l[d], h = l[m];
    if (i) {
      const g = d === "y" ? "bottom" : "right";
      p = si(p + u[d === "y" ? "top" : "left"], p, p - u[g]);
    }
    if (a) {
      const g = m === "y" ? "bottom" : "right";
      h = si(h + u[m === "y" ? "top" : "left"], h, h - u[g]);
    }
    const f = s.fn({ ...t, [d]: p, [m]: h });
    return { ...f, data: { x: f.x - n, y: f.y - r } };
  } };
}, $p = function(e) {
  return e === void 0 && (e = {}), { options: e, fn(t) {
    const { x: n, y: r, placement: o, rects: i, middlewareData: a } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = At(e, t), u = { x: n, y: r }, d = qt(o), m = Qc(d);
    let p = u[d], h = u[m];
    const f = At(s, t), g = typeof f == "number" ? { mainAxis: f, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...f };
    if (c) {
      const w = d === "y" ? "height" : "width", C = i.reference[d] - i.floating[w] + g.mainAxis, T = i.reference[d] + i.reference[w] - g.mainAxis;
      p < C ? p = C : p > T && (p = T);
    }
    if (l) {
      var v, b;
      const w = d === "y" ? "width" : "height", C = ["top", "left"].includes(ht(o)), T = i.reference[m] - i.floating[w] + (C && ((v = a.offset) == null ? void 0 : v[m]) || 0) + (C ? 0 : g.crossAxis), P = i.reference[m] + i.reference[w] + (C ? 0 : ((b = a.offset) == null ? void 0 : b[m]) || 0) - (C ? g.crossAxis : 0);
      h < T ? h = T : h > P && (h = P);
    }
    return { [d]: p, [m]: h };
  } };
}, kp = function(e) {
  return e === void 0 && (e = {}), { name: "size", options: e, async fn(t) {
    const { placement: n, rects: r, platform: o, elements: i } = t, { apply: a = () => {
    }, ...s } = At(e, t), c = await zn(t, s), l = ht(n), u = An(n), d = qt(n) === "x", { width: m, height: p } = r.floating;
    let h, f;
    l === "top" || l === "bottom" ? (h = l, f = u === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (f = l, h = u === "end" ? "top" : "bottom");
    const g = p - c[h], v = m - c[f], b = !t.middlewareData.shift;
    let w = g, C = v;
    if (d) {
      const P = m - c.left - c.right;
      C = u || b ? Gn(v, P) : P;
    } else {
      const P = p - c.top - c.bottom;
      w = u || b ? Gn(g, P) : P;
    }
    if (b && !u) {
      const P = Bt(c.left, 0), M = Bt(c.right, 0), R = Bt(c.top, 0), G = Bt(c.bottom, 0);
      d ? C = m - 2 * (P !== 0 || M !== 0 ? P + M : Bt(c.left, c.right)) : w = p - 2 * (R !== 0 || G !== 0 ? R + G : Bt(c.top, c.bottom));
    }
    await a({ ...t, availableWidth: C, availableHeight: w });
    const T = await o.getDimensions(i.floating);
    return m !== T.width || p !== T.height ? { reset: { rects: !0 } } : {};
  } };
};
function We(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ve(e) {
  return We(e).getComputedStyle(e);
}
function jc(e) {
  return e instanceof We(e).Node;
}
function Ft(e) {
  return jc(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Xe(e) {
  return e instanceof We(e).HTMLElement;
}
function mt(e) {
  return e instanceof We(e).Element;
}
function rs(e) {
  return typeof ShadowRoot < "u" && (e instanceof We(e).ShadowRoot || e instanceof ShadowRoot);
}
function Yn(e) {
  const { overflow: t, overflowX: n, overflowY: r, display: o } = Ve(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Bp(e) {
  return ["table", "td", "th"].includes(Ft(e));
}
function ci(e) {
  const t = ra(), n = Ve(e);
  return n.transform !== "none" || n.perspective !== "none" || !t && !!n.backdropFilter && n.backdropFilter !== "none" || !t && !!n.filter && n.filter !== "none" || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function ra() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function Vr(e) {
  return ["html", "body", "#document"].includes(Ft(e));
}
const os = Math.min, Bn = Math.max, Mr = Math.round, dr = Math.floor, Qt = (e) => ({ x: e, y: e });
function Kc(e) {
  const t = Ve(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Xe(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = Mr(n) !== i || Mr(r) !== a;
  return s && (n = i, r = a), { width: n, height: r, $: s };
}
function oa(e) {
  return mt(e) ? e : e.contextElement;
}
function un(e) {
  const t = oa(e);
  if (!Xe(t))
    return Qt(1);
  const n = t.getBoundingClientRect(), { width: r, height: o, $: i } = Kc(t);
  let a = (i ? Mr(n.width) : n.width) / r, s = (i ? Mr(n.height) : n.height) / o;
  return a && Number.isFinite(a) || (a = 1), s && Number.isFinite(s) || (s = 1), { x: a, y: s };
}
const is = Qt(0);
function Vc(e, t, n) {
  var r, o;
  if (t === void 0 && (t = !0), !ra())
    return is;
  const i = e ? We(e) : window;
  return !n || t && n !== i ? is : { x: ((r = i.visualViewport) == null ? void 0 : r.offsetLeft) || 0, y: ((o = i.visualViewport) == null ? void 0 : o.offsetTop) || 0 };
}
function jt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = oa(e);
  let a = Qt(1);
  t && (r ? mt(r) && (a = un(r)) : a = un(e));
  const s = Vc(i, n, r);
  let c = (o.left + s.x) / a.x, l = (o.top + s.y) / a.y, u = o.width / a.x, d = o.height / a.y;
  if (i) {
    const m = We(i), p = r && mt(r) ? We(r) : r;
    let h = m.frameElement;
    for (; h && r && p !== m; ) {
      const f = un(h), g = h.getBoundingClientRect(), v = getComputedStyle(h), b = g.left + (h.clientLeft + parseFloat(v.paddingLeft)) * f.x, w = g.top + (h.clientTop + parseFloat(v.paddingTop)) * f.y;
      c *= f.x, l *= f.y, u *= f.x, d *= f.y, c += b, l += w, h = We(h).frameElement;
    }
  }
  return Pr({ width: u, height: d, x: c, y: l });
}
function gt(e) {
  return ((jc(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Xr(e) {
  return mt(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function Xc(e) {
  return jt(gt(e)).left + Xr(e).scrollLeft;
}
function hn(e) {
  if (Ft(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || rs(e) && e.host || gt(e);
  return rs(t) ? t.host : t;
}
function qc(e) {
  const t = hn(e);
  return Vr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Xe(t) && Yn(t) ? t : qc(t);
}
function Nr(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = qc(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = We(r);
  return o ? t.concat(i, i.visualViewport || [], Yn(r) ? r : []) : t.concat(r, Nr(r));
}
function as(e, t, n) {
  let r;
  if (t === "viewport")
    r = function(o, i) {
      const a = We(o), s = gt(o), c = a.visualViewport;
      let l = s.clientWidth, u = s.clientHeight, d = 0, m = 0;
      if (c) {
        l = c.width, u = c.height;
        const p = ra();
        (!p || p && i === "fixed") && (d = c.offsetLeft, m = c.offsetTop);
      }
      return { width: l, height: u, x: d, y: m };
    }(e, n);
  else if (t === "document")
    r = function(o) {
      const i = gt(o), a = Xr(o), s = o.ownerDocument.body, c = Bn(i.scrollWidth, i.clientWidth, s.scrollWidth, s.clientWidth), l = Bn(i.scrollHeight, i.clientHeight, s.scrollHeight, s.clientHeight);
      let u = -a.scrollLeft + Xc(o);
      const d = -a.scrollTop;
      return Ve(s).direction === "rtl" && (u += Bn(i.clientWidth, s.clientWidth) - c), { width: c, height: l, x: u, y: d };
    }(gt(e));
  else if (mt(t))
    r = function(o, i) {
      const a = jt(o, !0, i === "fixed"), s = a.top + o.clientTop, c = a.left + o.clientLeft, l = Xe(o) ? un(o) : Qt(1);
      return { width: o.clientWidth * l.x, height: o.clientHeight * l.y, x: c * l.x, y: s * l.y };
    }(t, n);
  else {
    const o = Vc(e);
    r = { ...t, x: t.x - o.x, y: t.y - o.y };
  }
  return Pr(r);
}
function Jc(e, t) {
  const n = hn(e);
  return !(n === t || !mt(n) || Vr(n)) && (Ve(n).position === "fixed" || Jc(n, t));
}
function ss(e, t) {
  return Xe(e) && Ve(e).position !== "fixed" ? t ? t(e) : e.offsetParent : null;
}
function cs(e, t) {
  const n = We(e);
  if (!Xe(e))
    return n;
  let r = ss(e, t);
  for (; r && Bp(r) && Ve(r).position === "static"; )
    r = ss(r, t);
  return r && (Ft(r) === "html" || Ft(r) === "body" && Ve(r).position === "static" && !ci(r)) ? n : r || function(o) {
    let i = hn(o);
    for (; Xe(i) && !Vr(i); ) {
      if (ci(i))
        return i;
      i = hn(i);
    }
    return null;
  }(e) || n;
}
function Lp(e, t, n) {
  const r = Xe(t), o = gt(t), i = n === "fixed", a = jt(e, !0, i, t);
  let s = { scrollLeft: 0, scrollTop: 0 };
  const c = Qt(0);
  if (r || !r && !i)
    if ((Ft(t) !== "body" || Yn(o)) && (s = Xr(t)), Xe(t)) {
      const l = jt(t, !0, i, t);
      c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
    } else
      o && (c.x = Xc(o));
  return { x: a.left + s.scrollLeft - c.x, y: a.top + s.scrollTop - c.y, width: a.width, height: a.height };
}
const zp = { getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: r, strategy: o } = e;
  const i = n === "clippingAncestors" ? function(l, u) {
    const d = u.get(l);
    if (d)
      return d;
    let m = Nr(l).filter((g) => mt(g) && Ft(g) !== "body"), p = null;
    const h = Ve(l).position === "fixed";
    let f = h ? hn(l) : l;
    for (; mt(f) && !Vr(f); ) {
      const g = Ve(f), v = ci(f);
      v || g.position !== "fixed" || (p = null), (h ? !v && !p : !v && g.position === "static" && p && ["absolute", "fixed"].includes(p.position) || Yn(f) && !v && Jc(l, f)) ? m = m.filter((b) => b !== f) : p = g, f = hn(f);
    }
    return u.set(l, m), m;
  }(t, this._c) : [].concat(n), a = [...i, r], s = a[0], c = a.reduce((l, u) => {
    const d = as(t, u, o);
    return l.top = Bn(d.top, l.top), l.right = os(d.right, l.right), l.bottom = os(d.bottom, l.bottom), l.left = Bn(d.left, l.left), l;
  }, as(t, s, o));
  return { width: c.right - c.left, height: c.bottom - c.top, x: c.left, y: c.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: n, strategy: r } = e;
  const o = Xe(n), i = gt(n);
  if (n === i)
    return t;
  let a = { scrollLeft: 0, scrollTop: 0 }, s = Qt(1);
  const c = Qt(0);
  if ((o || !o && r !== "fixed") && ((Ft(n) !== "body" || Yn(i)) && (a = Xr(n)), Xe(n))) {
    const l = jt(n);
    s = un(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return { width: t.width * s.x, height: t.height * s.y, x: t.x * s.x - a.scrollLeft * s.x + c.x, y: t.y * s.y - a.scrollTop * s.y + c.y };
}, isElement: mt, getDimensions: function(e) {
  return Kc(e);
}, getOffsetParent: cs, getDocumentElement: gt, getScale: un, async getElementRects(e) {
  let { reference: t, floating: n, strategy: r } = e;
  const o = this.getOffsetParent || cs, i = this.getDimensions;
  return { reference: Lp(t, await o(n), r), floating: { x: 0, y: 0, ...await i(n) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => Ve(e).direction === "rtl" };
function Gp(e, t, n, r) {
  r === void 0 && (r = {});
  const { ancestorScroll: o = !0, ancestorResize: i = !0, elementResize: a = !0, layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = oa(e), u = o || i ? [...l ? Nr(l) : [], ...Nr(t)] : [];
  u.forEach((f) => {
    o && f.addEventListener("scroll", n, { passive: !0 }), i && f.addEventListener("resize", n);
  });
  const d = l && s ? function(f, g) {
    let v, b = null;
    const w = gt(f);
    function C() {
      clearTimeout(v), b && b.disconnect(), b = null;
    }
    return function T(P, M) {
      P === void 0 && (P = !1), M === void 0 && (M = 1), C();
      const { left: R, top: G, width: Q, height: U } = f.getBoundingClientRect();
      if (P || g(), !Q || !U)
        return;
      const te = dr(G), X = dr(w.clientWidth - (R + Q)), F = dr(w.clientHeight - (G + U)), L = dr(R);
      let z = !0;
      b = new IntersectionObserver((Z) => {
        const ne = Z[0].intersectionRatio;
        if (ne !== M) {
          if (!z)
            return T();
          ne === 0 ? v = setTimeout(() => {
            T(!1, 1e-7);
          }, 100) : T(!1, ne);
        }
        z = !1;
      }, { rootMargin: -te + "px " + -X + "px " + -F + "px " + -L + "px", threshold: M }), b.observe(f);
    }(!0), C;
  }(l, n) : null;
  let m, p = null;
  a && (p = new ResizeObserver(n), l && !c && p.observe(l), p.observe(t));
  let h = c ? jt(e) : null;
  return c && function f() {
    const g = jt(e);
    !h || g.x === h.x && g.y === h.y && g.width === h.width && g.height === h.height || n(), h = g, m = requestAnimationFrame(f);
  }(), n(), () => {
    u.forEach((f) => {
      o && f.removeEventListener("scroll", n), i && f.removeEventListener("resize", n);
    }), d && d(), p && p.disconnect(), p = null, c && cancelAnimationFrame(m);
  };
}
const Yp = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = { platform: zp, ...n }, i = { ...o.platform, _c: r };
  return Op(e, t, { ...o, platform: i });
}, Hp = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? es({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? es({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var Ar = typeof document < "u" ? Yr : Y;
function Fr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Fr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Fr(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Zc(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ls(e, t) {
  const n = Zc(e);
  return Math.round(t * n) / n;
}
function ds(e) {
  const t = q.useRef(e);
  return Ar(() => {
    t.current = e;
  }), t;
}
function Up(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, d] = q.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, p] = q.useState(r);
  Fr(m, r) || p(r);
  const [h, f] = q.useState(null), [g, v] = q.useState(null), b = q.useCallback((z) => {
    z != P.current && (P.current = z, f(z));
  }, [f]), w = q.useCallback((z) => {
    z !== M.current && (M.current = z, v(z));
  }, [v]), C = i || h, T = a || g, P = q.useRef(null), M = q.useRef(null), R = q.useRef(u), G = ds(c), Q = ds(o), U = q.useCallback(() => {
    if (!P.current || !M.current)
      return;
    const z = {
      placement: t,
      strategy: n,
      middleware: m
    };
    Q.current && (z.platform = Q.current), Yp(P.current, M.current, z).then((Z) => {
      const ne = {
        ...Z,
        isPositioned: !0
      };
      te.current && !Fr(R.current, ne) && (R.current = ne, zu.flushSync(() => {
        d(ne);
      }));
    });
  }, [m, t, n, Q]);
  Ar(() => {
    l === !1 && R.current.isPositioned && (R.current.isPositioned = !1, d((z) => ({
      ...z,
      isPositioned: !1
    })));
  }, [l]);
  const te = q.useRef(!1);
  Ar(() => (te.current = !0, () => {
    te.current = !1;
  }), []), Ar(() => {
    if (C && (P.current = C), T && (M.current = T), C && T) {
      if (G.current)
        return G.current(C, T, U);
      U();
    }
  }, [C, T, U, G]);
  const X = q.useMemo(() => ({
    reference: P,
    floating: M,
    setReference: b,
    setFloating: w
  }), [b, w]), F = q.useMemo(() => ({
    reference: C,
    floating: T
  }), [C, T]), L = q.useMemo(() => {
    const z = {
      position: n,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return z;
    const Z = ls(F.floating, u.x), ne = ls(F.floating, u.y);
    return s ? {
      ...z,
      transform: "translate(" + Z + "px, " + ne + "px)",
      ...Zc(F.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: Z,
      top: ne
    };
  }, [n, s, F.floating, u.x, u.y]);
  return q.useMemo(() => ({
    ...u,
    update: U,
    refs: X,
    elements: F,
    floatingStyles: L
  }), [u, U, X, F, L]);
}
const Wp = /* @__PURE__ */ S((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ A(ce.svg, O({}, i, {
    ref: t,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ A("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), Qp = Wp, _c = "Popper", [el, yn] = ke(_c), [jp, tl] = el(_c), Kp = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = V(null);
  return /* @__PURE__ */ A(jp, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, Vp = "PopperAnchor", Xp = /* @__PURE__ */ S((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, i = tl(Vp, n), a = N(null), s = ve(t, a);
  return Y(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || a.current);
  }), r ? null : /* @__PURE__ */ A(ce.div, O({}, o, {
    ref: s
  }));
}), nl = "PopperContent", [qp, Jp] = el(nl), Zp = /* @__PURE__ */ S((e, t) => {
  var n, r, o, i, a, s, c, l;
  const { __scopePopper: u, side: d = "bottom", sideOffset: m = 0, align: p = "center", alignOffset: h = 0, arrowPadding: f = 0, collisionBoundary: g = [], collisionPadding: v = 0, sticky: b = "partial", hideWhenDetached: w = !1, avoidCollisions: C = !0, onPlaced: T, ...P } = e, M = tl(nl, u), [R, G] = V(null), Q = ve(
    t,
    (wt) => G(wt)
  ), [U, te] = V(null), X = ta(U), F = (n = X == null ? void 0 : X.width) !== null && n !== void 0 ? n : 0, L = (r = X == null ? void 0 : X.height) !== null && r !== void 0 ? r : 0, z = d + (p !== "center" ? "-" + p : ""), Z = typeof v == "number" ? v : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...v
  }, ne = Array.isArray(g) ? g : [
    g
  ], K = ne.length > 0, B = {
    padding: Z,
    boundary: ne.filter(nh),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: K
  }, { refs: ee, floatingStyles: se, placement: re, isPositioned: ie, middlewareData: ue } = Up({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: z,
    whileElementsMounted: Gp,
    elements: {
      reference: M.anchor
    },
    middleware: [
      Np({
        mainAxis: m + L,
        alignmentAxis: h
      }),
      C && Fp({
        mainAxis: !0,
        crossAxis: !1,
        limiter: b === "partial" ? $p() : void 0,
        ...B
      }),
      C && Dp({
        ...B
      }),
      kp({
        ...B,
        apply: ({ elements: wt, rects: xt, availableWidth: Et, availableHeight: dt }) => {
          const { width: _t, height: et } = xt.reference, Ct = wt.floating.style;
          Ct.setProperty("--radix-popper-available-width", `${Et}px`), Ct.setProperty("--radix-popper-available-height", `${dt}px`), Ct.setProperty("--radix-popper-anchor-width", `${_t}px`), Ct.setProperty("--radix-popper-anchor-height", `${et}px`);
        }
      }),
      U && Hp({
        element: U,
        padding: f
      }),
      rh({
        arrowWidth: F,
        arrowHeight: L
      }),
      w && Mp({
        strategy: "referenceHidden"
      })
    ]
  }), [Te, ye] = rl(re), De = Se(T);
  bt(() => {
    ie && (De == null || De());
  }, [
    ie,
    De
  ]);
  const Ce = (o = ue.arrow) === null || o === void 0 ? void 0 : o.x, He = (i = ue.arrow) === null || i === void 0 ? void 0 : i.y, On = ((a = ue.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [kt, Sn] = V();
  return bt(() => {
    R && Sn(window.getComputedStyle(R).zIndex);
  }, [
    R
  ]), /* @__PURE__ */ A("div", {
    ref: ee.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...se,
      transform: ie ? se.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: kt,
      ["--radix-popper-transform-origin"]: [
        (s = ue.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = ue.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ A(qp, {
    scope: u,
    placedSide: Te,
    onArrowChange: te,
    arrowX: Ce,
    arrowY: He,
    shouldHideArrow: On
  }, /* @__PURE__ */ A(ce.div, O({
    "data-side": Te,
    "data-align": ye
  }, P, {
    ref: Q,
    style: {
      ...P.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ie ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = ue.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
}), _p = "PopperArrow", eh = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, th = /* @__PURE__ */ S(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = Jp(_p, r), a = eh[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ A("span", {
      ref: i.onArrowChange,
      style: {
        position: "absolute",
        left: i.arrowX,
        top: i.arrowY,
        [a]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[i.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[i.placedSide],
        visibility: i.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ A(Qp, O({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function nh(e) {
  return e !== null;
}
const rh = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, i, a;
    const { placement: s, rects: c, middlewareData: l } = t, d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, m = d ? 0 : e.arrowWidth, p = d ? 0 : e.arrowHeight, [h, f] = rl(s), g = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[f], v = ((r = (o = l.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + m / 2, b = ((i = (a = l.arrow) === null || a === void 0 ? void 0 : a.y) !== null && i !== void 0 ? i : 0) + p / 2;
    let w = "", C = "";
    return h === "bottom" ? (w = d ? g : `${v}px`, C = `${-p}px`) : h === "top" ? (w = d ? g : `${v}px`, C = `${c.floating.height + p}px`) : h === "right" ? (w = `${-p}px`, C = d ? g : `${b}px`) : h === "left" && (w = `${c.floating.width + p}px`, C = d ? g : `${b}px`), {
      data: {
        x: w,
        y: C
      }
    };
  }
});
function rl(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const ia = Kp, aa = Xp, sa = Zp, ca = th, qr = /* @__PURE__ */ S((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ Hi.createPortal(/* @__PURE__ */ A(ce.div, O({}, o, {
    ref: t
  })), r) : null;
}), $o = "rovingFocusGroup.onEntryFocus", oh = {
  bubbles: !1,
  cancelable: !0
}, la = "RovingFocusGroup", [li, ol, ih] = Ur(la), [ah, Jr] = ke(la, [
  ih
]), [sh, ch] = ah(la), lh = /* @__PURE__ */ S((e, t) => /* @__PURE__ */ A(li.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ A(li.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ A(dh, O({}, e, {
  ref: t
}))))), dh = /* @__PURE__ */ S((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: o = !1, dir: i, currentTabStopId: a, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: c, onEntryFocus: l, ...u } = e, d = N(null), m = ve(t, d), p = Wr(i), [h = null, f] = Ye({
    prop: a,
    defaultProp: s,
    onChange: c
  }), [g, v] = V(!1), b = Se(l), w = ol(n), C = N(!1), [T, P] = V(0);
  return Y(() => {
    const M = d.current;
    if (M)
      return M.addEventListener($o, b), () => M.removeEventListener($o, b);
  }, [
    b
  ]), /* @__PURE__ */ A(sh, {
    scope: n,
    orientation: r,
    dir: p,
    loop: o,
    currentTabStopId: h,
    onItemFocus: W(
      (M) => f(M),
      [
        f
      ]
    ),
    onItemShiftTab: W(
      () => v(!0),
      []
    ),
    onFocusableItemAdd: W(
      () => P(
        (M) => M + 1
      ),
      []
    ),
    onFocusableItemRemove: W(
      () => P(
        (M) => M - 1
      ),
      []
    )
  }, /* @__PURE__ */ A(ce.div, O({
    tabIndex: g || T === 0 ? -1 : 0,
    "data-orientation": r
  }, u, {
    ref: m,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: _(e.onMouseDown, () => {
      C.current = !0;
    }),
    onFocus: _(e.onFocus, (M) => {
      const R = !C.current;
      if (M.target === M.currentTarget && R && !g) {
        const G = new CustomEvent($o, oh);
        if (M.currentTarget.dispatchEvent(G), !G.defaultPrevented) {
          const Q = w().filter(
            (L) => L.focusable
          ), U = Q.find(
            (L) => L.active
          ), te = Q.find(
            (L) => L.id === h
          ), F = [
            U,
            te,
            ...Q
          ].filter(Boolean).map(
            (L) => L.ref.current
          );
          il(F);
        }
      }
      C.current = !1;
    }),
    onBlur: _(
      e.onBlur,
      () => v(!1)
    )
  })));
}), uh = "RovingFocusGroupItem", fh = /* @__PURE__ */ S((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: o = !1, tabStopId: i, ...a } = e, s = Wt(), c = i || s, l = ch(uh, n), u = l.currentTabStopId === c, d = ol(n), { onFocusableItemAdd: m, onFocusableItemRemove: p } = l;
  return Y(() => {
    if (r)
      return m(), () => p();
  }, [
    r,
    m,
    p
  ]), /* @__PURE__ */ A(li.ItemSlot, {
    scope: n,
    id: c,
    focusable: r,
    active: o
  }, /* @__PURE__ */ A(ce.span, O({
    tabIndex: u ? 0 : -1,
    "data-orientation": l.orientation
  }, a, {
    ref: t,
    onMouseDown: _(e.onMouseDown, (h) => {
      r ? l.onItemFocus(c) : h.preventDefault();
    }),
    onFocus: _(
      e.onFocus,
      () => l.onItemFocus(c)
    ),
    onKeyDown: _(e.onKeyDown, (h) => {
      if (h.key === "Tab" && h.shiftKey) {
        l.onItemShiftTab();
        return;
      }
      if (h.target !== h.currentTarget)
        return;
      const f = mh(h, l.orientation, l.dir);
      if (f !== void 0) {
        h.preventDefault();
        let v = d().filter(
          (b) => b.focusable
        ).map(
          (b) => b.ref.current
        );
        if (f === "last")
          v.reverse();
        else if (f === "prev" || f === "next") {
          f === "prev" && v.reverse();
          const b = v.indexOf(h.currentTarget);
          v = l.loop ? gh(v, b + 1) : v.slice(b + 1);
        }
        setTimeout(
          () => il(v)
        );
      }
    })
  })));
}), ph = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function hh(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function mh(e, t, n) {
  const r = hh(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return ph[r];
}
function il(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function gh(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const al = lh, sl = fh;
var vh = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, an = /* @__PURE__ */ new WeakMap(), ur = /* @__PURE__ */ new WeakMap(), fr = {}, ko = 0, cl = function(e) {
  return e && (e.host || cl(e.parentNode));
}, bh = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = cl(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Ah = function(e, t, n, r) {
  var o = bh(t, Array.isArray(e) ? e : [e]);
  fr[n] || (fr[n] = /* @__PURE__ */ new WeakMap());
  var i = fr[n], a = [], s = /* @__PURE__ */ new Set(), c = new Set(o), l = function(d) {
    !d || s.has(d) || (s.add(d), l(d.parentNode));
  };
  o.forEach(l);
  var u = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(m) {
      if (s.has(m))
        u(m);
      else {
        var p = m.getAttribute(r), h = p !== null && p !== "false", f = (an.get(m) || 0) + 1, g = (i.get(m) || 0) + 1;
        an.set(m, f), i.set(m, g), a.push(m), f === 1 && h && ur.set(m, !0), g === 1 && m.setAttribute(n, "true"), h || m.setAttribute(r, "true");
      }
    });
  };
  return u(t), s.clear(), ko++, function() {
    a.forEach(function(d) {
      var m = an.get(d) - 1, p = i.get(d) - 1;
      an.set(d, m), i.set(d, p), m || (ur.has(d) || d.removeAttribute(r), ur.delete(d)), p || d.removeAttribute(n);
    }), ko--, ko || (an = /* @__PURE__ */ new WeakMap(), an = /* @__PURE__ */ new WeakMap(), ur = /* @__PURE__ */ new WeakMap(), fr = {});
  };
}, Zr = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || vh(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), Ah(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, ot = function() {
  return ot = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, ot.apply(this, arguments);
};
function ll(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function yh(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var yr = "right-scroll-bar-position", wr = "width-before-scroll-bar", wh = "with-scroll-bars-hidden", xh = "--removed-body-scroll-bar-size";
function Eh(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Ch(e, t) {
  var n = V(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function Ih(e, t) {
  return Ch(t || null, function(n) {
    return e.forEach(function(r) {
      return Eh(r, n);
    });
  });
}
function Th(e) {
  return e;
}
function Oh(e, t) {
  t === void 0 && (t = Th);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var c = function() {
        var u = a;
        a = [], u.forEach(i);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(u) {
          a.push(u), l();
        },
        filter: function(u) {
          return a = a.filter(u), n;
        }
      };
    }
  };
  return o;
}
function Sh(e) {
  e === void 0 && (e = {});
  var t = Oh(null);
  return t.options = ot({ async: !0, ssr: !1 }, e), t;
}
var dl = function(e) {
  var t = e.sideCar, n = ll(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return q.createElement(r, ot({}, n));
};
dl.isSideCarExport = !0;
function Rh(e, t) {
  return e.useMedium(t), dl;
}
var ul = Sh(), Bo = function() {
}, _r = q.forwardRef(function(e, t) {
  var n = q.useRef(null), r = q.useState({
    onScrollCapture: Bo,
    onWheelCapture: Bo,
    onTouchMoveCapture: Bo
  }), o = r[0], i = r[1], a = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, m = e.sideCar, p = e.noIsolation, h = e.inert, f = e.allowPinchZoom, g = e.as, v = g === void 0 ? "div" : g, b = ll(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), w = m, C = Ih([n, t]), T = ot(ot({}, b), o);
  return q.createElement(
    q.Fragment,
    null,
    u && q.createElement(w, { sideCar: ul, removeScrollBar: l, shards: d, noIsolation: p, inert: h, setCallbacks: i, allowPinchZoom: !!f, lockRef: n }),
    a ? q.cloneElement(q.Children.only(s), ot(ot({}, T), { ref: C })) : q.createElement(v, ot({}, T, { className: c, ref: C }), s)
  );
});
_r.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
_r.classNames = {
  fullWidth: wr,
  zeroRight: yr
};
var us, Ph = function() {
  if (us)
    return us;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Dh() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ph();
  return t && e.setAttribute("nonce", t), e;
}
function Mh(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Nh(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Fh = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Dh()) && (Mh(t, n), Nh(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, $h = function() {
  var e = Fh();
  return function(t, n) {
    q.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, fl = function() {
  var e = $h(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, kh = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Lo = function(e) {
  return parseInt(e || "", 10) || 0;
}, Bh = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Lo(n), Lo(r), Lo(o)];
}, Lh = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return kh;
  var t = Bh(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, zh = fl(), Gh = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(wh, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(yr, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(wr, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(yr, " .").concat(yr, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(wr, " .").concat(wr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(xh, ": ").concat(s, `px;
  }
`);
}, Yh = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r, i = q.useMemo(function() {
    return Lh(o);
  }, [o]);
  return q.createElement(zh, { styles: Gh(i, !t, o, n ? "" : "!important") });
}, di = !1;
if (typeof window < "u")
  try {
    var pr = Object.defineProperty({}, "passive", {
      get: function() {
        return di = !0, !0;
      }
    });
    window.addEventListener("test", pr, pr), window.removeEventListener("test", pr, pr);
  } catch {
    di = !1;
  }
var sn = di ? { passive: !1 } : !1, Hh = function(e) {
  return e.tagName === "TEXTAREA";
}, pl = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Hh(e) && n[t] === "visible")
  );
}, Uh = function(e) {
  return pl(e, "overflowY");
}, Wh = function(e) {
  return pl(e, "overflowX");
}, fs = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = hl(e, n);
    if (r) {
      var o = ml(e, n), i = o[1], a = o[2];
      if (i > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, Qh = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, jh = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, hl = function(e, t) {
  return e === "v" ? Uh(t) : Wh(t);
}, ml = function(e, t) {
  return e === "v" ? Qh(t) : jh(t);
}, Kh = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Vh = function(e, t, n, r, o) {
  var i = Kh(e, window.getComputedStyle(t).direction), a = i * r, s = n.target, c = t.contains(s), l = !1, u = a > 0, d = 0, m = 0;
  do {
    var p = ml(e, s), h = p[0], f = p[1], g = p[2], v = f - g - i * h;
    (h || v) && hl(e, s) && (d += v, m += h), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (u && (o && d === 0 || !o && a > d) || !u && (o && m === 0 || !o && -a > m)) && (l = !0), l;
}, hr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ps = function(e) {
  return [e.deltaX, e.deltaY];
}, hs = function(e) {
  return e && "current" in e ? e.current : e;
}, Xh = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, qh = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Jh = 0, cn = [];
function Zh(e) {
  var t = q.useRef([]), n = q.useRef([0, 0]), r = q.useRef(), o = q.useState(Jh++)[0], i = q.useState(function() {
    return fl();
  })[0], a = q.useRef(e);
  q.useEffect(function() {
    a.current = e;
  }, [e]), q.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var f = yh([e.lockRef.current], (e.shards || []).map(hs), !0).filter(Boolean);
      return f.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), f.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = q.useCallback(function(f, g) {
    if ("touches" in f && f.touches.length === 2)
      return !a.current.allowPinchZoom;
    var v = hr(f), b = n.current, w = "deltaX" in f ? f.deltaX : b[0] - v[0], C = "deltaY" in f ? f.deltaY : b[1] - v[1], T, P = f.target, M = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in f && M === "h" && P.type === "range")
      return !1;
    var R = fs(M, P);
    if (!R)
      return !0;
    if (R ? T = M : (T = M === "v" ? "h" : "v", R = fs(M, P)), !R)
      return !1;
    if (!r.current && "changedTouches" in f && (w || C) && (r.current = T), !T)
      return !0;
    var G = r.current || T;
    return Vh(G, g, f, G === "h" ? w : C, !0);
  }, []), c = q.useCallback(function(f) {
    var g = f;
    if (!(!cn.length || cn[cn.length - 1] !== i)) {
      var v = "deltaY" in g ? ps(g) : hr(g), b = t.current.filter(function(T) {
        return T.name === g.type && T.target === g.target && Xh(T.delta, v);
      })[0];
      if (b && b.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!b) {
        var w = (a.current.shards || []).map(hs).filter(Boolean).filter(function(T) {
          return T.contains(g.target);
        }), C = w.length > 0 ? s(g, w[0]) : !a.current.noIsolation;
        C && g.cancelable && g.preventDefault();
      }
    }
  }, []), l = q.useCallback(function(f, g, v, b) {
    var w = { name: f, delta: g, target: v, should: b };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), u = q.useCallback(function(f) {
    n.current = hr(f), r.current = void 0;
  }, []), d = q.useCallback(function(f) {
    l(f.type, ps(f), f.target, s(f, e.lockRef.current));
  }, []), m = q.useCallback(function(f) {
    l(f.type, hr(f), f.target, s(f, e.lockRef.current));
  }, []);
  q.useEffect(function() {
    return cn.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", c, sn), document.addEventListener("touchmove", c, sn), document.addEventListener("touchstart", u, sn), function() {
      cn = cn.filter(function(f) {
        return f !== i;
      }), document.removeEventListener("wheel", c, sn), document.removeEventListener("touchmove", c, sn), document.removeEventListener("touchstart", u, sn);
    };
  }, []);
  var p = e.removeScrollBar, h = e.inert;
  return q.createElement(
    q.Fragment,
    null,
    h ? q.createElement(i, { styles: qh(o) }) : null,
    p ? q.createElement(Yh, { gapMode: "margin" }) : null
  );
}
const _h = Rh(ul, Zh);
var gl = q.forwardRef(function(e, t) {
  return q.createElement(_r, ot({}, e, { ref: t, sideCar: _h }));
});
gl.classNames = _r.classNames;
const eo = gl, em = [
  "Enter",
  " "
], tm = [
  "ArrowDown",
  "PageUp",
  "Home"
], vl = [
  "ArrowUp",
  "PageDown",
  "End"
], nm = [
  ...tm,
  ...vl
], to = "Menu", [ui, rm, om] = Ur(to), [Jt, bl] = ke(to, [
  om,
  yn,
  Jr
]), no = yn(), Al = Jr(), [im, _n] = Jt(to), [am, da] = Jt(to), sm = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: a = !0 } = e, s = no(t), [c, l] = V(null), u = N(!1), d = Se(i), m = Wr(o);
  return Y(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", h, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", h, {
        capture: !0,
        once: !0
      });
    }, h = () => u.current = !1;
    return document.addEventListener("keydown", p, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", p, {
        capture: !0
      }), document.removeEventListener("pointerdown", h, {
        capture: !0
      }), document.removeEventListener("pointermove", h, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ A(ia, s, /* @__PURE__ */ A(im, {
    scope: t,
    open: n,
    onOpenChange: d,
    content: c,
    onContentChange: l
  }, /* @__PURE__ */ A(am, {
    scope: t,
    onClose: W(
      () => d(!1),
      [
        d
      ]
    ),
    isUsingKeyboardRef: u,
    dir: m,
    modal: a
  }, r)));
}, cm = /* @__PURE__ */ S((e, t) => {
  const { __scopeMenu: n, ...r } = e, o = no(n);
  return /* @__PURE__ */ A(aa, O({}, o, r, {
    ref: t
  }));
}), yl = "MenuPortal", [lm, dm] = Jt(yl, {
  forceMount: void 0
}), um = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = _n(yl, t);
  return /* @__PURE__ */ A(lm, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ A(st, {
    present: n || i.open
  }, /* @__PURE__ */ A(qr, {
    asChild: !0,
    container: o
  }, r)));
}, Mt = "MenuContent", [fm, wl] = Jt(Mt), pm = /* @__PURE__ */ S((e, t) => {
  const n = dm(Mt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = _n(Mt, e.__scopeMenu), a = da(Mt, e.__scopeMenu);
  return /* @__PURE__ */ A(ui.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ A(st, {
    present: r || i.open
  }, /* @__PURE__ */ A(ui.Slot, {
    scope: e.__scopeMenu
  }, a.modal ? /* @__PURE__ */ A(hm, O({}, o, {
    ref: t
  })) : /* @__PURE__ */ A(mm, O({}, o, {
    ref: t
  })))));
}), hm = /* @__PURE__ */ S((e, t) => {
  const n = _n(Mt, e.__scopeMenu), r = N(null), o = ve(t, r);
  return Y(() => {
    const i = r.current;
    if (i)
      return Zr(i);
  }, []), /* @__PURE__ */ A(xl, O({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: _(
      e.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), mm = /* @__PURE__ */ S((e, t) => {
  const n = _n(Mt, e.__scopeMenu);
  return /* @__PURE__ */ A(xl, O({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), xl = /* @__PURE__ */ S((e, t) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: o, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: s, onEntryFocus: c, onEscapeKeyDown: l, onPointerDownOutside: u, onFocusOutside: d, onInteractOutside: m, onDismiss: p, disableOutsideScroll: h, ...f } = e, g = _n(Mt, n), v = da(Mt, n), b = no(n), w = Al(n), C = rm(n), [T, P] = V(null), M = N(null), R = ve(t, M, g.onContentChange), G = N(0), Q = N(""), U = N(0), te = N(null), X = N("right"), F = N(0), L = h ? eo : Ze, z = h ? {
    as: Ut,
    allowPinchZoom: !0
  } : void 0, Z = (K) => {
    var B, ee;
    const se = Q.current + K, re = C().filter(
      (Ce) => !Ce.disabled
    ), ie = document.activeElement, ue = (B = re.find(
      (Ce) => Ce.ref.current === ie
    )) === null || B === void 0 ? void 0 : B.textValue, Te = re.map(
      (Ce) => Ce.textValue
    ), ye = Im(Te, se, ue), De = (ee = re.find(
      (Ce) => Ce.textValue === ye
    )) === null || ee === void 0 ? void 0 : ee.ref.current;
    (function Ce(He) {
      Q.current = He, window.clearTimeout(G.current), He !== "" && (G.current = window.setTimeout(
        () => Ce(""),
        1e3
      ));
    })(se), De && setTimeout(
      () => De.focus()
    );
  };
  Y(() => () => window.clearTimeout(G.current), []), Ap();
  const ne = W((K) => {
    var B, ee;
    return X.current === ((B = te.current) === null || B === void 0 ? void 0 : B.side) && Om(K, (ee = te.current) === null || ee === void 0 ? void 0 : ee.area);
  }, []);
  return /* @__PURE__ */ A(fm, {
    scope: n,
    searchRef: Q,
    onItemEnter: W((K) => {
      ne(K) && K.preventDefault();
    }, [
      ne
    ]),
    onItemLeave: W((K) => {
      var B;
      ne(K) || ((B = M.current) === null || B === void 0 || B.focus(), P(null));
    }, [
      ne
    ]),
    onTriggerLeave: W((K) => {
      ne(K) && K.preventDefault();
    }, [
      ne
    ]),
    pointerGraceTimerRef: U,
    onPointerGraceIntentChange: W((K) => {
      te.current = K;
    }, [])
  }, /* @__PURE__ */ A(L, z, /* @__PURE__ */ A(yp, {
    asChild: !0,
    trapped: o,
    onMountAutoFocus: _(i, (K) => {
      var B;
      K.preventDefault(), (B = M.current) === null || B === void 0 || B.focus();
    }),
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ A(Kr, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: l,
    onPointerDownOutside: u,
    onFocusOutside: d,
    onInteractOutside: m,
    onDismiss: p
  }, /* @__PURE__ */ A(al, O({
    asChild: !0
  }, w, {
    dir: v.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: T,
    onCurrentTabStopIdChange: P,
    onEntryFocus: _(c, (K) => {
      v.isUsingKeyboardRef.current || K.preventDefault();
    })
  }), /* @__PURE__ */ A(sa, O({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": xm(g.open),
    "data-radix-menu-content": "",
    dir: v.dir
  }, b, f, {
    ref: R,
    style: {
      outline: "none",
      ...f.style
    },
    onKeyDown: _(f.onKeyDown, (K) => {
      const ee = K.target.closest("[data-radix-menu-content]") === K.currentTarget, se = K.ctrlKey || K.altKey || K.metaKey, re = K.key.length === 1;
      ee && (K.key === "Tab" && K.preventDefault(), !se && re && Z(K.key));
      const ie = M.current;
      if (K.target !== ie || !nm.includes(K.key))
        return;
      K.preventDefault();
      const Te = C().filter(
        (ye) => !ye.disabled
      ).map(
        (ye) => ye.ref.current
      );
      vl.includes(K.key) && Te.reverse(), Em(Te);
    }),
    onBlur: _(e.onBlur, (K) => {
      K.currentTarget.contains(K.target) || (window.clearTimeout(G.current), Q.current = "");
    }),
    onPointerMove: _(e.onPointerMove, pi((K) => {
      const B = K.target, ee = F.current !== K.clientX;
      if (K.currentTarget.contains(B) && ee) {
        const se = K.clientX > F.current ? "right" : "left";
        X.current = se, F.current = K.clientX;
      }
    }))
  })))))));
}), fi = "MenuItem", ms = "menu.itemSelect", gm = /* @__PURE__ */ S((e, t) => {
  const { disabled: n = !1, onSelect: r, ...o } = e, i = N(null), a = da(fi, e.__scopeMenu), s = wl(fi, e.__scopeMenu), c = ve(t, i), l = N(!1), u = () => {
    const d = i.current;
    if (!n && d) {
      const m = new CustomEvent(ms, {
        bubbles: !0,
        cancelable: !0
      });
      d.addEventListener(
        ms,
        (p) => r == null ? void 0 : r(p),
        {
          once: !0
        }
      ), Ki(d, m), m.defaultPrevented ? l.current = !1 : a.onClose();
    }
  };
  return /* @__PURE__ */ A(vm, O({}, o, {
    ref: c,
    disabled: n,
    onClick: _(e.onClick, u),
    onPointerDown: (d) => {
      var m;
      (m = e.onPointerDown) === null || m === void 0 || m.call(e, d), l.current = !0;
    },
    onPointerUp: _(e.onPointerUp, (d) => {
      var m;
      l.current || (m = d.currentTarget) === null || m === void 0 || m.click();
    }),
    onKeyDown: _(e.onKeyDown, (d) => {
      const m = s.searchRef.current !== "";
      n || m && d.key === " " || em.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
    })
  }));
}), vm = /* @__PURE__ */ S((e, t) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, a = wl(fi, n), s = Al(n), c = N(null), l = ve(t, c), [u, d] = V(!1), [m, p] = V("");
  return Y(() => {
    const h = c.current;
    if (h) {
      var f;
      p(((f = h.textContent) !== null && f !== void 0 ? f : "").trim());
    }
  }, [
    i.children
  ]), /* @__PURE__ */ A(ui.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: o ?? m
  }, /* @__PURE__ */ A(sl, O({
    asChild: !0
  }, s, {
    focusable: !r
  }), /* @__PURE__ */ A(ce.div, O({
    role: "menuitem",
    "data-highlighted": u ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, i, {
    ref: l,
    onPointerMove: _(e.onPointerMove, pi((h) => {
      r ? a.onItemLeave(h) : (a.onItemEnter(h), h.defaultPrevented || h.currentTarget.focus());
    })),
    onPointerLeave: _(e.onPointerLeave, pi(
      (h) => a.onItemLeave(h)
    )),
    onFocus: _(
      e.onFocus,
      () => d(!0)
    ),
    onBlur: _(
      e.onBlur,
      () => d(!1)
    )
  }))));
}), bm = "MenuRadioGroup";
Jt(bm, {
  value: void 0,
  onValueChange: () => {
  }
});
const Am = "MenuItemIndicator";
Jt(Am, {
  checked: !1
});
const ym = /* @__PURE__ */ S((e, t) => {
  const { __scopeMenu: n, ...r } = e, o = no(n);
  return /* @__PURE__ */ A(ca, O({}, o, r, {
    ref: t
  }));
}), wm = "MenuSub";
Jt(wm);
function xm(e) {
  return e ? "open" : "closed";
}
function Em(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function Cm(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
function Im(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(
    (l) => l === t[0]
  ) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = Cm(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter(
    (l) => l !== n
  ));
  const c = a.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function Tm(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, c = t[i].y, l = t[a].x, u = t[a].y;
    c > r != u > r && n < (l - s) * (r - c) / (u - c) + s && (o = !o);
  }
  return o;
}
function Om(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return Tm(n, t);
}
function pi(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const Sm = sm, Rm = cm, Pm = um, Dm = pm, Mm = gm, Nm = ym, El = "DropdownMenu", [Fm, gC] = ke(El, [
  bl
]), wn = bl(), [$m, Cl] = Fm(El), km = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: r, open: o, defaultOpen: i, onOpenChange: a, modal: s = !0 } = e, c = wn(t), l = N(null), [u = !1, d] = Ye({
    prop: o,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ A($m, {
    scope: t,
    triggerId: Wt(),
    triggerRef: l,
    contentId: Wt(),
    open: u,
    onOpenChange: d,
    onOpenToggle: W(
      () => d(
        (m) => !m
      ),
      [
        d
      ]
    ),
    modal: s
  }, /* @__PURE__ */ A(Sm, O({}, c, {
    open: u,
    onOpenChange: d,
    dir: r,
    modal: s
  }), n));
}, Bm = "DropdownMenuTrigger", Lm = /* @__PURE__ */ S((e, t) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = Cl(Bm, n), a = wn(n);
  return /* @__PURE__ */ A(Rm, O({
    asChild: !0
  }, a), /* @__PURE__ */ A(ce.button, O({
    type: "button",
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": i.open,
    "aria-controls": i.open ? i.contentId : void 0,
    "data-state": i.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, o, {
    ref: ji(t, i.triggerRef),
    onPointerDown: _(e.onPointerDown, (s) => {
      !r && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
    }),
    onKeyDown: _(e.onKeyDown, (s) => {
      r || ([
        "Enter",
        " "
      ].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), zm = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = wn(t);
  return /* @__PURE__ */ A(Pm, O({}, r, n));
}, Gm = "DropdownMenuContent", Ym = /* @__PURE__ */ S((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Cl(Gm, n), i = wn(n), a = N(!1);
  return /* @__PURE__ */ A(Dm, O({
    id: o.contentId,
    "aria-labelledby": o.triggerId
  }, i, r, {
    ref: t,
    onCloseAutoFocus: _(e.onCloseAutoFocus, (s) => {
      var c;
      a.current || (c = o.triggerRef.current) === null || c === void 0 || c.focus(), a.current = !1, s.preventDefault();
    }),
    onInteractOutside: _(e.onInteractOutside, (s) => {
      const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || l;
      (!o.modal || u) && (a.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), Hm = /* @__PURE__ */ S((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = wn(n);
  return /* @__PURE__ */ A(Mm, O({}, o, r, {
    ref: t
  }));
}), Um = /* @__PURE__ */ S((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = wn(n);
  return /* @__PURE__ */ A(Nm, O({}, o, r, {
    ref: t
  }));
}), Wm = km, Qm = Lm, jm = zm, Km = Ym, Vm = Hm, Xm = Um, ua = /* @__PURE__ */ S((e, t) => /* @__PURE__ */ A(ce.span, O({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), qm = ua, [ro, vC] = ke("Tooltip", [
  yn
]), oo = yn(), Jm = "TooltipProvider", Zm = 700, hi = "tooltip.open", [_m, fa] = ro(Jm), e0 = (e) => {
  const { __scopeTooltip: t, delayDuration: n = Zm, skipDelayDuration: r = 300, disableHoverableContent: o = !1, children: i } = e, [a, s] = V(!0), c = N(!1), l = N(0);
  return Y(() => {
    const u = l.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ A(_m, {
    scope: t,
    isOpenDelayed: a,
    delayDuration: n,
    onOpen: W(() => {
      window.clearTimeout(l.current), s(!1);
    }, []),
    onClose: W(() => {
      window.clearTimeout(l.current), l.current = window.setTimeout(
        () => s(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: W((u) => {
      c.current = u;
    }, []),
    disableHoverableContent: o
  }, i);
}, pa = "Tooltip", [t0, er] = ro(pa), n0 = (e) => {
  const { __scopeTooltip: t, children: n, open: r, defaultOpen: o = !1, onOpenChange: i, disableHoverableContent: a, delayDuration: s } = e, c = fa(pa, e.__scopeTooltip), l = oo(t), [u, d] = V(null), m = Wt(), p = N(0), h = a ?? c.disableHoverableContent, f = s ?? c.delayDuration, g = N(!1), [v = !1, b] = Ye({
    prop: r,
    defaultProp: o,
    onChange: (M) => {
      M ? (c.onOpen(), document.dispatchEvent(new CustomEvent(hi))) : c.onClose(), i == null || i(M);
    }
  }), w = xe(() => v ? g.current ? "delayed-open" : "instant-open" : "closed", [
    v
  ]), C = W(() => {
    window.clearTimeout(p.current), g.current = !1, b(!0);
  }, [
    b
  ]), T = W(() => {
    window.clearTimeout(p.current), b(!1);
  }, [
    b
  ]), P = W(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      g.current = !0, b(!0);
    }, f);
  }, [
    f,
    b
  ]);
  return Y(() => () => window.clearTimeout(p.current), []), /* @__PURE__ */ A(ia, l, /* @__PURE__ */ A(t0, {
    scope: t,
    contentId: m,
    open: v,
    stateAttribute: w,
    trigger: u,
    onTriggerChange: d,
    onTriggerEnter: W(() => {
      c.isOpenDelayed ? P() : C();
    }, [
      c.isOpenDelayed,
      P,
      C
    ]),
    onTriggerLeave: W(() => {
      h ? T() : window.clearTimeout(p.current);
    }, [
      T,
      h
    ]),
    onOpen: C,
    onClose: T,
    disableHoverableContent: h
  }, n));
}, gs = "TooltipTrigger", r0 = /* @__PURE__ */ S((e, t) => {
  const { __scopeTooltip: n, ...r } = e, o = er(gs, n), i = fa(gs, n), a = oo(n), s = N(null), c = ve(t, s, o.onTriggerChange), l = N(!1), u = N(!1), d = W(
    () => l.current = !1,
    []
  );
  return Y(() => () => document.removeEventListener("pointerup", d), [
    d
  ]), /* @__PURE__ */ A(aa, O({
    asChild: !0
  }, a), /* @__PURE__ */ A(ce.button, O({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": o.open ? o.contentId : void 0,
    "data-state": o.stateAttribute
  }, r, {
    ref: c,
    onPointerMove: _(e.onPointerMove, (m) => {
      m.pointerType !== "touch" && !u.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
    }),
    onPointerLeave: _(e.onPointerLeave, () => {
      o.onTriggerLeave(), u.current = !1;
    }),
    onPointerDown: _(e.onPointerDown, () => {
      l.current = !0, document.addEventListener("pointerup", d, {
        once: !0
      });
    }),
    onFocus: _(e.onFocus, () => {
      l.current || o.onOpen();
    }),
    onBlur: _(e.onBlur, o.onClose),
    onClick: _(e.onClick, o.onClose)
  })));
}), Il = "TooltipPortal", [o0, i0] = ro(Il, {
  forceMount: void 0
}), a0 = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = er(Il, t);
  return /* @__PURE__ */ A(o0, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ A(st, {
    present: n || i.open
  }, /* @__PURE__ */ A(qr, {
    asChild: !0,
    container: o
  }, r)));
}, Hn = "TooltipContent", s0 = /* @__PURE__ */ S((e, t) => {
  const n = i0(Hn, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, a = er(Hn, e.__scopeTooltip);
  return /* @__PURE__ */ A(st, {
    present: r || a.open
  }, a.disableHoverableContent ? /* @__PURE__ */ A(Tl, O({
    side: o
  }, i, {
    ref: t
  })) : /* @__PURE__ */ A(c0, O({
    side: o
  }, i, {
    ref: t
  })));
}), c0 = /* @__PURE__ */ S((e, t) => {
  const n = er(Hn, e.__scopeTooltip), r = fa(Hn, e.__scopeTooltip), o = N(null), i = ve(t, o), [a, s] = V(null), { trigger: c, onClose: l } = n, u = o.current, { onPointerInTransitChange: d } = r, m = W(() => {
    s(null), d(!1);
  }, [
    d
  ]), p = W((h, f) => {
    const g = h.currentTarget, v = {
      x: h.clientX,
      y: h.clientY
    }, b = p0(v, g.getBoundingClientRect()), w = h0(v, b), C = m0(f.getBoundingClientRect()), T = v0([
      ...w,
      ...C
    ]);
    s(T), d(!0);
  }, [
    d
  ]);
  return Y(() => () => m(), [
    m
  ]), Y(() => {
    if (c && u) {
      const h = (g) => p(g, u), f = (g) => p(g, c);
      return c.addEventListener("pointerleave", h), u.addEventListener("pointerleave", f), () => {
        c.removeEventListener("pointerleave", h), u.removeEventListener("pointerleave", f);
      };
    }
  }, [
    c,
    u,
    p,
    m
  ]), Y(() => {
    if (a) {
      const h = (f) => {
        const g = f.target, v = {
          x: f.clientX,
          y: f.clientY
        }, b = (c == null ? void 0 : c.contains(g)) || (u == null ? void 0 : u.contains(g)), w = !g0(v, a);
        b ? m() : w && (m(), l());
      };
      return document.addEventListener("pointermove", h), () => document.removeEventListener("pointermove", h);
    }
  }, [
    c,
    u,
    a,
    l,
    m
  ]), /* @__PURE__ */ A(Tl, O({}, e, {
    ref: i
  }));
}), [l0, d0] = ro(pa, {
  isInside: !1
}), Tl = /* @__PURE__ */ S((e, t) => {
  const { __scopeTooltip: n, children: r, "aria-label": o, onEscapeKeyDown: i, onPointerDownOutside: a, ...s } = e, c = er(Hn, n), l = oo(n), { onClose: u } = c;
  return Y(() => (document.addEventListener(hi, u), () => document.removeEventListener(hi, u)), [
    u
  ]), Y(() => {
    if (c.trigger) {
      const d = (m) => {
        const p = m.target;
        p != null && p.contains(c.trigger) && u();
      };
      return window.addEventListener("scroll", d, {
        capture: !0
      }), () => window.removeEventListener("scroll", d, {
        capture: !0
      });
    }
  }, [
    c.trigger,
    u
  ]), /* @__PURE__ */ A(Kr, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: i,
    onPointerDownOutside: a,
    onFocusOutside: (d) => d.preventDefault(),
    onDismiss: u
  }, /* @__PURE__ */ A(sa, O({
    "data-state": c.stateAttribute
  }, l, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ A(xc, null, r), /* @__PURE__ */ A(l0, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ A(qm, {
    id: c.contentId,
    role: "tooltip"
  }, o || r))));
}), u0 = "TooltipArrow", f0 = /* @__PURE__ */ S((e, t) => {
  const { __scopeTooltip: n, ...r } = e, o = oo(n);
  return d0(u0, n).isInside ? null : /* @__PURE__ */ A(ca, O({}, o, r, {
    ref: t
  }));
});
function p0(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function h0(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function m0(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    {
      x: o,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: r
    },
    {
      x: o,
      y: r
    }
  ];
}
function g0(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, c = t[i].y, l = t[a].x, u = t[a].y;
    c > r != u > r && n < (l - s) * (r - c) / (u - c) + s && (o = !o);
  }
  return o;
}
function v0(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), b0(t);
}
function b0(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x))
        t.pop();
      else
        break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const A0 = e0, y0 = n0, w0 = r0, x0 = a0, E0 = s0, C0 = f0, I0 = Re`
    0% { opacity: 0; transform: 'translateY(2px)' };
    100% { opacity: 1; transform: 'translateY(0)' };
`, T0 = Re`
    0% { opacity: 0; transform: 'translateX(-2px)' };
    100% { opacity: 1; transform: 'translateX(0)' };
`, O0 = Re`
    0% { opacity: 0; transform: 'translateY(-2px)' };
    100% { opacity: 1; transform: 'translateY(0)' };
`, S0 = Re`
    0% { opacity: 0; transform: 'translateX(2px)' };
    100% { opacity: 1; transform: 'translateX(0)' };
`, R0 = I(E0)`
  border-radius: ${le.xs};
  padding: 10px 15px;
  font-size: 15px;
  line-height: 1;
  color: ${E.black300};
  background-color: ${E.white300};
  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  user-select: none;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  z-index: 1;

  @media (prefers-reduced-motion: no-preference) {
    animation-duration: 400ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
    &[data-state='delayed-open'] {
      &[data-side='top'] {
        animation-name: ${O0};
      }

      &[data-side='right'] {
        animation-name: ${S0};
      }

      &[data-side='bottom'] {
        animation-name: ${I0};
      }

      &[data-side='left'] {
        animation-name: ${T0};
      }
    }
  }
`, P0 = I(C0)`
  fill: ${E.white300};
`, Yt = ({
  children: e,
  message: t,
  dataCy: n = "tooltip-field",
  ...r
}) => /* @__PURE__ */ x(A0, { ...r, children: /* @__PURE__ */ J(y0, { delayDuration: 300, children: [
  /* @__PURE__ */ x(w0, { asChild: !0, children: e }),
  /* @__PURE__ */ x(x0, { children: /* @__PURE__ */ J(R0, { sideOffset: 5, "data-cy": n, children: [
    t,
    /* @__PURE__ */ x(P0, {})
  ] }) })
] }) }), D0 = Re`
  0% { opacity: 0; transform: "translateY(2px)" };
  100% { opacity: 1; transform: "translateY(0)" };
`, M0 = Re`
  0% { opacity: 0; transform: "translateX(-2px)" };
  100% { opacity: 1; transform: "translateX(0)" };
`, N0 = Re`
  0% { opacity: 0; transform: "translateY(-2px)" };
  100% { opacity: 1; transform: "translateY(0)" };
`, F0 = Re`
  0% { opacity: 0; transform: "translateX(2px)" };
  100% { opacity: 1; transform: "translateX(0)" };
`, $0 = I(Km)`
  background-color: ${E.white300};
  border-radius: ${le.sm};
  box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35),
    0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  max-width: 99vw;
  min-width: 150px;
  padding: 5px;
  z-index: ${({ $zIndex: e }) => e !== void 0 ? e : "auto"};

  @media (prefers-reduced-motion: no-preference) {
    animation-duration: 400ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
    &[data-state='open'] {
      &[data-side='top'] {
        animation-name: ${N0};
      }

      &[data-side='right'] {
        animation-name: ${F0};
      }

      &[data-side='bottom'] {
        animation-name: ${D0};
      }

      &[data-side='left'] {
        animation-name: ${M0};
      }
    }
  }
`, k0 = I(Xm)`
  fill: ${E.white300};
`, B0 = I.button`
  all: unset;
  align-items: center;
  border-radius: ${le.full};
  display: inline-flex;
  font-family: inherit;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;

  &:hover {
    background-color: ${E.backgroundHover};
  }
  &:focus {
    box-shadow: ${Zn.modal};
  }
`, L0 = I(zf)`
  height: 2rem;
  width: 2rem;
`, z0 = I(Vm)`
  border-radius: ${le.sm};
  color: ${E.labelText};
  font-size: 1rem;
  font-weight: 400;
  height: auto;
  line-height: 1.125rem;
  padding-left: 25;
  padding: 5px;
  position: relative;
  user-select: none;

  ${({ $type: e }) => e === "large" && j`
      border: 0.5px solid ${E.lightGray200};
      padding: 1rem;
    `}

  &[data-highlighted] {
    background-color: ${E.backgroundHover};
    outline: none;
  }

  &[data-disabled] {
    opacity: 0.8;
  }
`, G0 = S(function({ ...t }, n) {
  return /* @__PURE__ */ x(B0, { ref: n, "aria-label": "More options", ...t, children: /* @__PURE__ */ x(L0, {}) });
}), Y0 = ({
  children: e,
  customTrigger: t = null,
  dataCy: n = "dropdown-menu-button",
  disabled: r = !1,
  zIndex: o,
  ...i
}) => /* @__PURE__ */ J(Wm, { ...i, children: [
  /* @__PURE__ */ x(Yt, { message: "Options", children: /* @__PURE__ */ x(
    Qm,
    {
      disabled: r,
      asChild: !0,
      "data-cy": n,
      children: t ?? /* @__PURE__ */ x(G0, {})
    }
  ) }),
  /* @__PURE__ */ x(jm, { children: /* @__PURE__ */ J(
    $0,
    {
      $zIndex: o,
      "data-cy": "dropdown-menu-content",
      sideOffset: 5,
      children: [
        e,
        /* @__PURE__ */ x(k0, {})
      ]
    }
  ) })
] }), H0 = S(function({ type: t = "default", ...n }, r) {
  return /* @__PURE__ */ x(z0, { ref: r, ...n, $type: t });
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var mi = function(e, t) {
  return mi = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r)
      r.hasOwnProperty(o) && (n[o] = r[o]);
  }, mi(e, t);
};
function U0(e, t) {
  mi(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Ln = function() {
  return Ln = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ln.apply(this, arguments);
};
function W0(e, t, n, r) {
  var o, i = !1, a = 0;
  function s() {
    o && clearTimeout(o);
  }
  function c() {
    s(), i = !0;
  }
  typeof t != "boolean" && (r = n, n = t, t = void 0);
  function l() {
    var u = this, d = Date.now() - a, m = arguments;
    if (i)
      return;
    function p() {
      a = Date.now(), n.apply(u, m);
    }
    function h() {
      o = void 0;
    }
    r && !o && p(), s(), r === void 0 && d > e ? p() : t !== !0 && (o = setTimeout(r ? h : p, r === void 0 ? e - d : e));
  }
  return l.cancel = c, l;
}
var fn = {
  Pixel: "Pixel",
  Percent: "Percent"
}, vs = {
  unit: fn.Percent,
  value: 0.8
};
function bs(e) {
  return typeof e == "number" ? {
    unit: fn.Percent,
    value: e * 100
  } : typeof e == "string" ? e.match(/^(\d*(\.\d+)?)px$/) ? {
    unit: fn.Pixel,
    value: parseFloat(e)
  } : e.match(/^(\d*(\.\d+)?)%$/) ? {
    unit: fn.Percent,
    value: parseFloat(e)
  } : (console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...'), vs) : (console.warn("scrollThreshold should be string or number"), vs);
}
var Q0 = (
  /** @class */
  function(e) {
    U0(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.lastScrollTop = 0, r.actionTriggered = !1, r.startY = 0, r.currentY = 0, r.dragging = !1, r.maxPullDownDistance = 0, r.getScrollableTarget = function() {
        return r.props.scrollableTarget instanceof HTMLElement ? r.props.scrollableTarget : typeof r.props.scrollableTarget == "string" ? document.getElementById(r.props.scrollableTarget) : (r.props.scrollableTarget === null && console.warn(`You are trying to pass scrollableTarget but it is null. This might
        happen because the element may not have been added to DOM yet.
        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.
      `), null);
      }, r.onStart = function(o) {
        r.lastScrollTop || (r.dragging = !0, o instanceof MouseEvent ? r.startY = o.pageY : o instanceof TouchEvent && (r.startY = o.touches[0].pageY), r.currentY = r.startY, r._infScroll && (r._infScroll.style.willChange = "transform", r._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)"));
      }, r.onMove = function(o) {
        r.dragging && (o instanceof MouseEvent ? r.currentY = o.pageY : o instanceof TouchEvent && (r.currentY = o.touches[0].pageY), !(r.currentY < r.startY) && (r.currentY - r.startY >= Number(r.props.pullDownToRefreshThreshold) && r.setState({
          pullToRefreshThresholdBreached: !0
        }), !(r.currentY - r.startY > r.maxPullDownDistance * 1.5) && r._infScroll && (r._infScroll.style.overflow = "visible", r._infScroll.style.transform = "translate3d(0px, " + (r.currentY - r.startY) + "px, 0px)")));
      }, r.onEnd = function() {
        r.startY = 0, r.currentY = 0, r.dragging = !1, r.state.pullToRefreshThresholdBreached && (r.props.refreshFunction && r.props.refreshFunction(), r.setState({
          pullToRefreshThresholdBreached: !1
        })), requestAnimationFrame(function() {
          r._infScroll && (r._infScroll.style.overflow = "auto", r._infScroll.style.transform = "none", r._infScroll.style.willChange = "unset");
        });
      }, r.onScrollListener = function(o) {
        typeof r.props.onScroll == "function" && setTimeout(function() {
          return r.props.onScroll && r.props.onScroll(o);
        }, 0);
        var i = r.props.height || r._scrollableNode ? o.target : document.documentElement.scrollTop ? document.documentElement : document.body;
        if (!r.actionTriggered) {
          var a = r.props.inverse ? r.isElementAtTop(i, r.props.scrollThreshold) : r.isElementAtBottom(i, r.props.scrollThreshold);
          a && r.props.hasMore && (r.actionTriggered = !0, r.setState({ showLoader: !0 }), r.props.next && r.props.next()), r.lastScrollTop = i.scrollTop;
        }
      }, r.state = {
        showLoader: !1,
        pullToRefreshThresholdBreached: !1,
        prevDataLength: n.dataLength
      }, r.throttledOnScrollListener = W0(150, r.onScrollListener).bind(r), r.onStart = r.onStart.bind(r), r.onMove = r.onMove.bind(r), r.onEnd = r.onEnd.bind(r), r;
    }
    return t.prototype.componentDidMount = function() {
      if (typeof this.props.dataLength > "u")
        throw new Error('mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage');
      if (this._scrollableNode = this.getScrollableTarget(), this.el = this.props.height ? this._infScroll : this._scrollableNode || window, this.el && this.el.addEventListener("scroll", this.throttledOnScrollListener), typeof this.props.initialScrollY == "number" && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY && this.el.scrollTo(0, this.props.initialScrollY), this.props.pullDownToRefresh && this.el && (this.el.addEventListener("touchstart", this.onStart), this.el.addEventListener("touchmove", this.onMove), this.el.addEventListener("touchend", this.onEnd), this.el.addEventListener("mousedown", this.onStart), this.el.addEventListener("mousemove", this.onMove), this.el.addEventListener("mouseup", this.onEnd), this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0, this.forceUpdate(), typeof this.props.refreshFunction != "function"))
        throw new Error(`Mandatory prop "refreshFunction" missing.
          Pull Down To Refresh functionality will not work
          as expected. Check README.md for usage'`);
    }, t.prototype.componentWillUnmount = function() {
      this.el && (this.el.removeEventListener("scroll", this.throttledOnScrollListener), this.props.pullDownToRefresh && (this.el.removeEventListener("touchstart", this.onStart), this.el.removeEventListener("touchmove", this.onMove), this.el.removeEventListener("touchend", this.onEnd), this.el.removeEventListener("mousedown", this.onStart), this.el.removeEventListener("mousemove", this.onMove), this.el.removeEventListener("mouseup", this.onEnd)));
    }, t.prototype.componentDidUpdate = function(n) {
      this.props.dataLength !== n.dataLength && (this.actionTriggered = !1, this.setState({
        showLoader: !1
      }));
    }, t.getDerivedStateFromProps = function(n, r) {
      var o = n.dataLength !== r.prevDataLength;
      return o ? Ln(Ln({}, r), { prevDataLength: n.dataLength }) : null;
    }, t.prototype.isElementAtTop = function(n, r) {
      r === void 0 && (r = 0.8);
      var o = n === document.body || n === document.documentElement ? window.screen.availHeight : n.clientHeight, i = bs(r);
      return i.unit === fn.Pixel ? n.scrollTop <= i.value + o - n.scrollHeight + 1 : n.scrollTop <= i.value / 100 + o - n.scrollHeight + 1;
    }, t.prototype.isElementAtBottom = function(n, r) {
      r === void 0 && (r = 0.8);
      var o = n === document.body || n === document.documentElement ? window.screen.availHeight : n.clientHeight, i = bs(r);
      return i.unit === fn.Pixel ? n.scrollTop + o >= n.scrollHeight - i.value : n.scrollTop + o >= i.value / 100 * n.scrollHeight;
    }, t.prototype.render = function() {
      var n = this, r = Ln({ height: this.props.height || "auto", overflow: "auto", WebkitOverflowScrolling: "touch" }, this.props.style), o = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length), i = this.props.pullDownToRefresh && this.props.height ? { overflow: "auto" } : {};
      return $.createElement(
        "div",
        { style: i, className: "infinite-scroll-component__outerdiv" },
        $.createElement(
          "div",
          { className: "infinite-scroll-component " + (this.props.className || ""), ref: function(a) {
            return n._infScroll = a;
          }, style: r },
          this.props.pullDownToRefresh && $.createElement(
            "div",
            { style: { position: "relative" }, ref: function(a) {
              return n._pullDown = a;
            } },
            $.createElement("div", { style: {
              position: "absolute",
              left: 0,
              right: 0,
              top: -1 * this.maxPullDownDistance
            } }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)
          ),
          this.props.children,
          !this.state.showLoader && !o && this.props.hasMore && this.props.loader,
          this.state.showLoader && this.props.hasMore && this.props.loader,
          !this.props.hasMore && this.props.endMessage
        )
      );
    }, t;
  }(Lu)
);
const j0 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIgogIHN0eWxlPSJtYXJnaW46IGF1dG87IGJhY2tncm91bmQ6IG5vbmU7IGRpc3BsYXk6IGJsb2NrOyBzaGFwZS1yZW5kZXJpbmc6IGF1dG87IiB3aWR0aD0iMjAwcHgiIGhlaWdodD0iMjAwcHgiCiAgdmlld0JveD0iMjUgMjUgNTAgNTAiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIj4KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC02LjUpIj4KICAgIDxjaXJjbGUgY3g9IjUwIiBjeT0iNDIuMiIgcj0iMTAiIGZpbGw9IiM2ZGM1ZWEiPgogICAgICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgZHVyPSIxcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGtleVRpbWVzPSIwOzEiCiAgICAgICAgdmFsdWVzPSIwIDUwIDUwOzM2MCA1MCA1MCI+PC9hbmltYXRlVHJhbnNmb3JtPgogICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgY2FsY01vZGU9InNwbGluZSIga2V5VGltZXM9IjA7MC41OzEiIHZhbHVlcz0iMDsxMzswIgogICAgICAgIGtleVNwbGluZXM9IjAuMiAwIDAuOCAxOzAuMiAwIDAuOCAxIj48L2FuaW1hdGU+CiAgICA8L2NpcmNsZT4KICAgIDxjaXJjbGUgY3g9IjUwIiBjeT0iNDIuMiIgcj0iMTAiIGZpbGw9IiMwMDQyNmIiPgogICAgICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgZHVyPSIxcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGtleVRpbWVzPSIwOzEiCiAgICAgICAgdmFsdWVzPSIxODAgNTAgNTA7NTQwIDUwIDUwIj48L2FuaW1hdGVUcmFuc2Zvcm0+CiAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiIGR1cj0iMXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlUaW1lcz0iMDswLjU7MSIgdmFsdWVzPSIxMzswOzEzIgogICAgICAgIGtleVNwbGluZXM9IjAuMiAwIDAuOCAxOzAuMiAwIDAuOCAxIj48L2FuaW1hdGU+CiAgICA8L2NpcmNsZT4KICA8L2c+CiAgPCEtLSBbbGRpb10gZ2VuZXJhdGVkIGJ5IGh0dHBzOi8vbG9hZGluZy5pby8gLS0+Cjwvc3ZnPgo=", tr = S(
  // eslint-disable-next-line no-restricted-syntax
  function({ dataCy: t = "loading-spinner", notLoading: n = !1, ...r }, o) {
    return /* @__PURE__ */ x(Qi, { children: n || /* @__PURE__ */ x(
      "img",
      {
        alt: "Loading spinner",
        ...r,
        "data-cy": t,
        ref: o,
        src: j0
      }
    ) });
  }
), K0 = I(tr)`
  height: 3.25rem;
  margin-top: 1.5rem;
  width: 3.25rem;
`, V0 = I.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`, X0 = ({
  dataCy: e = "loading-items-container",
  ...t
}) => /* @__PURE__ */ x(V0, { ...t, "data-cy": e, children: /* @__PURE__ */ x(K0, {}) }), q0 = I.div`
  display: flex;
  flex-basis: 0;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;

  ${bn}
`;
I(tr)`
  height: 3.25rem;
  margin-top: 1.5rem;
  width: 3.25rem;
`;
I.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;
I.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  margin-top: 1rem;
`;
I.p`
  color: ${E.textLight};
  font-size: 1rem;
  font-weight: 400;
`;
const J0 = I.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  margin-top: 1rem;
`, Z0 = I.p`
  color: ${E.textLight};
  font-size: 1rem;
  font-weight: 400;
`, _0 = ({
  loading: e = !1,
  endMessage: t = "You have seen it all",
  style: n,
  className: r,
  dataCy: o = "infinite-scroll",
  inverse: i = !1,
  scrollableTarget: a = "container-pagination",
  ...s
}) => {
  const c = { overflow: "unset" }, l = i ? { ...c, display: "flex", flexDirection: "column-reverse" } : c;
  return /* @__PURE__ */ x(
    q0,
    {
      style: n,
      className: r,
      id: a,
      "data-cy": `${o}-container`,
      children: /* @__PURE__ */ x(
        Q0,
        {
          "data-cy": o,
          style: l,
          inverse: i,
          scrollableTarget: a,
          ...s,
          loader: e && /* @__PURE__ */ x(X0, {}),
          endMessage: /* @__PURE__ */ x(J0, { "data-cy": "text-container", children: /* @__PURE__ */ x(Z0, { "data-cy": t, children: t }) })
        }
      )
    }
  );
};
function Nt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function eg(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ol(...e) {
  return (t) => e.forEach(
    (n) => eg(n, t)
  );
}
function nr(...e) {
  return W(Ol(...e), e);
}
function tg(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = /* @__PURE__ */ $e(a), c = n.length;
    n = [
      ...n,
      a
    ];
    function l(d) {
      const { scope: m, children: p, ...h } = d, f = (m == null ? void 0 : m[e][c]) || s, g = xe(
        () => h,
        Object.values(h)
      );
      return /* @__PURE__ */ A(f.Provider, {
        value: g
      }, p);
    }
    function u(d, m) {
      const p = (m == null ? void 0 : m[e][c]) || s, h = Je(p);
      if (h)
        return h;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [
      l,
      u
    ];
  }
  const o = () => {
    const i = n.map((a) => /* @__PURE__ */ $e(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return xe(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    ng(o, ...t)
  ];
}
function ng(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const a = r.reduce((s, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return {
          ...s,
          ...d
        };
      }, {});
      return xe(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const gi = globalThis != null && globalThis.document ? Yr : () => {
}, rg = q["useId".toString()] || (() => {
});
let og = 0;
function zo(e) {
  const [t, n] = q.useState(rg());
  return gi(() => {
    e || n(
      (r) => r ?? String(og++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function rr(e) {
  const t = N(e);
  return Y(() => {
    t.current = e;
  }), xe(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function ig({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = ag({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : r, s = rr(n), c = W((l) => {
    if (i) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && s(d);
    } else
      o(l);
  }, [
    i,
    e,
    o,
    s
  ]);
  return [
    a,
    c
  ];
}
function ag({ defaultProp: e, onChange: t }) {
  const n = V(e), [r] = n, o = N(r), i = rr(t);
  return Y(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const ha = /* @__PURE__ */ S((e, t) => {
  const { children: n, ...r } = e, o = be.toArray(n), i = o.find(cg);
  if (i) {
    const a = i.props.children, s = o.map((c) => c === i ? be.count(a) > 1 ? be.only(null) : /* @__PURE__ */ Me(a) ? a.props.children : null : c);
    return /* @__PURE__ */ A(vi, O({}, r, {
      ref: t
    }), /* @__PURE__ */ Me(a) ? /* @__PURE__ */ at(a, void 0, s) : null);
  }
  return /* @__PURE__ */ A(vi, O({}, r, {
    ref: t
  }), n);
});
ha.displayName = "Slot";
const vi = /* @__PURE__ */ S((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Me(n) ? /* @__PURE__ */ at(n, {
    ...lg(r, n.props),
    ref: Ol(t, n.ref)
  }) : be.count(n) > 1 ? be.only(null) : null;
});
vi.displayName = "SlotClone";
const sg = ({ children: e }) => /* @__PURE__ */ A(Ze, null, e);
function cg(e) {
  return /* @__PURE__ */ Me(e) && e.type === sg;
}
function lg(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const dg = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], xn = dg.reduce((e, t) => {
  const n = /* @__PURE__ */ S((r, o) => {
    const { asChild: i, ...a } = r, s = i ? ha : t;
    return Y(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ A(s, O({}, a, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function ug(e, t) {
  e && qn(
    () => e.dispatchEvent(t)
  );
}
function fg(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = rr(e);
  Y(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const bi = "dismissableLayer.update", pg = "dismissableLayer.pointerDownOutside", hg = "dismissableLayer.focusOutside";
let As;
const mg = /* @__PURE__ */ $e({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), gg = /* @__PURE__ */ S((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...l } = e, u = Je(mg), [d, m] = V(null), p = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, h] = V({}), f = nr(
    t,
    (R) => m(R)
  ), g = Array.from(u.layers), [v] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), b = g.indexOf(v), w = d ? g.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, T = w >= b, P = vg((R) => {
    const G = R.target, Q = [
      ...u.branches
    ].some(
      (U) => U.contains(G)
    );
    !T || Q || (i == null || i(R), s == null || s(R), R.defaultPrevented || c == null || c());
  }, p), M = bg((R) => {
    const G = R.target;
    [
      ...u.branches
    ].some(
      (U) => U.contains(G)
    ) || (a == null || a(R), s == null || s(R), R.defaultPrevented || c == null || c());
  }, p);
  return fg((R) => {
    w === u.layers.size - 1 && (o == null || o(R), !R.defaultPrevented && c && (R.preventDefault(), c()));
  }, p), Y(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (As = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), ys(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = As);
      };
  }, [
    d,
    p,
    r,
    u
  ]), Y(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), ys());
  }, [
    d,
    u
  ]), Y(() => {
    const R = () => h({});
    return document.addEventListener(bi, R), () => document.removeEventListener(bi, R);
  }, []), /* @__PURE__ */ A(xn.div, O({}, l, {
    ref: f,
    style: {
      pointerEvents: C ? T ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Nt(e.onFocusCapture, M.onFocusCapture),
    onBlurCapture: Nt(e.onBlurCapture, M.onBlurCapture),
    onPointerDownCapture: Nt(e.onPointerDownCapture, P.onPointerDownCapture)
  }));
});
function vg(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = rr(e), r = N(!1), o = N(() => {
  });
  return Y(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Sl(pg, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, {
          once: !0
        })) : l();
      }
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function bg(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = rr(e), r = N(!1);
  return Y(() => {
    const o = (i) => {
      i.target && !r.current && Sl(hg, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function ys() {
  const e = new CustomEvent(bi);
  document.dispatchEvent(e);
}
function Sl(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? ug(o, i) : o.dispatchEvent(i);
}
function Ag(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Rl(...e) {
  return (t) => e.forEach(
    (n) => Ag(n, t)
  );
}
function yg(...e) {
  return W(Rl(...e), e);
}
const Pl = /* @__PURE__ */ S((e, t) => {
  const { children: n, ...r } = e, o = be.toArray(n), i = o.find(xg);
  if (i) {
    const a = i.props.children, s = o.map((c) => c === i ? be.count(a) > 1 ? be.only(null) : /* @__PURE__ */ Me(a) ? a.props.children : null : c);
    return /* @__PURE__ */ A(Ai, O({}, r, {
      ref: t
    }), /* @__PURE__ */ Me(a) ? /* @__PURE__ */ at(a, void 0, s) : null);
  }
  return /* @__PURE__ */ A(Ai, O({}, r, {
    ref: t
  }), n);
});
Pl.displayName = "Slot";
const Ai = /* @__PURE__ */ S((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Me(n) ? /* @__PURE__ */ at(n, {
    ...Eg(r, n.props),
    ref: Rl(t, n.ref)
  }) : be.count(n) > 1 ? be.only(null) : null;
});
Ai.displayName = "SlotClone";
const wg = ({ children: e }) => /* @__PURE__ */ A(Ze, null, e);
function xg(e) {
  return /* @__PURE__ */ Me(e) && e.type === wg;
}
function Eg(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const Cg = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ig = Cg.reduce((e, t) => {
  const n = /* @__PURE__ */ S((r, o) => {
    const { asChild: i, ...a } = r, s = i ? Pl : t;
    return Y(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ A(s, O({}, a, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function ws(e) {
  const t = N(e);
  return Y(() => {
    t.current = e;
  }), xe(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
const Go = "focusScope.autoFocusOnMount", Yo = "focusScope.autoFocusOnUnmount", xs = {
  bubbles: !1,
  cancelable: !0
}, Dl = /* @__PURE__ */ S((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...a } = e, [s, c] = V(null), l = ws(o), u = ws(i), d = N(null), m = yg(
    t,
    (f) => c(f)
  ), p = N({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Y(() => {
    if (r) {
      let f = function(v) {
        if (p.paused || !s)
          return;
        const b = v.target;
        s.contains(b) ? d.current = b : Lt(d.current, {
          select: !0
        });
      }, g = function(v) {
        p.paused || !s || s.contains(v.relatedTarget) || Lt(d.current, {
          select: !0
        });
      };
      return document.addEventListener("focusin", f), document.addEventListener("focusout", g), () => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", g);
      };
    }
  }, [
    r,
    s,
    p.paused
  ]), Y(() => {
    if (s) {
      Cs.add(p);
      const f = document.activeElement;
      if (!s.contains(f)) {
        const v = new CustomEvent(Go, xs);
        s.addEventListener(Go, l), s.dispatchEvent(v), v.defaultPrevented || (Tg(Dg(Ml(s)), {
          select: !0
        }), document.activeElement === f && Lt(s));
      }
      return () => {
        s.removeEventListener(Go, l), setTimeout(() => {
          const v = new CustomEvent(Yo, xs);
          s.addEventListener(Yo, u), s.dispatchEvent(v), v.defaultPrevented || Lt(f ?? document.body, {
            select: !0
          }), s.removeEventListener(Yo, u), Cs.remove(p);
        }, 0);
      };
    }
  }, [
    s,
    l,
    u,
    p
  ]);
  const h = W((f) => {
    if (!n && !r || p.paused)
      return;
    const g = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, v = document.activeElement;
    if (g && v) {
      const b = f.currentTarget, [w, C] = Og(b);
      w && C ? !f.shiftKey && v === C ? (f.preventDefault(), n && Lt(w, {
        select: !0
      })) : f.shiftKey && v === w && (f.preventDefault(), n && Lt(C, {
        select: !0
      })) : v === b && f.preventDefault();
    }
  }, [
    n,
    r,
    p.paused
  ]);
  return /* @__PURE__ */ A(Ig.div, O({
    tabIndex: -1
  }, a, {
    ref: m,
    onKeyDown: h
  }));
});
function Tg(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Lt(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function Og(e) {
  const t = Ml(e), n = Es(t, e), r = Es(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Ml(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Es(e, t) {
  for (const n of e)
    if (!Sg(n, {
      upTo: t
    }))
      return n;
}
function Sg(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Rg(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Lt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Rg(e) && t && e.select();
  }
}
const Cs = Pg();
function Pg() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Is(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Is(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Is(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Dg(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Mg = /* @__PURE__ */ S((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ Hi.createPortal(/* @__PURE__ */ A(xn.div, O({}, o, {
    ref: t
  })), r) : null;
});
function Ng(e, t) {
  return yc((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const io = (e) => {
  const { present: t, children: n } = e, r = Fg(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : be.only(n), i = nr(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ at(o, {
    ref: i
  }) : null;
};
io.displayName = "Presence";
function Fg(e) {
  const [t, n] = V(), r = N({}), o = N(e), i = N("none"), a = e ? "mounted" : "unmounted", [s, c] = Ng(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Y(() => {
    const l = mr(r.current);
    i.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), gi(() => {
    const l = r.current, u = o.current;
    if (u !== e) {
      const m = i.current, p = mr(l);
      e ? c("MOUNT") : p === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), gi(() => {
    if (t) {
      const l = (d) => {
        const p = mr(r.current).includes(d.animationName);
        d.target === t && p && qn(
          () => c("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (i.current = mr(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: W((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function mr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let Ho = 0;
function Nl() {
  Y(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Ts()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Ts()), Ho++, () => {
      Ho === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Ho--;
    };
  }, []);
}
function Ts() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Fl = "Dialog", [$l, bC] = tg(Fl), [$g, ct] = $l(Fl), kg = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: a = !0 } = e, s = N(null), c = N(null), [l = !1, u] = ig({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ A($g, {
    scope: t,
    triggerRef: s,
    contentRef: c,
    contentId: zo(),
    titleId: zo(),
    descriptionId: zo(),
    open: l,
    onOpenChange: u,
    onOpenToggle: W(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    ),
    modal: a
  }, n);
}, Bg = "DialogTrigger", Lg = /* @__PURE__ */ S((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ct(Bg, n), i = nr(t, o.triggerRef);
  return /* @__PURE__ */ A(xn.button, O({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": ma(o.open)
  }, r, {
    ref: i,
    onClick: Nt(e.onClick, o.onOpenToggle)
  }));
}), kl = "DialogPortal", [zg, Bl] = $l(kl, {
  forceMount: void 0
}), Ll = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = ct(kl, t);
  return /* @__PURE__ */ A(zg, {
    scope: t,
    forceMount: n
  }, be.map(
    r,
    (a) => /* @__PURE__ */ A(io, {
      present: n || i.open
    }, /* @__PURE__ */ A(Mg, {
      asChild: !0,
      container: o
    }, a))
  ));
}, yi = "DialogOverlay", Gg = /* @__PURE__ */ S((e, t) => {
  const n = Bl(yi, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = ct(yi, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ A(io, {
    present: r || i.open
  }, /* @__PURE__ */ A(Yg, O({}, o, {
    ref: t
  }))) : null;
}), Yg = /* @__PURE__ */ S((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ct(yi, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ A(eo, {
      as: ha,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ A(xn.div, O({
      "data-state": ma(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), Un = "DialogContent", Hg = /* @__PURE__ */ S((e, t) => {
  const n = Bl(Un, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = ct(Un, e.__scopeDialog);
  return /* @__PURE__ */ A(io, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ A(Ug, O({}, o, {
    ref: t
  })) : /* @__PURE__ */ A(Wg, O({}, o, {
    ref: t
  })));
}), Ug = /* @__PURE__ */ S((e, t) => {
  const n = ct(Un, e.__scopeDialog), r = N(null), o = nr(t, n.contentRef, r);
  return Y(() => {
    const i = r.current;
    if (i)
      return Zr(i);
  }, []), /* @__PURE__ */ A(zl, O({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Nt(e.onCloseAutoFocus, (i) => {
      var a;
      i.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: Nt(e.onPointerDownOutside, (i) => {
      const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || s) && i.preventDefault();
    }),
    onFocusOutside: Nt(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), Wg = /* @__PURE__ */ S((e, t) => {
  const n = ct(Un, e.__scopeDialog), r = N(!1);
  return /* @__PURE__ */ A(zl, O({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, o), !o.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), o.preventDefault();
      }
      r.current = !1;
    },
    onInteractOutside: (o) => {
      var i, a;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, o), o.defaultPrevented || (r.current = !0);
      const s = o.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(s)) && o.preventDefault();
    }
  }));
}), zl = /* @__PURE__ */ S((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, s = ct(Un, n), c = N(null), l = nr(t, c);
  return Nl(), /* @__PURE__ */ A(Ze, null, /* @__PURE__ */ A(Dl, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ A(gg, O({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": ma(s.open)
  }, a, {
    ref: l,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), Qg = "DialogTitle", jg = /* @__PURE__ */ S((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ct(Qg, n);
  return /* @__PURE__ */ A(xn.h2, O({
    id: o.titleId
  }, r, {
    ref: t
  }));
}), Kg = "DialogClose", Vg = /* @__PURE__ */ S((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ct(Kg, n);
  return /* @__PURE__ */ A(xn.button, O({
    type: "button"
  }, r, {
    ref: t,
    onClick: Nt(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
});
function ma(e) {
  return e ? "open" : "closed";
}
const Xg = kg, qg = Lg, Jg = Ll, Zg = Gg, _g = Hg, ev = jg, tv = Vg, nv = Re`
  0% { opacity: 0 }
  100% { opacity: 1 }
`, rv = Re`
  0% { opacity: 0; transform: 'translate(-50%, -48%) scale(.96)' };
  100% { opacity: 1; transform: 'translate(-50%, -50%) scale(1)' };
`, ov = I(Zg)`
  background-color: ${E.blackTranslucent400};

  inset: 0;
  position: fixed;
  ${({ $zIndex: e }) => e !== void 0 && j`
      z-index: ${e};
    `}

  @media (prefers-reduced-motion: no-preference) {
    animation: ${nv} 150ms cubic-bezier(0.55, 0.29, 0.34, 1.02);
  }
`;
I(Jg)``;
const iv = I(_g)`
  background-color: ${E.white300};
  box-shadow: ${Zn.modal};
  max-width: ${({ $biggerModal: e = !1 }) => e ? "600px" : "450px"};
  padding: ${({ $fullHeight: e = !1 }) => e ? "0 25px" : "25px"};
  position: fixed;
  width: 90vw;
  overflow: auto;
  max-height: ${({ $fullHeight: e = !1 }) => e ? "100vh" : "90vh"};

  ${bn}

  ${({ $zIndex: e }) => e !== void 0 && j`
      z-index: ${e};
    `}

  ${({ $sideModal: e = !1 }) => e ? j`
          border-top-left-radius: ${le.md};
          border-bottom-left-radius: ${le.md};
          height: 100%;
          right: 0;
          top: 0;
        ` : j`
          border-radius: ${le.sm};
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        `};

  @media (prefers-reduced-motion: no-preference) {
    animation: ${rv} 150ms cubic-bezier(0.55, 0.29, 0.34, 1.02);
  }

  &:focus {
    outline: none;
  }
`, av = I.button`
  all: unset;
  align-items: center;
  border-radius: 100%;
  color: ${E.black300};
  display: inline-flex;
  font-family: inherit;
  height: 25px;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  width: 25px;

  &:hover {
    background-color: ${E.backgroundHover};
  }
  &:focus {
    box-shadow: ${Zn.modal};
  }
`, sv = I(_i)``, Gl = ({
  biggerModal: e = !1,
  children: t,
  className: n,
  dataCy: r = "content-modal",
  hiddenCloseButton: o = !1,
  refContent: i,
  sideModal: a = !1,
  fullHeight: s = !1,
  style: c,
  trigger: l,
  zIndex: u,
  ...d
}) => /* @__PURE__ */ J(Xg, { ...d, children: [
  /* @__PURE__ */ x(qg, { asChild: !0, children: l }),
  /* @__PURE__ */ J(Ll, { "data-cy": "portal-modal", children: [
    /* @__PURE__ */ x(ov, { $zIndex: u, "data-cy": "overlay-modal" }),
    /* @__PURE__ */ J(
      iv,
      {
        $fullHeight: s,
        $biggerModal: e,
        $sideModal: a,
        $zIndex: u,
        className: n,
        "data-cy": r,
        ref: i,
        style: c,
        children: [
          t,
          /* @__PURE__ */ x(tv, { asChild: !0, children: !o && /* @__PURE__ */ x(av, { "aria-label": "Close", "data-cy": "button-closeModal", children: /* @__PURE__ */ x(sv, {}) }) })
        ]
      }
    )
  ] })
] });
let Uo = 0;
function cv() {
  Y(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Os()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Os()), Uo++, () => {
      Uo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Uo--;
    };
  }, []);
}
function Os() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Wo = "focusScope.autoFocusOnMount", Qo = "focusScope.autoFocusOnUnmount", Ss = {
  bubbles: !1,
  cancelable: !0
}, lv = /* @__PURE__ */ S((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...a } = e, [s, c] = V(null), l = Se(o), u = Se(i), d = N(null), m = ve(
    t,
    (f) => c(f)
  ), p = N({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Y(() => {
    if (r) {
      let f = function(w) {
        if (p.paused || !s)
          return;
        const C = w.target;
        s.contains(C) ? d.current = C : Rt(d.current, {
          select: !0
        });
      }, g = function(w) {
        if (p.paused || !s)
          return;
        const C = w.relatedTarget;
        C !== null && (s.contains(C) || Rt(d.current, {
          select: !0
        }));
      }, v = function(w) {
        const C = document.activeElement;
        for (const T of w)
          T.removedNodes.length > 0 && (s != null && s.contains(C) || Rt(s));
      };
      document.addEventListener("focusin", f), document.addEventListener("focusout", g);
      const b = new MutationObserver(v);
      return s && b.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", g), b.disconnect();
      };
    }
  }, [
    r,
    s,
    p.paused
  ]), Y(() => {
    if (s) {
      Ps.add(p);
      const f = document.activeElement;
      if (!s.contains(f)) {
        const v = new CustomEvent(Wo, Ss);
        s.addEventListener(Wo, l), s.dispatchEvent(v), v.defaultPrevented || (dv(mv(Yl(s)), {
          select: !0
        }), document.activeElement === f && Rt(s));
      }
      return () => {
        s.removeEventListener(Wo, l), setTimeout(() => {
          const v = new CustomEvent(Qo, Ss);
          s.addEventListener(Qo, u), s.dispatchEvent(v), v.defaultPrevented || Rt(f ?? document.body, {
            select: !0
          }), s.removeEventListener(Qo, u), Ps.remove(p);
        }, 0);
      };
    }
  }, [
    s,
    l,
    u,
    p
  ]);
  const h = W((f) => {
    if (!n && !r || p.paused)
      return;
    const g = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, v = document.activeElement;
    if (g && v) {
      const b = f.currentTarget, [w, C] = uv(b);
      w && C ? !f.shiftKey && v === C ? (f.preventDefault(), n && Rt(w, {
        select: !0
      })) : f.shiftKey && v === w && (f.preventDefault(), n && Rt(C, {
        select: !0
      })) : v === b && f.preventDefault();
    }
  }, [
    n,
    r,
    p.paused
  ]);
  return /* @__PURE__ */ A(ce.div, O({
    tabIndex: -1
  }, a, {
    ref: m,
    onKeyDown: h
  }));
});
function dv(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Rt(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function uv(e) {
  const t = Yl(e), n = Rs(t, e), r = Rs(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Yl(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Rs(e, t) {
  for (const n of e)
    if (!fv(n, {
      upTo: t
    }))
      return n;
}
function fv(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function pv(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Rt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && pv(e) && t && e.select();
  }
}
const Ps = hv();
function hv() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Ds(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Ds(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Ds(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function mv(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Hl = "Popover", [Ul, AC] = ke(Hl, [
  yn
]), ao = yn(), [gv, Zt] = Ul(Hl), vv = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: a = !1 } = e, s = ao(t), c = N(null), [l, u] = V(!1), [d = !1, m] = Ye({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ A(ia, s, /* @__PURE__ */ A(gv, {
    scope: t,
    contentId: Wt(),
    triggerRef: c,
    open: d,
    onOpenChange: m,
    onOpenToggle: W(
      () => m(
        (p) => !p
      ),
      [
        m
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: W(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: W(
      () => u(!1),
      []
    ),
    modal: a
  }, n));
}, bv = "PopoverTrigger", Av = /* @__PURE__ */ S((e, t) => {
  const { __scopePopover: n, ...r } = e, o = Zt(bv, n), i = ao(n), a = ve(t, o.triggerRef), s = /* @__PURE__ */ A(ce.button, O({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": jl(o.open)
  }, r, {
    ref: a,
    onClick: _(e.onClick, o.onOpenToggle)
  }));
  return o.hasCustomAnchor ? s : /* @__PURE__ */ A(aa, O({
    asChild: !0
  }, i), s);
}), Wl = "PopoverPortal", [yv, wv] = Ul(Wl, {
  forceMount: void 0
}), xv = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = Zt(Wl, t);
  return /* @__PURE__ */ A(yv, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ A(st, {
    present: n || i.open
  }, /* @__PURE__ */ A(qr, {
    asChild: !0,
    container: o
  }, r)));
}, Wn = "PopoverContent", Ev = /* @__PURE__ */ S((e, t) => {
  const n = wv(Wn, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = Zt(Wn, e.__scopePopover);
  return /* @__PURE__ */ A(st, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ A(Cv, O({}, o, {
    ref: t
  })) : /* @__PURE__ */ A(Iv, O({}, o, {
    ref: t
  })));
}), Cv = /* @__PURE__ */ S((e, t) => {
  const n = Zt(Wn, e.__scopePopover), r = N(null), o = ve(t, r), i = N(!1);
  return Y(() => {
    const a = r.current;
    if (a)
      return Zr(a);
  }, []), /* @__PURE__ */ A(eo, {
    as: Ut,
    allowPinchZoom: !0
  }, /* @__PURE__ */ A(Ql, O({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: _(e.onCloseAutoFocus, (a) => {
      var s;
      a.preventDefault(), i.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: _(e.onPointerDownOutside, (a) => {
      const s = a.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
      i.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: _(
      e.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), Iv = /* @__PURE__ */ S((e, t) => {
  const n = Zt(Wn, e.__scopePopover), r = N(!1), o = N(!1);
  return /* @__PURE__ */ A(Ql, O({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, i), !i.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const c = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), Ql = /* @__PURE__ */ S((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, disableOutsidePointerEvents: a, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: u, ...d } = e, m = Zt(Wn, n), p = ao(n);
  return cv(), /* @__PURE__ */ A(lv, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ A(Kr, {
    asChild: !0,
    disableOutsidePointerEvents: a,
    onInteractOutside: u,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: l,
    onDismiss: () => m.onOpenChange(!1)
  }, /* @__PURE__ */ A(sa, O({
    "data-state": jl(m.open),
    role: "dialog",
    id: m.contentId
  }, p, d, {
    ref: t,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), Tv = "PopoverClose", Ov = /* @__PURE__ */ S((e, t) => {
  const { __scopePopover: n, ...r } = e, o = Zt(Tv, n);
  return /* @__PURE__ */ A(ce.button, O({
    type: "button"
  }, r, {
    ref: t,
    onClick: _(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
}), Sv = /* @__PURE__ */ S((e, t) => {
  const { __scopePopover: n, ...r } = e, o = ao(n);
  return /* @__PURE__ */ A(ca, O({}, o, r, {
    ref: t
  }));
});
function jl(e) {
  return e ? "open" : "closed";
}
const Rv = vv, Pv = Av, Dv = xv, Mv = Ev, Nv = Ov, Fv = Sv, $v = Re`
    0% { opacity: 0; transform: 'translateY(2px)' };
    100% { opacity: 1; transform: 'translateY(0)' };
`, kv = Re`
    0% { opacity: 0; transform: 'translateX(-2px)' };
    100% { opacity: 1; transform: 'translateX(0)' };
`, Bv = Re`
    0% { opacity: 0; transform: 'translateY(-2px)' };
    100% { opacity: 1; transform: 'translateY(0)' };
`, Lv = Re`
    0% { opacity: 0; transform: 'translateX(2px)' };
    100% { opacity: 1; transform: 'translateX(0)' };
`, zv = I(Mv)`
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  background-color: ${E.white300};
  border-radius: ${le.xs};
  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  color: ${E.black300};
  font-size: 15px;
  line-height: 1;
  padding: 10px 15px;
  user-select: none;
  will-change: transform, opacity;

  ${({ $zIndex: e }) => e !== void 0 && j`
      z-index: ${e};
    `}

  @media (prefers-reduced-motion: no-preference) {
    animation-duration: 400ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
    &[data-state='open'] {
      &[data-side='top'] {
        animation-name: ${Bv};
      }

      &[data-side='right'] {
        animation-name: ${Lv};
      }

      &[data-side='bottom'] {
        animation-name: ${$v};
      }

      &[data-side='left'] {
        animation-name: ${kv};
      }
    }
  }
`, Gv = I.button`
  all: unset;
  align-items: center;
  border-radius: ${le.full};
  color: ${E.black300};
  display: inline-flex;
  font-family: inherit;
  height: 25px;
  justify-content: center;
  position: absolute;
  right: 5px;
  top: 5px;
  width: 25px;

  &:hover {
    background-color: ${E.backgroundHover};
  }
  &:focus {
    box-shadow: ${Zn.modal};
  }
`, Yv = I(_i)``, Hv = I(Fv)`
  fill: ${E.white300};
`, yC = ({
  children: e,
  dataCy: t = "popover-field",
  hiddenCloseButton: n = !1,
  trigger: r,
  zIndex: o,
  ...i
}) => /* @__PURE__ */ J(Rv, { ...i, children: [
  /* @__PURE__ */ x(Pv, { asChild: !0, children: r }),
  /* @__PURE__ */ x(Dv, { children: /* @__PURE__ */ J(zv, { $zIndex: o, sideOffset: 5, "data-cy": t, children: [
    e,
    /* @__PURE__ */ x(Nv, { asChild: !0, children: !n && /* @__PURE__ */ x(Gv, { "aria-label": "Close", "data-cy": "button-closeModal", children: /* @__PURE__ */ x(Yv, {}) }) }),
    /* @__PURE__ */ x(Hv, {})
  ] }) })
] });
function Ms(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Oe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Kl(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = /* @__PURE__ */ $e(a), c = n.length;
    n = [
      ...n,
      a
    ];
    function l(d) {
      const { scope: m, children: p, ...h } = d, f = (m == null ? void 0 : m[e][c]) || s, g = xe(
        () => h,
        Object.values(h)
      );
      return /* @__PURE__ */ A(f.Provider, {
        value: g
      }, p);
    }
    function u(d, m) {
      const p = (m == null ? void 0 : m[e][c]) || s, h = Je(p);
      if (h)
        return h;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [
      l,
      u
    ];
  }
  const o = () => {
    const i = n.map((a) => /* @__PURE__ */ $e(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return xe(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    Uv(o, ...t)
  ];
}
function Uv(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const a = r.reduce((s, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return {
          ...s,
          ...d
        };
      }, {});
      return xe(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Wv(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Vl(...e) {
  return (t) => e.forEach(
    (n) => Wv(n, t)
  );
}
function je(...e) {
  return W(Vl(...e), e);
}
const Qn = /* @__PURE__ */ S((e, t) => {
  const { children: n, ...r } = e, o = be.toArray(n), i = o.find(jv);
  if (i) {
    const a = i.props.children, s = o.map((c) => c === i ? be.count(a) > 1 ? be.only(null) : /* @__PURE__ */ Me(a) ? a.props.children : null : c);
    return /* @__PURE__ */ A(wi, O({}, r, {
      ref: t
    }), /* @__PURE__ */ Me(a) ? /* @__PURE__ */ at(a, void 0, s) : null);
  }
  return /* @__PURE__ */ A(wi, O({}, r, {
    ref: t
  }), n);
});
Qn.displayName = "Slot";
const wi = /* @__PURE__ */ S((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Me(n) ? /* @__PURE__ */ at(n, {
    ...Kv(r, n.props),
    ref: Vl(t, n.ref)
  }) : be.count(n) > 1 ? be.only(null) : null;
});
wi.displayName = "SlotClone";
const Qv = ({ children: e }) => /* @__PURE__ */ A(Ze, null, e);
function jv(e) {
  return /* @__PURE__ */ Me(e) && e.type === Qv;
}
function Kv(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function Vv(e) {
  const t = e + "CollectionProvider", [n, r] = Kl(t), [o, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (p) => {
    const { scope: h, children: f } = p, g = $.useRef(null), v = $.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ $.createElement(o, {
      scope: h,
      itemMap: v,
      collectionRef: g
    }, f);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ $.forwardRef((p, h) => {
    const { scope: f, children: g } = p, v = i(s, f), b = je(h, v.collectionRef);
    return /* @__PURE__ */ $.createElement(Qn, {
      ref: b
    }, g);
  }), l = e + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ $.forwardRef((p, h) => {
    const { scope: f, children: g, ...v } = p, b = $.useRef(null), w = je(h, b), C = i(l, f);
    return $.useEffect(() => (C.itemMap.set(b, {
      ref: b,
      ...v
    }), () => void C.itemMap.delete(b))), /* @__PURE__ */ $.createElement(Qn, {
      [u]: "",
      ref: w
    }, g);
  });
  function m(p) {
    const h = i(e + "CollectionConsumer", p);
    return $.useCallback(() => {
      const g = h.collectionRef.current;
      if (!g)
        return [];
      const v = Array.from(g.querySelectorAll(`[${u}]`));
      return Array.from(h.itemMap.values()).sort(
        (C, T) => v.indexOf(C.ref.current) - v.indexOf(T.ref.current)
      );
    }, [
      h.collectionRef,
      h.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: c,
      ItemSlot: d
    },
    m,
    r
  ];
}
const Xv = /* @__PURE__ */ $e(void 0);
function qv(e) {
  const t = Je(Xv);
  return e || t || "ltr";
}
const Jv = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], _e = Jv.reduce((e, t) => {
  const n = /* @__PURE__ */ S((r, o) => {
    const { asChild: i, ...a } = r, s = i ? Qn : t;
    return Y(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ A(s, O({}, a, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function Zv(e, t) {
  e && qn(
    () => e.dispatchEvent(t)
  );
}
function En(e) {
  const t = N(e);
  return Y(() => {
    t.current = e;
  }), xe(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function _v(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = En(e);
  Y(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const xi = "dismissableLayer.update", eb = "dismissableLayer.pointerDownOutside", tb = "dismissableLayer.focusOutside";
let Ns;
const nb = /* @__PURE__ */ $e({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), rb = /* @__PURE__ */ S((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...l } = e, u = Je(nb), [d, m] = V(null), p = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, h] = V({}), f = je(
    t,
    (R) => m(R)
  ), g = Array.from(u.layers), [v] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), b = g.indexOf(v), w = d ? g.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, T = w >= b, P = ob((R) => {
    const G = R.target, Q = [
      ...u.branches
    ].some(
      (U) => U.contains(G)
    );
    !T || Q || (i == null || i(R), s == null || s(R), R.defaultPrevented || c == null || c());
  }, p), M = ib((R) => {
    const G = R.target;
    [
      ...u.branches
    ].some(
      (U) => U.contains(G)
    ) || (a == null || a(R), s == null || s(R), R.defaultPrevented || c == null || c());
  }, p);
  return _v((R) => {
    w === u.layers.size - 1 && (o == null || o(R), !R.defaultPrevented && c && (R.preventDefault(), c()));
  }, p), Y(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Ns = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), Fs(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = Ns);
      };
  }, [
    d,
    p,
    r,
    u
  ]), Y(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), Fs());
  }, [
    d,
    u
  ]), Y(() => {
    const R = () => h({});
    return document.addEventListener(xi, R), () => document.removeEventListener(xi, R);
  }, []), /* @__PURE__ */ A(_e.div, O({}, l, {
    ref: f,
    style: {
      pointerEvents: C ? T ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Oe(e.onFocusCapture, M.onFocusCapture),
    onBlurCapture: Oe(e.onBlurCapture, M.onBlurCapture),
    onPointerDownCapture: Oe(e.onPointerDownCapture, P.onPointerDownCapture)
  }));
});
function ob(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = En(e), r = N(!1), o = N(() => {
  });
  return Y(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Xl(eb, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, {
          once: !0
        })) : l();
      }
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function ib(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = En(e), r = N(!1);
  return Y(() => {
    const o = (i) => {
      i.target && !r.current && Xl(tb, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Fs() {
  const e = new CustomEvent(xi);
  document.dispatchEvent(e);
}
function Xl(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? Zv(o, i) : o.dispatchEvent(i);
}
const yt = globalThis != null && globalThis.document ? Yr : () => {
}, ab = q["useId".toString()] || (() => {
});
let sb = 0;
function ql(e) {
  const [t, n] = q.useState(ab());
  return yt(() => {
    e || n(
      (r) => r ?? String(sb++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const cb = /* @__PURE__ */ S((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ Hi.createPortal(/* @__PURE__ */ A(_e.div, O({}, o, {
    ref: t
  })), r) : null;
});
function $s({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = lb({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : r, s = En(n), c = W((l) => {
    if (i) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && s(d);
    } else
      o(l);
  }, [
    i,
    e,
    o,
    s
  ]);
  return [
    a,
    c
  ];
}
function lb({ defaultProp: e, onChange: t }) {
  const n = V(e), [r] = n, o = N(r), i = En(t);
  return Y(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function db(e) {
  const t = N({
    value: e,
    previous: e
  });
  return xe(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const ub = /* @__PURE__ */ S((e, t) => /* @__PURE__ */ A(_e.span, O({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), fb = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], pb = [
  " ",
  "Enter"
], so = "Select", [co, ga, hb] = Vv(so), [or, wC] = Kl(so, [
  hb
]), [mb, Cn] = or(so), [gb, vb] = or(so), bb = (e) => {
  const { __scopeSelect: t, children: n, open: r, defaultOpen: o, onOpenChange: i, value: a, defaultValue: s, onValueChange: c, dir: l, name: u, autoComplete: d, disabled: m, required: p } = e, [h, f] = V(null), [g, v] = V(null), [b, w] = V(!1), C = qv(l), [T = !1, P] = $s({
    prop: r,
    defaultProp: o,
    onChange: i
  }), [M, R] = $s({
    prop: a,
    defaultProp: s,
    onChange: c
  }), G = N(null), Q = h ? !!h.closest("form") : !0, [U, te] = V(/* @__PURE__ */ new Set()), X = Array.from(U).map(
    (F) => F.props.value
  ).join(";");
  return /* @__PURE__ */ A(mb, {
    required: p,
    scope: t,
    trigger: h,
    onTriggerChange: f,
    valueNode: g,
    onValueNodeChange: v,
    valueNodeHasChildren: b,
    onValueNodeHasChildrenChange: w,
    contentId: ql(),
    value: M,
    onValueChange: R,
    open: T,
    onOpenChange: P,
    dir: C,
    triggerPointerDownPosRef: G,
    disabled: m
  }, /* @__PURE__ */ A(co.Provider, {
    scope: t
  }, /* @__PURE__ */ A(gb, {
    scope: e.__scopeSelect,
    onNativeOptionAdd: W((F) => {
      te(
        (L) => new Set(L).add(F)
      );
    }, []),
    onNativeOptionRemove: W((F) => {
      te((L) => {
        const z = new Set(L);
        return z.delete(F), z;
      });
    }, [])
  }, n)), Q ? /* @__PURE__ */ A(td, {
    key: X,
    "aria-hidden": !0,
    required: p,
    tabIndex: -1,
    name: u,
    autoComplete: d,
    value: M,
    onChange: (F) => R(F.target.value),
    disabled: m
  }, M === void 0 ? /* @__PURE__ */ A("option", {
    value: ""
  }) : null, Array.from(U)) : null);
}, Ab = "SelectTrigger", yb = /* @__PURE__ */ S((e, t) => {
  const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = Cn(Ab, n), a = i.disabled || r, s = je(t, i.onTriggerChange), c = ga(n), [l, u, d] = nd((p) => {
    const h = c().filter(
      (v) => !v.disabled
    ), f = h.find(
      (v) => v.value === i.value
    ), g = rd(h, p, f);
    g !== void 0 && i.onValueChange(g.value);
  }), m = () => {
    a || (i.onOpenChange(!0), d());
  };
  return /* @__PURE__ */ A(_e.button, O({
    type: "button",
    role: "combobox",
    "aria-controls": i.contentId,
    "aria-expanded": i.open,
    "aria-required": i.required,
    "aria-autocomplete": "none",
    dir: i.dir,
    "data-state": i.open ? "open" : "closed",
    disabled: a,
    "data-disabled": a ? "" : void 0,
    "data-placeholder": i.value === void 0 ? "" : void 0
  }, o, {
    ref: s,
    onClick: Oe(o.onClick, (p) => {
      p.currentTarget.focus();
    }),
    onPointerDown: Oe(o.onPointerDown, (p) => {
      p.target.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && (m(), i.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      }, p.preventDefault());
    }),
    onKeyDown: Oe(o.onKeyDown, (p) => {
      const h = l.current !== "";
      !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && u(p.key), !(h && p.key === " ") && fb.includes(p.key) && (m(), p.preventDefault());
    })
  }));
}), wb = "SelectValue", xb = /* @__PURE__ */ S((e, t) => {
  const { __scopeSelect: n, className: r, style: o, children: i, placeholder: a, ...s } = e, c = Cn(wb, n), { onValueNodeHasChildrenChange: l } = c, u = i !== void 0, d = je(t, c.onValueNodeChange);
  return yt(() => {
    l(u);
  }, [
    l,
    u
  ]), /* @__PURE__ */ A(_e.span, O({}, s, {
    ref: d,
    style: {
      pointerEvents: "none"
    }
  }), c.value === void 0 && a !== void 0 ? a : i);
}), Eb = /* @__PURE__ */ S((e, t) => {
  const { __scopeSelect: n, children: r, ...o } = e;
  return /* @__PURE__ */ A(_e.span, O({
    "aria-hidden": !0
  }, o, {
    ref: t
  }), r || "▼");
}), Cb = (e) => /* @__PURE__ */ A(cb, O({
  asChild: !0
}, e)), va = "SelectContent", Ib = /* @__PURE__ */ S((e, t) => {
  const n = Cn(va, e.__scopeSelect), [r, o] = V();
  return yt(() => {
    o(new DocumentFragment());
  }, []), /* @__PURE__ */ A(Ze, null, n.open ? /* @__PURE__ */ A(Tb, O({}, e, {
    ref: t
  })) : r ? /* @__PURE__ */ Ui(/* @__PURE__ */ A(Jl, {
    scope: e.__scopeSelect
  }, /* @__PURE__ */ A(co.Slot, {
    scope: e.__scopeSelect
  }, /* @__PURE__ */ A("div", null, e.children))), r) : null);
}), Pt = 10, [Jl, In] = or(va), Tb = /* @__PURE__ */ S((e, t) => {
  const { __scopeSelect: n, onCloseAutoFocus: r, ...o } = e, i = Cn(va, n), [a, s] = V(null), [c, l] = V(null), [u, d] = V(null), m = je(
    t,
    (B) => l(B)
  ), [p, h] = V(null), [f, g] = V(null), v = ga(n), [b, w] = V(!1), C = N(!0), T = N(!1), P = N(!1);
  Y(() => {
    if (c)
      return Zr(c);
  }, [
    c
  ]), Nl();
  const [M, R] = V();
  yt(() => {
    c && R(window.getComputedStyle(c).zIndex);
  }, [
    c
  ]);
  const G = W((B) => {
    const [ee, ...se] = v().map(
      (ue) => ue.ref.current
    ), [re] = se.slice(-1), ie = document.activeElement;
    for (const ue of B)
      if (ue === ie || (ue == null || ue.scrollIntoView({
        block: "nearest"
      }), ue === ee && u && (u.scrollTop = 0), ue === re && u && (u.scrollTop = u.scrollHeight), ue == null || ue.focus(), document.activeElement !== ie))
        return;
  }, [
    v,
    u
  ]), Q = W(() => {
    if (i.trigger && i.valueNode && a && c && u && p && f) {
      const B = i.trigger.getBoundingClientRect(), ee = c.getBoundingClientRect(), se = i.valueNode.getBoundingClientRect(), re = f.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const ut = re.left - ee.left, Ke = se.left - ut, tt = B.left - Ke, Be = B.width + tt, Pn = Math.max(Be, ee.width), tn = window.innerWidth - Pt, nn = Ms(Ke, [
          Pt,
          tn - Pn
        ]);
        a.style.minWidth = Be + "px", a.style.left = nn + "px";
      } else {
        const ut = ee.right - re.right, Ke = window.innerWidth - se.right - ut, tt = window.innerWidth - B.right - Ke, Be = B.width + tt, Pn = Math.max(Be, ee.width), tn = window.innerWidth - Pt, nn = Ms(Ke, [
          Pt,
          tn - Pn
        ]);
        a.style.minWidth = Be + "px", a.style.right = nn + "px";
      }
      const ie = v(), ue = window.innerHeight - Pt * 2, Te = u.scrollHeight, ye = window.getComputedStyle(c), De = parseInt(ye.borderTopWidth, 10), Ce = parseInt(ye.paddingTop, 10), He = parseInt(ye.borderBottomWidth, 10), On = parseInt(ye.paddingBottom, 10), kt = De + Ce + Te + On + He, Sn = Math.min(p.offsetHeight * 5, kt), wt = window.getComputedStyle(u), xt = parseInt(wt.paddingTop, 10), Et = parseInt(wt.paddingBottom, 10), dt = B.top + B.height / 2 - Pt, _t = ue - dt, et = p.offsetHeight / 2, Ct = p.offsetTop + et, en = De + Ce + Ct, Rn = kt - en;
      if (en <= dt) {
        const ut = p === ie[ie.length - 1].ref.current;
        a.style.bottom = "0px";
        const Ke = c.clientHeight - u.offsetTop - u.offsetHeight, tt = Math.max(_t, et + (ut ? Et : 0) + Ke + He), Be = en + tt;
        a.style.height = Be + "px";
      } else {
        const ut = p === ie[0].ref.current;
        a.style.top = "0px";
        const tt = Math.max(dt, De + u.offsetTop + (ut ? xt : 0) + et) + Rn;
        a.style.height = tt + "px", u.scrollTop = en - dt + u.offsetTop;
      }
      a.style.margin = `${Pt}px 0`, a.style.minHeight = Sn + "px", a.style.maxHeight = ue + "px", w(!0), requestAnimationFrame(
        () => T.current = !0
      );
    }
  }, [
    v,
    i.trigger,
    i.valueNode,
    a,
    c,
    u,
    p,
    f,
    i.dir
  ]);
  yt(
    () => Q(),
    [
      Q
    ]
  );
  const U = W(
    () => G([
      p,
      c
    ]),
    [
      G,
      p,
      c
    ]
  );
  Y(() => {
    b && U();
  }, [
    b,
    U
  ]);
  const te = W((B) => {
    B && C.current === !0 && (Q(), U(), C.current = !1);
  }, [
    Q,
    U
  ]), { onOpenChange: X, triggerPointerDownPosRef: F } = i;
  Y(() => {
    if (c) {
      let B = {
        x: 0,
        y: 0
      };
      const ee = (re) => {
        var ie, ue, Te, ye;
        B = {
          x: Math.abs(Math.round(re.pageX) - ((ie = (ue = F.current) === null || ue === void 0 ? void 0 : ue.x) !== null && ie !== void 0 ? ie : 0)),
          y: Math.abs(Math.round(re.pageY) - ((Te = (ye = F.current) === null || ye === void 0 ? void 0 : ye.y) !== null && Te !== void 0 ? Te : 0))
        };
      }, se = (re) => {
        B.x <= 10 && B.y <= 10 ? re.preventDefault() : c.contains(re.target) || X(!1), document.removeEventListener("pointermove", ee), F.current = null;
      };
      return F.current !== null && (document.addEventListener("pointermove", ee), document.addEventListener("pointerup", se, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", ee), document.removeEventListener("pointerup", se, {
          capture: !0
        });
      };
    }
  }, [
    c,
    X,
    F
  ]), Y(() => {
    const B = () => X(!1);
    return window.addEventListener("blur", B), window.addEventListener("resize", B), () => {
      window.removeEventListener("blur", B), window.removeEventListener("resize", B);
    };
  }, [
    X
  ]);
  const [L, z] = nd((B) => {
    const ee = v().filter(
      (ie) => !ie.disabled
    ), se = ee.find(
      (ie) => ie.ref.current === document.activeElement
    ), re = rd(ee, B, se);
    re && setTimeout(
      () => re.ref.current.focus()
    );
  }), Z = W((B, ee, se) => {
    const re = !P.current && !se;
    (i.value !== void 0 && i.value === ee || re) && (h(B), re && (P.current = !0));
  }, [
    i.value
  ]), ne = W(
    () => c == null ? void 0 : c.focus(),
    [
      c
    ]
  ), K = W((B, ee, se) => {
    const re = !P.current && !se;
    (i.value !== void 0 && i.value === ee || re) && g(B);
  }, [
    i.value
  ]);
  return /* @__PURE__ */ A(Jl, {
    scope: n,
    contentWrapper: a,
    content: c,
    viewport: u,
    onViewportChange: d,
    itemRefCallback: Z,
    selectedItem: p,
    onItemLeave: ne,
    itemTextRefCallback: K,
    selectedItemText: f,
    onScrollButtonChange: te,
    isPositioned: b,
    shouldExpandOnScrollRef: T,
    searchRef: L
  }, /* @__PURE__ */ A(eo, {
    as: Qn,
    allowPinchZoom: !0
  }, /* @__PURE__ */ A("div", {
    ref: s,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: M
    }
  }, /* @__PURE__ */ A(Dl, {
    asChild: !0,
    trapped: i.open,
    onMountAutoFocus: (B) => {
      B.preventDefault();
    },
    onUnmountAutoFocus: Oe(r, (B) => {
      var ee;
      (ee = i.trigger) === null || ee === void 0 || ee.focus({
        preventScroll: !0
      }), B.preventDefault();
    })
  }, /* @__PURE__ */ A(rb, O({
    role: "listbox",
    id: i.contentId,
    "data-state": i.open ? "open" : "closed",
    dir: i.dir,
    onContextMenu: (B) => B.preventDefault()
  }, o, {
    ref: m,
    style: {
      display: "flex",
      flexDirection: "column",
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      maxHeight: "100%",
      outline: "none",
      ...o.style
    },
    disableOutsidePointerEvents: !0,
    onFocusOutside: (B) => B.preventDefault(),
    onDismiss: () => i.onOpenChange(!1),
    onKeyDown: Oe(o.onKeyDown, (B) => {
      const ee = B.ctrlKey || B.altKey || B.metaKey;
      if (B.key === "Tab" && B.preventDefault(), !ee && B.key.length === 1 && z(B.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(B.key)) {
        let re = v().filter(
          (ie) => !ie.disabled
        ).map(
          (ie) => ie.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(B.key) && (re = re.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(B.key)) {
          const ie = B.target, ue = re.indexOf(ie);
          re = re.slice(ue + 1);
        }
        setTimeout(
          () => G(re)
        ), B.preventDefault();
      }
    })
  }))))));
}), Ob = "SelectViewport", Sb = /* @__PURE__ */ S((e, t) => {
  const { __scopeSelect: n, ...r } = e, o = In(Ob, n), i = je(t, o.onViewportChange), a = N(0);
  return /* @__PURE__ */ A(Ze, null, /* @__PURE__ */ A("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ A(co.Slot, {
    scope: n
  }, /* @__PURE__ */ A(_e.div, O({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, r, {
    ref: i,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...r.style
    },
    onScroll: Oe(r.onScroll, (s) => {
      const c = s.currentTarget, { contentWrapper: l, shouldExpandOnScrollRef: u } = o;
      if (u != null && u.current && l) {
        const d = Math.abs(a.current - c.scrollTop);
        if (d > 0) {
          const m = window.innerHeight - Pt * 2, p = parseFloat(l.style.minHeight), h = parseFloat(l.style.height), f = Math.max(p, h);
          if (f < m) {
            const g = f + d, v = Math.min(m, g), b = g - v;
            l.style.height = v + "px", l.style.bottom === "0px" && (c.scrollTop = b > 0 ? b : 0, l.style.justifyContent = "flex-end");
          }
        }
      }
      a.current = c.scrollTop;
    })
  }))));
}), Rb = "SelectGroup";
or(Rb);
const Ei = "SelectItem", [Pb, Zl] = or(Ei), Db = /* @__PURE__ */ S((e, t) => {
  const { __scopeSelect: n, value: r, disabled: o = !1, textValue: i, ...a } = e, s = Cn(Ei, n), c = In(Ei, n), l = s.value === r, [u, d] = V(i ?? ""), [m, p] = V(!1), h = je(t, (v) => {
    var b;
    return (b = c.itemRefCallback) === null || b === void 0 ? void 0 : b.call(c, v, r, o);
  }), f = ql(), g = () => {
    o || (s.onValueChange(r), s.onOpenChange(!1));
  };
  return /* @__PURE__ */ A(Pb, {
    scope: n,
    value: r,
    disabled: o,
    textId: f,
    isSelected: l,
    onItemTextChange: W((v) => {
      d((b) => {
        var w;
        return b || ((w = v == null ? void 0 : v.textContent) !== null && w !== void 0 ? w : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ A(co.ItemSlot, {
    scope: n,
    value: r,
    disabled: o,
    textValue: u
  }, /* @__PURE__ */ A(_e.div, O({
    role: "option",
    "aria-labelledby": f,
    "data-highlighted": m ? "" : void 0,
    "aria-selected": l && m,
    "data-state": l ? "checked" : "unchecked",
    "aria-disabled": o || void 0,
    "data-disabled": o ? "" : void 0,
    tabIndex: o ? void 0 : -1
  }, a, {
    ref: h,
    onFocus: Oe(
      a.onFocus,
      () => p(!0)
    ),
    onBlur: Oe(
      a.onBlur,
      () => p(!1)
    ),
    onPointerUp: Oe(a.onPointerUp, g),
    onPointerMove: Oe(a.onPointerMove, (v) => {
      if (o) {
        var b;
        (b = c.onItemLeave) === null || b === void 0 || b.call(c);
      } else
        v.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: Oe(a.onPointerLeave, (v) => {
      if (v.currentTarget === document.activeElement) {
        var b;
        (b = c.onItemLeave) === null || b === void 0 || b.call(c);
      }
    }),
    onKeyDown: Oe(a.onKeyDown, (v) => {
      var b;
      ((b = c.searchRef) === null || b === void 0 ? void 0 : b.current) !== "" && v.key === " " || (pb.includes(v.key) && g(), v.key === " " && v.preventDefault());
    })
  }))));
}), gr = "SelectItemText", Mb = /* @__PURE__ */ S((e, t) => {
  const { __scopeSelect: n, className: r, style: o, ...i } = e, a = Cn(gr, n), s = In(gr, n), c = Zl(gr, n), l = vb(gr, n), [u, d] = V(null), m = je(
    t,
    (v) => d(v),
    c.onItemTextChange,
    (v) => {
      var b;
      return (b = s.itemTextRefCallback) === null || b === void 0 ? void 0 : b.call(s, v, c.value, c.disabled);
    }
  ), p = u == null ? void 0 : u.textContent, h = xe(
    () => /* @__PURE__ */ A("option", {
      key: c.value,
      value: c.value,
      disabled: c.disabled
    }, p),
    [
      c.disabled,
      c.value,
      p
    ]
  ), { onNativeOptionAdd: f, onNativeOptionRemove: g } = l;
  return yt(() => (f(h), () => g(h)), [
    f,
    g,
    h
  ]), /* @__PURE__ */ A(Ze, null, /* @__PURE__ */ A(_e.span, O({
    id: c.textId
  }, i, {
    ref: m
  })), c.isSelected && a.valueNode && !a.valueNodeHasChildren ? /* @__PURE__ */ Ui(i.children, a.valueNode) : null);
}), Nb = "SelectItemIndicator", _l = /* @__PURE__ */ S((e, t) => {
  const { __scopeSelect: n, ...r } = e;
  return Zl(Nb, n).isSelected ? /* @__PURE__ */ A(_e.span, O({
    "aria-hidden": !0
  }, r, {
    ref: t
  })) : null;
}), Fb = "SelectScrollUpButton", $b = /* @__PURE__ */ S((e, t) => {
  const n = In(Fb, e.__scopeSelect), [r, o] = V(!1), i = je(t, n.onScrollButtonChange);
  return yt(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = a.scrollTop > 0;
        o(c);
      };
      const a = n.viewport;
      return s(), a.addEventListener("scroll", s), () => a.removeEventListener("scroll", s);
    }
  }, [
    n.viewport,
    n.isPositioned
  ]), r ? /* @__PURE__ */ A(ed, O({}, e, {
    ref: i,
    onAutoScroll: () => {
      const { viewport: a, selectedItem: s } = n;
      a && s && (a.scrollTop = a.scrollTop - s.offsetHeight);
    }
  })) : null;
}), kb = "SelectScrollDownButton", Bb = /* @__PURE__ */ S((e, t) => {
  const n = In(kb, e.__scopeSelect), [r, o] = V(!1), i = je(t, n.onScrollButtonChange);
  return yt(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = a.scrollHeight - a.clientHeight, l = Math.ceil(a.scrollTop) < c;
        o(l);
      };
      const a = n.viewport;
      return s(), a.addEventListener("scroll", s), () => a.removeEventListener("scroll", s);
    }
  }, [
    n.viewport,
    n.isPositioned
  ]), r ? /* @__PURE__ */ A(ed, O({}, e, {
    ref: i,
    onAutoScroll: () => {
      const { viewport: a, selectedItem: s } = n;
      a && s && (a.scrollTop = a.scrollTop + s.offsetHeight);
    }
  })) : null;
}), ed = /* @__PURE__ */ S((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = In("SelectScrollButton", n), a = N(null), s = ga(n), c = W(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return Y(() => () => c(), [
    c
  ]), yt(() => {
    var l;
    const u = s().find(
      (d) => d.ref.current === document.activeElement
    );
    u == null || (l = u.ref.current) === null || l === void 0 || l.scrollIntoView({
      block: "nearest"
    });
  }, [
    s
  ]), /* @__PURE__ */ A(_e.div, O({
    "aria-hidden": !0
  }, o, {
    ref: t,
    style: {
      flexShrink: 0,
      ...o.style
    },
    onPointerMove: Oe(o.onPointerMove, () => {
      var l;
      (l = i.onItemLeave) === null || l === void 0 || l.call(i), a.current === null && (a.current = window.setInterval(r, 50));
    }),
    onPointerLeave: Oe(o.onPointerLeave, () => {
      c();
    })
  }));
}), td = /* @__PURE__ */ S((e, t) => {
  const { value: n, ...r } = e, o = N(null), i = je(t, o), a = db(n);
  return Y(() => {
    const s = o.current, c = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(c, "value").set;
    if (a !== n && u) {
      const d = new Event("change", {
        bubbles: !0
      });
      u.call(s, n), s.dispatchEvent(d);
    }
  }, [
    a,
    n
  ]), /* @__PURE__ */ A(ub, {
    asChild: !0
  }, /* @__PURE__ */ A("select", O({}, r, {
    ref: i,
    defaultValue: n
  })));
});
td.displayName = "BubbleSelect";
function nd(e) {
  const t = En(e), n = N(""), r = N(0), o = W((a) => {
    const s = n.current + a;
    t(s), function c(l) {
      n.current = l, window.clearTimeout(r.current), l !== "" && (r.current = window.setTimeout(
        () => c(""),
        1e3
      ));
    }(s);
  }, [
    t
  ]), i = W(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return Y(() => () => window.clearTimeout(r.current), []), [
    n,
    o,
    i
  ];
}
function rd(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(
    (l) => l === t[0]
  ) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = Lb(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter(
    (l) => l !== n
  ));
  const c = a.find(
    (l) => l.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function Lb(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const zb = bb, Gb = yb, Yb = xb, Hb = Cb, Ub = Ib, od = Sb, id = Db, ad = Mb, sd = $b, cd = Bb, Wb = j`
  height: 2.25rem;
  border-radius: ${le.lg};
  &[data-placeholder] {
    font-style: italic;
  }
`, Qb = I(Gb)`
  width: 100%;
  align-items: center;
  background-color: ${E.white300};
  border-radius: ${le.px};
  border: 1px solid ${E.inputBorderLight};
  color: ${E.text};
  display: flex;
  font-size: 1rem;
  height: 2rem;
  justify-content: space-between;
  line-height: 1.1;
  outline: none;
  padding-right: 0.2rem;
  padding: 0 0.5rem;
  &[data-placeholder] {
    color: ${E.inputPlaceholder};
  }

  ${({ $themeStyle: e }) => e === "admin" && j`
      ${Wb}
    `}
`, jb = I(Ub)`
  background-color: ${E.white300};
  border-radius: ${le.sm};
  box-shadow: ${Zn.modal};
  min-width: 220;
  overflow: hidden;
  padding: 5px;

  ${({ $overwriteHeight: e }) => e !== void 0 && j`
      height: ${e}px !important;
    `}

  ${({ $zIndex: e }) => e !== void 0 && j`
      z-index: ${e};
    `}
`, Kb = I(Eb)`
  align-items: center;
  display: flex;
`, Vb = I(Jn)`
  color: ${E.text};
  height: 1rem;
  width: 1rem;
`, Xb = I(sd)`
  align-items: center;
  background-color: ${E.white300};
  color: ${E.blue300};
  cursor: default;
  display: flex;
  height: 1.625rem;
  justify-content: center;

  &:hover {
    background-color: ${E.backgroundHover};
  }
`, qb = I(Nc)`
  height: 1rem;
  width: 1rem;
`, Jb = I(od)`
  padding: 0.315rem;
`, Zb = I(id)`
  all: unset;
  align-items: center;
  border-radius: ${le.px};
  color: ${E.text};
  display: flex;
  font-size: 1rem;
  line-height: 1.1;
  padding: 0.375rem 35px 0.375rem 25px;
  position: relative;
  user-select: none;

  &[data-disabled] {
    color: ${E.gray200};
    pointer-events: none;
  }

  &[data-highlighted],
  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
`, _b = I(_l)`
  align-items: center;
  color: ${E.blue300};
  display: inline-flex;
  justify-content: center;
  left: 0px;
  position: absolute;
  width: 25px;

  &:active {
    background-color: rgba(0, 0, 0, 0.08);
  }
`, e1 = I(Fc)`
  height: 1.125rem;
  width: 1.125rem;
`, t1 = I(cd)`
  align-items: center;
  background-color: ${E.white300};
  color: ${E.blue300};
  cursor: default;
  display: flex;
  height: 25px;
  justify-content: center;

  &:hover {
    background-color: ${E.backgroundHover};
  }
`, n1 = I(Jn)`
  height: 1rem;
  width: 1rem;
`, ld = ({
  children: e,
  customContentStyle: t,
  overwritePortalHeight: n,
  dataCy: r = "select-field",
  onKeyPress: o,
  onKeyDown: i,
  placeholder: a = "Select…",
  themeStyle: s = "default",
  zIndex: c,
  ...l
}) => /* @__PURE__ */ J(zb, { "data-cy": "test", ...l, children: [
  /* @__PURE__ */ J(Qb, { "data-cy": r, $themeStyle: s, children: [
    /* @__PURE__ */ x(Yb, { "data-cy": a, placeholder: a }),
    /* @__PURE__ */ x(Kb, { "data-cy": "icon-container", children: /* @__PURE__ */ x(Vb, { "data-cy": "arrow-down" }) })
  ] }),
  /* @__PURE__ */ x(Hb, { "data-cy": "select-portal", children: /* @__PURE__ */ x(
    jb,
    {
      $overwriteHeight: n,
      $zIndex: c,
      "data-cy": "select-content-container",
      onKeyDown: i ?? o,
      style: t,
      children: e
    }
  ) })
] }), r1 = S(function({ ...t }, n) {
  return /* @__PURE__ */ x(ad, { ref: n, ...t });
}), o1 = S(function({ ...t }, n) {
  return /* @__PURE__ */ x(Xb, { ref: n, ...t, children: /* @__PURE__ */ x(qb, {}) });
}), i1 = S(function({ ...t }, n) {
  return /* @__PURE__ */ x(t1, { ref: n, ...t, children: /* @__PURE__ */ x(n1, {}) });
}), a1 = S(function({ children: t, ...n }, r) {
  return /* @__PURE__ */ x(_b, { ref: r, ...n, children: t ?? /* @__PURE__ */ x(e1, {}) });
}), s1 = S(function({ ...t }, n) {
  return /* @__PURE__ */ x(Jb, { ref: n, ...t });
}), c1 = S(function({ ...t }, n) {
  return /* @__PURE__ */ x(Zb, { ref: n, ...t });
}), dd = S(function({ ...t }, n) {
  return /* @__PURE__ */ x(Ut, { ...t, ref: n });
}), l1 = $.createContext({}), ud = !0;
function d1({ baseColor: e, highlightColor: t, width: n, height: r, borderRadius: o, circle: i, direction: a, duration: s, enableAnimation: c = ud }) {
  const l = {};
  return a === "rtl" && (l["--animation-direction"] = "reverse"), typeof s == "number" && (l["--animation-duration"] = `${s}s`), c || (l["--pseudo-element-display"] = "none"), (typeof n == "string" || typeof n == "number") && (l.width = n), (typeof r == "string" || typeof r == "number") && (l.height = r), (typeof o == "string" || typeof o == "number") && (l.borderRadius = o), i && (l.borderRadius = "50%"), typeof e < "u" && (l["--base-color"] = e), typeof t < "u" && (l["--highlight-color"] = t), l;
}
function u1({ count: e = 1, wrapper: t, className: n, containerClassName: r, containerTestId: o, circle: i = !1, style: a, ...s }) {
  var c, l, u;
  const d = $.useContext(l1), m = { ...s };
  for (const [w, C] of Object.entries(s))
    typeof C > "u" && delete m[w];
  const p = {
    ...d,
    ...m,
    circle: i
  }, h = {
    ...a,
    ...d1(p)
  };
  let f = "react-loading-skeleton";
  n && (f += ` ${n}`);
  const g = (c = p.inline) !== null && c !== void 0 ? c : !1, v = [], b = Math.ceil(e);
  for (let w = 0; w < b; w++) {
    let C = h;
    if (b > e && w === b - 1) {
      const P = (l = C.width) !== null && l !== void 0 ? l : "100%", M = e % 1, R = typeof P == "number" ? P * M : `calc(${P} * ${M})`;
      C = { ...C, width: R };
    }
    const T = $.createElement("span", { className: f, style: C, key: w }, "‌");
    g ? v.push(T) : v.push($.createElement(
      $.Fragment,
      { key: w },
      T,
      $.createElement("br", null)
    ));
  }
  return $.createElement("span", { className: r, "data-testid": o, "aria-live": "polite", "aria-busy": (u = p.enableAnimation) !== null && u !== void 0 ? u : ud }, t ? v.map((w, C) => $.createElement(t, { key: C }, w)) : v);
}
const xC = ({ ...e }) => /* @__PURE__ */ x(u1, { ...e }), fd = "Switch", [f1, EC] = ke(fd), [p1, h1] = f1(fd), m1 = /* @__PURE__ */ S((e, t) => {
  const { __scopeSwitch: n, name: r, checked: o, defaultChecked: i, required: a, disabled: s, value: c = "on", onCheckedChange: l, ...u } = e, [d, m] = V(null), p = ve(
    t,
    (b) => m(b)
  ), h = N(!1), f = d ? !!d.closest("form") : !0, [g = !1, v] = Ye({
    prop: o,
    defaultProp: i,
    onChange: l
  });
  return /* @__PURE__ */ A(p1, {
    scope: n,
    checked: g,
    disabled: s
  }, /* @__PURE__ */ A(ce.button, O({
    type: "button",
    role: "switch",
    "aria-checked": g,
    "aria-required": a,
    "data-state": pd(g),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: c
  }, u, {
    ref: p,
    onClick: _(e.onClick, (b) => {
      v(
        (w) => !w
      ), f && (h.current = b.isPropagationStopped(), h.current || b.stopPropagation());
    })
  })), f && /* @__PURE__ */ A(b1, {
    control: d,
    bubbles: !h.current,
    name: r,
    value: c,
    checked: g,
    required: a,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), g1 = "SwitchThumb", v1 = /* @__PURE__ */ S((e, t) => {
  const { __scopeSwitch: n, ...r } = e, o = h1(g1, n);
  return /* @__PURE__ */ A(ce.span, O({
    "data-state": pd(o.checked),
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: t
  }));
}), b1 = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, i = N(null), a = Bc(n), s = ta(t);
  return Y(() => {
    const c = i.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== n && d) {
      const m = new Event("click", {
        bubbles: r
      });
      d.call(c, n), c.dispatchEvent(m);
    }
  }, [
    a,
    n,
    r
  ]), /* @__PURE__ */ A("input", O({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: n
  }, o, {
    tabIndex: -1,
    ref: i,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function pd(e) {
  return e ? "checked" : "unchecked";
}
const A1 = m1, y1 = v1, w1 = I(A1)`
  width: 34px;
  height: 18px;
  background-color: ${E.gray300};
  border-radius: ${le.full};
  position: relative;
  box-shadow: 0 2px 10px ${E.gray100};
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &:focus {
    box-shadow: 0 0 0 2px ${E.gray100};
  }

  &[data-state='checked'] {
    background-color: ${E.green300};
  }
`, x1 = I(y1)`
  display: block;
  width: 12px;
  height: 12px;
  background-color: ${E.white300};
  border-radius: ${le.full};
  box-shadow: 0 2px 2px ${E.gray100};
  transition: transform 100ms;
  transform: translateX(2px);
  will-change: transform;

  &[data-state='checked'] {
    transform: translateX(16px);
  }
`, CC = ({
  dataCy: e = "switch-field",
  ...t
}) => /* @__PURE__ */ x(w1, { "data-cy": e, ...t, children: /* @__PURE__ */ x(x1, {}) }), hd = "ToastProvider", [ba, E1, C1] = Ur("Toast"), [md, IC] = ke("Toast", [
  C1
]), [I1, lo] = md(hd), gd = (e) => {
  const { __scopeToast: t, label: n = "Notification", duration: r = 5e3, swipeDirection: o = "right", swipeThreshold: i = 50, children: a } = e, [s, c] = V(null), [l, u] = V(0), d = N(!1), m = N(!1);
  return /* @__PURE__ */ A(ba.Provider, {
    scope: t
  }, /* @__PURE__ */ A(I1, {
    scope: t,
    label: n,
    duration: r,
    swipeDirection: o,
    swipeThreshold: i,
    toastCount: l,
    viewport: s,
    onViewportChange: c,
    onToastAdd: W(
      () => u(
        (p) => p + 1
      ),
      []
    ),
    onToastRemove: W(
      () => u(
        (p) => p - 1
      ),
      []
    ),
    isFocusedToastEscapeKeyDownRef: d,
    isClosePausedRef: m
  }, a));
};
gd.propTypes = {
  label(e) {
    if (e.label && typeof e.label == "string" && !e.label.trim()) {
      const t = `Invalid prop \`label\` supplied to \`${hd}\`. Expected non-empty \`string\`.`;
      return new Error(t);
    }
    return null;
  }
};
const T1 = "ToastViewport", O1 = [
  "F8"
], Ci = "toast.viewportPause", Ii = "toast.viewportResume", S1 = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: n, hotkey: r = O1, label: o = "Notifications ({hotkey})", ...i } = e, a = lo(T1, n), s = E1(n), c = N(null), l = N(null), u = N(null), d = N(null), m = ve(t, d, a.onViewportChange), p = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), h = a.toastCount > 0;
  Y(() => {
    const g = (v) => {
      var b;
      r.every(
        (C) => v[C] || v.code === C
      ) && ((b = d.current) === null || b === void 0 || b.focus());
    };
    return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
  }, [
    r
  ]), Y(() => {
    const g = c.current, v = d.current;
    if (h && g && v) {
      const b = () => {
        if (!a.isClosePausedRef.current) {
          const P = new CustomEvent(Ci);
          v.dispatchEvent(P), a.isClosePausedRef.current = !0;
        }
      }, w = () => {
        if (a.isClosePausedRef.current) {
          const P = new CustomEvent(Ii);
          v.dispatchEvent(P), a.isClosePausedRef.current = !1;
        }
      }, C = (P) => {
        !g.contains(P.relatedTarget) && w();
      }, T = () => {
        g.contains(document.activeElement) || w();
      };
      return g.addEventListener("focusin", b), g.addEventListener("focusout", C), g.addEventListener("pointermove", b), g.addEventListener("pointerleave", T), window.addEventListener("blur", b), window.addEventListener("focus", w), () => {
        g.removeEventListener("focusin", b), g.removeEventListener("focusout", C), g.removeEventListener("pointermove", b), g.removeEventListener("pointerleave", T), window.removeEventListener("blur", b), window.removeEventListener("focus", w);
      };
    }
  }, [
    h,
    a.isClosePausedRef
  ]);
  const f = W(({ tabbingDirection: g }) => {
    const b = s().map((w) => {
      const C = w.ref.current, T = [
        C,
        ...Q1(C)
      ];
      return g === "forwards" ? T : T.reverse();
    });
    return (g === "forwards" ? b.reverse() : b).flat();
  }, [
    s
  ]);
  return Y(() => {
    const g = d.current;
    if (g) {
      const v = (b) => {
        const w = b.altKey || b.ctrlKey || b.metaKey;
        if (b.key === "Tab" && !w) {
          const R = document.activeElement, G = b.shiftKey;
          if (b.target === g && G) {
            var T;
            (T = l.current) === null || T === void 0 || T.focus();
            return;
          }
          const te = f({
            tabbingDirection: G ? "backwards" : "forwards"
          }), X = te.findIndex(
            (F) => F === R
          );
          if (jo(te.slice(X + 1)))
            b.preventDefault();
          else {
            var P, M;
            G ? (P = l.current) === null || P === void 0 || P.focus() : (M = u.current) === null || M === void 0 || M.focus();
          }
        }
      };
      return g.addEventListener("keydown", v), () => g.removeEventListener("keydown", v);
    }
  }, [
    s,
    f
  ]), /* @__PURE__ */ A(bp, {
    ref: c,
    role: "region",
    "aria-label": o.replace("{hotkey}", p),
    tabIndex: -1,
    style: {
      pointerEvents: h ? void 0 : "none"
    }
  }, h && /* @__PURE__ */ A(ks, {
    ref: l,
    onFocusFromOutsideViewport: () => {
      const g = f({
        tabbingDirection: "forwards"
      });
      jo(g);
    }
  }), /* @__PURE__ */ A(ba.Slot, {
    scope: n
  }, /* @__PURE__ */ A(ce.ol, O({
    tabIndex: -1
  }, i, {
    ref: m
  }))), h && /* @__PURE__ */ A(ks, {
    ref: u,
    onFocusFromOutsideViewport: () => {
      const g = f({
        tabbingDirection: "backwards"
      });
      jo(g);
    }
  }));
}), R1 = "ToastFocusProxy", ks = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, i = lo(R1, n);
  return /* @__PURE__ */ A(ua, O({
    "aria-hidden": !0,
    tabIndex: 0
  }, o, {
    ref: t,
    style: {
      position: "fixed"
    },
    onFocus: (a) => {
      var s;
      const c = a.relatedTarget;
      !((s = i.viewport) !== null && s !== void 0 && s.contains(c)) && r();
    }
  }));
}), uo = "Toast", P1 = "toast.swipeStart", D1 = "toast.swipeMove", M1 = "toast.swipeCancel", N1 = "toast.swipeEnd", F1 = /* @__PURE__ */ S((e, t) => {
  const { forceMount: n, open: r, defaultOpen: o, onOpenChange: i, ...a } = e, [s = !0, c] = Ye({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ A(st, {
    present: n || s
  }, /* @__PURE__ */ A(vd, O({
    open: s
  }, a, {
    ref: t,
    onClose: () => c(!1),
    onPause: Se(e.onPause),
    onResume: Se(e.onResume),
    onSwipeStart: _(e.onSwipeStart, (l) => {
      l.currentTarget.setAttribute("data-swipe", "start");
    }),
    onSwipeMove: _(e.onSwipeMove, (l) => {
      const { x: u, y: d } = l.detail.delta;
      l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
    }),
    onSwipeCancel: _(e.onSwipeCancel, (l) => {
      l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
    }),
    onSwipeEnd: _(e.onSwipeEnd, (l) => {
      const { x: u, y: d } = l.detail.delta;
      l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), c(!1);
    })
  })));
}), [$1, k1] = md(uo, {
  onClose() {
  }
}), vd = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: n, type: r = "foreground", duration: o, open: i, onClose: a, onEscapeKeyDown: s, onPause: c, onResume: l, onSwipeStart: u, onSwipeMove: d, onSwipeCancel: m, onSwipeEnd: p, ...h } = e, f = lo(uo, n), [g, v] = V(null), b = ve(
    t,
    (F) => v(F)
  ), w = N(null), C = N(null), T = o || f.duration, P = N(0), M = N(T), R = N(0), { onToastAdd: G, onToastRemove: Q } = f, U = Se(() => {
    var F;
    (g == null ? void 0 : g.contains(document.activeElement)) && ((F = f.viewport) === null || F === void 0 || F.focus()), a();
  }), te = W((F) => {
    !F || F === 1 / 0 || (window.clearTimeout(R.current), P.current = (/* @__PURE__ */ new Date()).getTime(), R.current = window.setTimeout(U, F));
  }, [
    U
  ]);
  Y(() => {
    const F = f.viewport;
    if (F) {
      const L = () => {
        te(M.current), l == null || l();
      }, z = () => {
        const Z = (/* @__PURE__ */ new Date()).getTime() - P.current;
        M.current = M.current - Z, window.clearTimeout(R.current), c == null || c();
      };
      return F.addEventListener(Ci, z), F.addEventListener(Ii, L), () => {
        F.removeEventListener(Ci, z), F.removeEventListener(Ii, L);
      };
    }
  }, [
    f.viewport,
    T,
    c,
    l,
    te
  ]), Y(() => {
    i && !f.isClosePausedRef.current && te(T);
  }, [
    i,
    T,
    f.isClosePausedRef,
    te
  ]), Y(() => (G(), () => Q()), [
    G,
    Q
  ]);
  const X = xe(() => g ? yd(g) : null, [
    g
  ]);
  return f.viewport ? /* @__PURE__ */ A(Ze, null, X && /* @__PURE__ */ A(B1, {
    __scopeToast: n,
    role: "status",
    "aria-live": r === "foreground" ? "assertive" : "polite",
    "aria-atomic": !0
  }, X), /* @__PURE__ */ A($1, {
    scope: n,
    onClose: U
  }, /* @__PURE__ */ Ui(/* @__PURE__ */ A(ba.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ A(vp, {
    asChild: !0,
    onEscapeKeyDown: _(s, () => {
      f.isFocusedToastEscapeKeyDownRef.current || U(), f.isFocusedToastEscapeKeyDownRef.current = !1;
    })
  }, /* @__PURE__ */ A(ce.li, O({
    // Ensure toasts are announced as status list or status when focused
    role: "status",
    "aria-live": "off",
    "aria-atomic": !0,
    tabIndex: 0,
    "data-state": i ? "open" : "closed",
    "data-swipe-direction": f.swipeDirection
  }, h, {
    ref: b,
    style: {
      userSelect: "none",
      touchAction: "none",
      ...e.style
    },
    onKeyDown: _(e.onKeyDown, (F) => {
      F.key === "Escape" && (s == null || s(F.nativeEvent), F.nativeEvent.defaultPrevented || (f.isFocusedToastEscapeKeyDownRef.current = !0, U()));
    }),
    onPointerDown: _(e.onPointerDown, (F) => {
      F.button === 0 && (w.current = {
        x: F.clientX,
        y: F.clientY
      });
    }),
    onPointerMove: _(e.onPointerMove, (F) => {
      if (!w.current)
        return;
      const L = F.clientX - w.current.x, z = F.clientY - w.current.y, Z = !!C.current, ne = [
        "left",
        "right"
      ].includes(f.swipeDirection), K = [
        "left",
        "up"
      ].includes(f.swipeDirection) ? Math.min : Math.max, B = ne ? K(0, L) : 0, ee = ne ? 0 : K(0, z), se = F.pointerType === "touch" ? 10 : 2, re = {
        x: B,
        y: ee
      }, ie = {
        originalEvent: F,
        delta: re
      };
      Z ? (C.current = re, vr(D1, d, ie, {
        discrete: !1
      })) : Bs(re, f.swipeDirection, se) ? (C.current = re, vr(P1, u, ie, {
        discrete: !1
      }), F.target.setPointerCapture(F.pointerId)) : (Math.abs(L) > se || Math.abs(z) > se) && (w.current = null);
    }),
    onPointerUp: _(e.onPointerUp, (F) => {
      const L = C.current, z = F.target;
      if (z.hasPointerCapture(F.pointerId) && z.releasePointerCapture(F.pointerId), C.current = null, w.current = null, L) {
        const Z = F.currentTarget, ne = {
          originalEvent: F,
          delta: L
        };
        Bs(L, f.swipeDirection, f.swipeThreshold) ? vr(N1, p, ne, {
          discrete: !0
        }) : vr(M1, m, ne, {
          discrete: !0
        }), Z.addEventListener(
          "click",
          (K) => K.preventDefault(),
          {
            once: !0
          }
        );
      }
    })
  })))), f.viewport))) : null;
});
vd.propTypes = {
  type(e) {
    if (e.type && ![
      "foreground",
      "background"
    ].includes(e.type)) {
      const t = `Invalid prop \`type\` supplied to \`${uo}\`. Expected \`foreground | background\`.`;
      return new Error(t);
    }
    return null;
  }
};
const B1 = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = lo(uo, t), [i, a] = V(!1), [s, c] = V(!1);
  return U1(
    () => a(!0)
  ), Y(() => {
    const l = window.setTimeout(
      () => c(!0),
      1e3
    );
    return () => window.clearTimeout(l);
  }, []), s ? null : /* @__PURE__ */ A(qr, {
    asChild: !0
  }, /* @__PURE__ */ A(ua, r, i && /* @__PURE__ */ A(Ze, null, o.label, " ", n)));
}, L1 = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: n, ...r } = e;
  return /* @__PURE__ */ A(ce.div, O({}, r, {
    ref: t
  }));
}), z1 = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: n, ...r } = e;
  return /* @__PURE__ */ A(ce.div, O({}, r, {
    ref: t
  }));
}), G1 = "ToastAction", Y1 = /* @__PURE__ */ S((e, t) => {
  const { altText: n, ...r } = e;
  return n ? /* @__PURE__ */ A(Ad, {
    altText: n,
    asChild: !0
  }, /* @__PURE__ */ A(bd, O({}, r, {
    ref: t
  }))) : null;
});
Y1.propTypes = {
  altText(e) {
    return e.altText ? null : new Error(`Missing prop \`altText\` expected on \`${G1}\``);
  }
};
const H1 = "ToastClose", bd = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: n, ...r } = e, o = k1(H1, n);
  return /* @__PURE__ */ A(Ad, {
    asChild: !0
  }, /* @__PURE__ */ A(ce.button, O({
    type: "button"
  }, r, {
    ref: t,
    onClick: _(e.onClick, o.onClose)
  })));
}), Ad = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ A(ce.div, O({
    "data-radix-toast-announce-exclude": "",
    "data-radix-toast-announce-alt": r || void 0
  }, o, {
    ref: t
  }));
});
function yd(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), W1(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", i = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const a = r.dataset.radixToastAnnounceAlt;
          a && t.push(a);
        } else
          t.push(...yd(r));
    }
  }), t;
}
function vr(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, i = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? Ki(o, i) : o.dispatchEvent(i);
}
const Bs = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), i = r > o;
  return t === "left" || t === "right" ? i && r > n : !i && o > n;
};
function U1(e = () => {
}) {
  const t = Se(e);
  bt(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(
      () => r = window.requestAnimationFrame(t)
    ), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [
    t
  ]);
}
function W1(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Q1(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function jo(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
const j1 = gd, K1 = S1, V1 = F1, X1 = L1, q1 = z1, J1 = bd, Aa = 25, Z1 = Re`
  0% { opacity: 1 };
  100% { opacity: 0 };
`, _1 = Re`
  from { transform: 'translateX(calc(100% + ${Aa}px))' };
  to { transform: 'translateX(0)' };
`, eA = Re`
  from { transform: 'translateX(var(--radix-toast-swipe-end-x))' };
  to { transform: 'translateX(calc(100% + ${Aa}px))' };
`, tA = I(K1)`
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: ${Aa}px;
  gap: 10px;
  width: 400px;
  max-width: 100vw;
  margin: 0;
  list-style: none;
  z-index: 2147483647;
  outline: none;
`, nA = I(V1)`
  background-color: ${E.white300};
  border-radius: ${le.sm};
  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  padding: 15px;
  display: grid;
  grid-template-areas: 'title close' 'description close';
  grid-template-columns: auto max-content;
  column-gap: 15px;
  align-items: center;

  @media (prefers-reduced-motion: no-preference) {
    &[data-state='open'] {
      animation: ${_1} 150ms cubic-bezier(0.16, 1, 0.3, 1);
    }
    &[data-state='closed'] {
      animation: ${Z1} 100ms ease-in;
    }
    &[data-swipe='move'] {
      transform: translateX(var(--radix-toast-swipe-move-x));
    }
    &[data-swipe='cancel'] {
      transform: translateX(0);
      transition: transform 200ms ease-out;
    }
    &[data-swipe='end'] {
      animation: ${eA} 100ms ease-out;
    }
  }
`, rA = I.li`
  ${({ styleType: e }) => {
  switch (e) {
    case "error":
      return j`
          background-color: ${E.toastError};
          color: ${E.toastTextError};
        `;
    case "success":
      return j`
          background-color: ${E.toastSuccess};
          color: ${E.toastTextSuccess};
        `;
    case "warning":
      return j`
          background-color: ${E.white300};
          color: ${E.toastTextWarning};

          & button {
            color: ${E.toastWarning};
          }
        `;
    default:
      return j`
          background-color: ${E.white300};
          color: ${E.toastTextInfo};

          & button {
            color: ${E.toastInfo};
          }
        `;
  }
}};
`, oA = I(X1)`
  grid-area: title;
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 1rem;
`, iA = I(q1)`
  grid-area: description;
  margin: 0;
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 1.3;
  word-break: break-word;
`, aA = I(J1)`
  all: unset;
  align-items: center;
  border-radius: ${le.full};
  display: inline-flex;
  font-family: inherit;
  height: 1.5rem;
  justify-content: center;
  width: 1.5rem;
  grid-area: close;

  &:hover {
    background-color: ${E.backgroundHover};
  }
`, sA = I(Uf)`
  height: 1.5rem;
  width: 1.5rem;
`, cA = ({
  dataCy: e = "toast",
  description: t,
  styleType: n = "info",
  title: r,
  ...o
}) => /* @__PURE__ */ x(nA, { ...o, "data-cy": e, asChild: !0, children: /* @__PURE__ */ J(rA, { styleType: n, children: [
  /* @__PURE__ */ x(oA, { children: r }),
  /* @__PURE__ */ x(iA, { children: t }),
  /* @__PURE__ */ x(aA, { children: /* @__PURE__ */ x(sA, {}) })
] }) }), lA = ({
  dataCy: e = "toast-viewport",
  ...t
}) => /* @__PURE__ */ x(tA, { ...t, "data-cy": e }), wd = j`
  all: unset;
  align-items: center;
  border-radius: ${le.md};
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 0.875rem;
  justify-content: center;
  line-height: 1.5;
  padding: 0.5rem 1rem;

  &:hover {
    filter: brightness(0.9);
  }

  &[disabled] {
    cursor: not-allowed;
    opacity: unset;
    background-color: ${E.blue50};
  }

  ${(e) => e.noPaddingRight && j`
      padding-right: 0.25rem;
    `}

  ${(e) => e.textTransform && j`
      text-transform: ${e.textTransform};
    `}

  ${(e) => e.fontWeight && j`
      text-transform: ${e.fontWeight};
    `}

  ${(e) => {
  switch (e.styleType) {
    case "outline":
      return j`
          background-color: ${E.white300};
          border: 0.5px solid ${E.button};
          color: ${E.button};
          &[disabled] {
            opacity: 0.2;
          }
        `;
    case "text":
      return j`
          background-color: ${E.white300};
          color: ${E.button};
          &[disabled] {
            opacity: 0.25;
          }
        `;
    case "accept":
      return j`
          background-color: ${E.statusSuccess};
          color: ${E.statusTextSuccess};
          &[disabled] {
            opacity: 0.25;
          }
        `;
    case "decline":
      return j`
          background-color: ${E.statusError};
          color: ${E.statusTextError};
          &[disabled] {
            opacity: 0.25;
          }
        `;
    case "admin":
      return j`
          background-color: ${E.blue275};
          font-family: ${ea.admin};
          color: ${E.white300};
          &[disabled] {
            opacity: 0.25;
          }
        `;
    case "default":
      return j`
          background-color: ${E.button};
          color: ${E.white300};
        `;
    default:
      return j`
          background-color: ${E.button};
          color: ${E.white300};
        `;
  }
}}
`, dA = I.button`
  ${wd};
`, uA = I(dd)`
  ${wd};
`, fA = I(tr)`
  height: 1.3125rem;
  width: 1.3125rem;
`, fo = S(
  // eslint-disable-next-line no-restricted-syntax
  function({
    asChild: t = !1,
    children: n,
    dataCy: r = "button",
    disabled: o = !1,
    loading: i = !1,
    noPaddingRight: a = !1,
    styleType: s,
    textTransform: c = "uppercase",
    fontWeight: l = 700,
    ...u
  }, d) {
    return /* @__PURE__ */ x(
      t ? uA : dA,
      {
        type: "button",
        ...u,
        "data-cy": r,
        disabled: i || o,
        noPaddingRight: a,
        ref: d,
        styleType: s,
        textTransform: c,
        fontWeight: l,
        children: i ? /* @__PURE__ */ x(fA, {}) : n
      }
    );
  }
), pA = I.div`
  display: flex;
  flex-basis: 0;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;

  ${bn}
`, TC = ({
  children: e,
  dataCy: t = "content-modal"
}) => /* @__PURE__ */ x(pA, { id: "content-pagination", "data-cy": t, children: e }), hA = I.div`
  display: contents;
`, mA = S(
  // eslint-disable-next-line no-restricted-syntax
  function({ ...t }, n) {
    return /* @__PURE__ */ x(hA, { ref: n, ...t });
  }
), gA = /* @__PURE__ */ S((e, t) => /* @__PURE__ */ A(ce.label, O({}, e, {
  ref: t,
  onMouseDown: (n) => {
    var r;
    (r = e.onMouseDown) === null || r === void 0 || r.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault();
  }
}))), xd = gA, vA = I.div`
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: flex-end;
  padding-right: 0.5rem;
`, bA = I.fieldset`
  all: unset;
  align-items: center;
  border: none;
  display: flex;
  flex-direction: row;
  margin-bottom: 0.75rem;
  min-height: 1.5rem;
`, AA = I(xd)`
  color: ${E.labelText};
  font-size: 0.875rem;
  line-height: 1.3;
  overflow: hidden;
  padding: 1px 6px;
  user-select: none;
`, yA = ({
  children: e,
  htmlFor: t,
  label: n,
  dataCy: r = "label-checkbox"
}) => /* @__PURE__ */ J(bA, { "data-cy": "checkbox-container", children: [
  /* @__PURE__ */ x(vA, { children: e }),
  /* @__PURE__ */ x(AA, { "data-cy": r, htmlFor: t, children: n })
] }), wA = I.div``, xA = ({ children: e }) => /* @__PURE__ */ x(wA, { "data-cy": "content", children: e }), EA = I.div`
  width: 100%;
  display: grid;
  align-items: start;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));
`, CA = ({ children: e }) => /* @__PURE__ */ x(EA, { "data-cy": "content-grid", children: e }), Ed = $.createContext(null), IA = () => $.useContext(Ed), TA = (e) => {
  const { children: t, ...n } = e;
  return $.createElement(Ed.Provider, { value: n }, t);
}, OA = I.input`
  -webkit-appearance: none;
  background-color: ${E.white300};
  border-radius: ${le.px};
  border: none;
  color: ${E.text};
  flex-grow: 1;
  font-size: 1rem;
  height: 3.25rem;
  line-height: 1.1;
  outline: none;
  padding: 0 1rem;
  width: 100%;
  &::placeholder {
    color: ${E.inputPlaceholder};
  }
  @media (max-width: 337px) {
    width: 100%;
  }
`, SA = S(
  // eslint-disable-next-line no-restricted-syntax
  function({ dataCy: t, type: n = "text", name: r, ...o }, i) {
    const { register: a } = IA();
    return /* @__PURE__ */ x(
      OA,
      {
        ref: i,
        ...o,
        ...a(r, {
          valueAsNumber: n === "number"
        }),
        type: n,
        "data-cy": t
      }
    );
  }
), RA = I.button`
  all: unset;
  align-items: center;
  border-radius: ${le.px};
  color: ${E.labelText};
  display: inline-flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  width: 2.75rem;
  &:hover {
    background-color: ${E.backgroundHover};
  }
`, PA = ({
  icon: e,
  dataCy: t,
  ...n
}) => /* @__PURE__ */ x(RA, { "data-cy": t, type: "button", ...n, children: /* @__PURE__ */ x(e, {}) }), xr = I(xd)`
  background-color: ${E.white300};
  color: ${E.labelText};
  font-size: 0.875rem;
  left: 16px;
  max-width: 90%;
  overflow: hidden;
  padding: 1px 6px;
  position: absolute;
  text-overflow: ellipsis;
  top: 50%;
  transform-origin: 0;
  transform: translateY(-50%);
  transition: transform 0.15s ease-in-out, top 0.15s ease-in-out,
    padding 0.15s ease-in-out;
  user-select: none;
  white-space: nowrap;
`, DA = I.fieldset`
  all: unset;
  align-items: center;
  background-color: ${E.white300};
  border-radius: ${le.px};
  border: 1px solid ${E.inputBorderLight};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  position: relative;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:focus-within {
    border: 1px solid ${E.fieldFocus};

    & ${xr} {
      color: ${E.fieldFocus};
      top: -2px;
      transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
      white-space: normal;
    }
  }

  ${({ filled: e = !1, isInvalid: t = !1 }) => e && (t ? j`
          border: 1px solid ${E.red300};

          & ${xr} {
            color: ${E.red300};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        ` : j`
          border: 1px solid ${E.fieldFocus};

          & ${xr} {
            color: ${E.fieldFocus};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        `)}
`, MA = I.p`
  font-size: 0.7rem;
  color: ${E.red300};
  margin: -5px 0px 15px 0px;
`, NA = I.div`
  flex-grow: 1;
`, FA = ({
  label: e,
  inputRef: t,
  filled: n,
  errorMessage: r,
  children: o,
  dataCy: i = "input"
}) => /* @__PURE__ */ J(NA, { "data-cy": `container-withError-${i}`, children: [
  /* @__PURE__ */ J(DA, { "data-cy": e, filled: n, isInvalid: !!r, children: [
    e && /* @__PURE__ */ x(xr, { htmlFor: t, "data-cy": i, children: e }),
    o
  ] }),
  /* @__PURE__ */ x(MA, { "data-cy": `error-${i ?? ""}`, children: r })
] }), $A = ({
  children: e,
  ...t
}) => /* @__PURE__ */ x(TA, { "data-cy": "formProvider", ...t, children: e }), kA = I.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.5rem;
`, BA = ({
  children: e,
  onSubmit: t,
  ...n
}) => {
  const r = async (o) => {
    o.preventDefault(), await (t == null ? void 0 : t(o));
  };
  return /* @__PURE__ */ x(
    kA,
    {
      ...n,
      onSubmit: (o) => {
        r(o);
      },
      children: e
    }
  );
}, Ls = {
  Root: BA,
  Content: xA,
  Grid: CA,
  CheckboxContent: yA,
  InputActions: PA,
  InputContent: FA,
  InputText: SA,
  Provider: $A
}, LA = I.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
`;
I.div`
  margin: 1rem auto;
`;
const zA = j`
  font-family: ${ea.admin};
  font-weight: 600;
`, GA = I.h1`
  font-size: 1.125rem;
  margin-bottom: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;

  ${({ themeStyle: e = "default" }) => e === "admin" && j`
      ${zA}
    `}
`, YA = I.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;

  & button + button {
    margin-left: 1rem;
  }
`, HA = I.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.75rem;
  max-height: 5rem;
  overflow-y: auto;

  ${bn}
`, UA = I.p`
  border: ${le.xs};
  color: ${E.red300};
  font-size: 0.875rem;

  &:hover {
    background-color: ${E.backgroundHover};
  }
`, Ko = I(fo)`
  ${({ themeStyle: e = "default" }) => e === "admin" && j`
      background-color: ${E.blue275};
      color: ${E.white300};

      &:hover {
        background-color: ${E.blue300};
      }
    `}
`, OC = ({
  acceptText: e,
  children: t,
  dataCy: n = "form-modal",
  declineText: r,
  disabled: o = !1,
  errorMessage: i,
  loading: a = !1,
  mainText: s,
  acceptButtonTooltipText: c = null,
  formId: l,
  onAccept: u,
  onDecline: d,
  themeStyle: m = "default",
  ...p
}) => {
  const h = xe(() => i ? i.split(`
`) : [], [i]);
  return /* @__PURE__ */ J(Gl, { dataCy: n, ...p, children: [
    /* @__PURE__ */ x(LA, { "data-cy": "text-container", children: /* @__PURE__ */ x(ev, { asChild: !0, children: /* @__PURE__ */ x(GA, { themeStyle: m, "data-cy": s, children: s }) }) }),
    /* @__PURE__ */ J(Ls.Root, { id: l, onSubmit: u, children: [
      t,
      i && /* @__PURE__ */ x(HA, { "data-cy": "error-message", children: h.map((f) => /* @__PURE__ */ x(UA, { children: f }, f)) }),
      /* @__PURE__ */ x(Ls.Content, { children: /* @__PURE__ */ J(YA, { children: [
        r && /* @__PURE__ */ x(
          Ko,
          {
            type: "button",
            dataCy: "button-cancel",
            styleType: "outline",
            onClick: d,
            children: r
          }
        ),
        e && (c ? /* @__PURE__ */ x(Yt, { message: c, children: /* @__PURE__ */ x(
          Ko,
          {
            type: "submit",
            dataCy: "button-add",
            loading: a,
            disabled: o,
            children: e
          }
        ) }) : /* @__PURE__ */ x(
          Ko,
          {
            type: "submit",
            dataCy: "button-add",
            loading: a,
            disabled: o,
            children: e
          }
        ))
      ] }) })
    ] })
  ] });
}, Cd = "Avatar", [WA, SC] = ke(Cd), [QA, Id] = WA(Cd), jA = /* @__PURE__ */ S((e, t) => {
  const { __scopeAvatar: n, ...r } = e, [o, i] = V("idle");
  return /* @__PURE__ */ A(QA, {
    scope: n,
    imageLoadingStatus: o,
    onImageLoadingStatusChange: i
  }, /* @__PURE__ */ A(ce.span, O({}, r, {
    ref: t
  })));
}), KA = "AvatarImage", VA = /* @__PURE__ */ S((e, t) => {
  const { __scopeAvatar: n, src: r, onLoadingStatusChange: o = () => {
  }, ...i } = e, a = Id(KA, n), s = JA(r), c = Se((l) => {
    o(l), a.onImageLoadingStatusChange(l);
  });
  return bt(() => {
    s !== "idle" && c(s);
  }, [
    s,
    c
  ]), s === "loaded" ? /* @__PURE__ */ A(ce.img, O({}, i, {
    ref: t,
    src: r
  })) : null;
}), XA = "AvatarFallback", qA = /* @__PURE__ */ S((e, t) => {
  const { __scopeAvatar: n, delayMs: r, ...o } = e, i = Id(XA, n), [a, s] = V(r === void 0);
  return Y(() => {
    if (r !== void 0) {
      const c = window.setTimeout(
        () => s(!0),
        r
      );
      return () => window.clearTimeout(c);
    }
  }, [
    r
  ]), a && i.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ A(ce.span, O({}, o, {
    ref: t
  })) : null;
});
function JA(e) {
  const [t, n] = V("idle");
  return Y(() => {
    if (!e) {
      n("error");
      return;
    }
    let r = !0;
    const o = new window.Image(), i = (a) => () => {
      r && n(a);
    };
    return n("loading"), o.onload = i("loaded"), o.onerror = i("error"), o.src = e, () => {
      r = !1;
    };
  }, [
    e
  ]), t;
}
const ZA = jA, _A = VA, ey = qA, ty = I(ZA)`
  align-items: center;
  border-radius: inherit;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`, ny = I(_A)`
  border-radius: inherit;
  height: 100%;
  object-fit: scale-down;
  width: 100%;
`, ry = I(ey)`
  align-items: center;
  border-radius: inherit;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`, oy = I(Hf)`
  height: 3.5rem;
  width: 3.5rem;
`, iy = S(
  // eslint-disable-next-line no-restricted-syntax
  function({ alt: t, children: n, dataCy: r, delayMs: o = 500, ...i }, a) {
    return /* @__PURE__ */ J(ty, { children: [
      /* @__PURE__ */ x(ny, { ...i, ref: a, alt: t, "data-cy": r }),
      /* @__PURE__ */ x(ry, { ...i, "data-cy": "image-notFound", delayMs: o, children: n ?? /* @__PURE__ */ x(oy, { "data-cy": r }) })
    ] });
  }
), ay = I.section`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`, RC = ({
  children: e
}) => /* @__PURE__ */ x(ay, { children: e }), sy = /* @__PURE__ */ S((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...i } = e, [a = !1, s] = Ye({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ A(ce.button, O({
    type: "button",
    "aria-pressed": a,
    "data-state": a ? "on" : "off",
    "data-disabled": e.disabled ? "" : void 0
  }, i, {
    ref: t,
    onClick: _(e.onClick, () => {
      e.disabled || s(!a);
    })
  }));
}), po = "ToggleGroup", [Td, PC] = ke(po, [
  Jr
]), Od = Jr(), cy = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single") {
    const o = r;
    return /* @__PURE__ */ $.createElement(ly, O({}, o, {
      ref: t
    }));
  }
  if (n === "multiple") {
    const o = r;
    return /* @__PURE__ */ $.createElement(dy, O({}, o, {
      ref: t
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${po}\``);
}), [Sd, Rd] = Td(po), ly = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...i } = e, [a, s] = Ye({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ $.createElement(Sd, {
    scope: e.__scopeToggleGroup,
    type: "single",
    value: a ? [
      a
    ] : [],
    onItemActivate: s,
    onItemDeactivate: $.useCallback(
      () => s(""),
      [
        s
      ]
    )
  }, /* @__PURE__ */ $.createElement(Pd, O({}, i, {
    ref: t
  })));
}), dy = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...i } = e, [a = [], s] = Ye({
    prop: n,
    defaultProp: r,
    onChange: o
  }), c = $.useCallback(
    (u) => s(
      (d = []) => [
        ...d,
        u
      ]
    ),
    [
      s
    ]
  ), l = $.useCallback(
    (u) => s(
      (d = []) => d.filter(
        (m) => m !== u
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ $.createElement(Sd, {
    scope: e.__scopeToggleGroup,
    type: "multiple",
    value: a,
    onItemActivate: c,
    onItemDeactivate: l
  }, /* @__PURE__ */ $.createElement(Pd, O({}, i, {
    ref: t
  })));
}), [uy, fy] = Td(po), Pd = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, disabled: r = !1, rovingFocus: o = !0, orientation: i, dir: a, loop: s = !0, ...c } = e, l = Od(n), u = Wr(a), d = {
    role: "group",
    dir: u,
    ...c
  };
  return /* @__PURE__ */ $.createElement(uy, {
    scope: n,
    rovingFocus: o,
    disabled: r
  }, o ? /* @__PURE__ */ $.createElement(al, O({
    asChild: !0
  }, l, {
    orientation: i,
    dir: u,
    loop: s
  }), /* @__PURE__ */ $.createElement(ce.div, O({}, d, {
    ref: t
  }))) : /* @__PURE__ */ $.createElement(ce.div, O({}, d, {
    ref: t
  })));
}), Ti = "ToggleGroupItem", py = /* @__PURE__ */ $.forwardRef((e, t) => {
  const n = Rd(Ti, e.__scopeToggleGroup), r = fy(Ti, e.__scopeToggleGroup), o = Od(e.__scopeToggleGroup), i = n.value.includes(e.value), a = r.disabled || e.disabled, s = {
    ...e,
    pressed: i,
    disabled: a
  }, c = $.useRef(null);
  return r.rovingFocus ? /* @__PURE__ */ $.createElement(sl, O({
    asChild: !0
  }, o, {
    focusable: !a,
    active: i,
    ref: c
  }), /* @__PURE__ */ $.createElement(zs, O({}, s, {
    ref: t
  }))) : /* @__PURE__ */ $.createElement(zs, O({}, s, {
    ref: t
  }));
}), zs = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, value: r, ...o } = e, i = Rd(Ti, n), a = {
    role: "radio",
    "aria-checked": e.pressed,
    "aria-pressed": void 0
  }, s = i.type === "single" ? a : void 0;
  return /* @__PURE__ */ $.createElement(sy, O({}, s, o, {
    ref: t,
    onPressedChange: (c) => {
      c ? i.onItemActivate(r) : i.onItemDeactivate(r);
    }
  }));
}), hy = cy, my = py, gy = I(hy)`
  border-bottom: 1px solid ${E.divider};
  display: flex;
`, vy = I.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 0.375rem;
`, Dd = I.span`
  align-items: center;
  background-color: ${E.lightGray100};
  border-radius: ${le.px};
  color: ${E.textLight};
  display: flex;
  font-size: 0.625rem;
  justify-content: center;
  padding: 0.0625rem 0.25rem;
`, by = I(my)`
  all: unset;
  align-items: center;
  background-color: ${E.backgroundDarker};
  border-top-left-radius: ${le.sm};
  border-top-right-radius: ${le.sm};
  cursor: pointer;
  display: flex;
  padding: 0.5rem 0.375rem;

  &[data-disabled] {
    color: ${E.gray200};
    pointer-events: none;
    & ${Dd} {
      background-color: ${E.lightGray100};
    }
  }

  &[data-state='on'] {
    position: relative;
    &::after {
      content: '';
      background-color: currentColor;
      border-top-left-radius: ${le.px};
      border-top-right-radius: ${le.px};
      bottom: 0;
      height: 2px;
      left: 0;
      position: absolute;
      width: 100%;
    }
  }

  &[data-state='off'] {
    color: ${E.textLight};
    //   & {Indicator} {
    //     display: none;
    //   }
  }

  &:hover {
    filter: brightness(0.9);
  }
`, DC = S(
  // eslint-disable-next-line no-restricted-syntax
  function({ children: t, dataCy: n = "tab", status: r = "", ...o }, i) {
    return /* @__PURE__ */ J(by, { ...o, "data-cy": n, ref: i, children: [
      t,
      r !== "" && /* @__PURE__ */ x(vy, { "data-cy": "tab-button-container", children: /* @__PURE__ */ x(Dd, { "data-cy": "tab-indicator", children: r }) })
    ] });
  }
), Ay = ({
  children: e,
  dataCy: t = "tab-group",
  ...n
}) => /* @__PURE__ */ x(gy, { ...n, "data-cy": t, children: e }), Md = 1.25, Nd = 1.75, Fd = I.div`
  margin-top: ${Md + Nd}rem;
  background-color: ${E.white300};
  border-radius: ${le.xl};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 1rem;
`, yy = I(Ay)`
  margin-top: ${Md}rem;
  & + ${Fd} {
    margin-top: ${Nd}rem;
  }
`, MC = ({
  children: e,
  tabs: t,
  defaultTabValue: n,
  onTabValueChange: r,
  ...o
}) => /* @__PURE__ */ J(Qi, { children: [
  !!t && /* @__PURE__ */ x(
    yy,
    {
      type: "single",
      defaultValue: n,
      onValueChange: r,
      children: t
    }
  ),
  /* @__PURE__ */ x(Fd, { ...o, children: e })
] }), wy = I.header`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`, xy = I.h1`
  font-size: 2rem;
  font-weight: 700;
  @media (max-width: 337px) {
    font-size: 1.5rem;
  }
  @media (max-width: 279px) {
    font-size: 1.2rem;
  }
`, Ey = I.div`
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: flex-end;
  gap: 1rem;
`, NC = ({
  title: e,
  buttonText: t,
  buttonVisibleRoles: n = void 0,
  userRoles: r,
  dataCy: o = "page-header",
  additionalActions: i = null,
  onClick: a,
  themeStyle: s,
  ...c
}) => {
  const l = n == null ? void 0 : n.some((u) => r == null ? void 0 : r.includes(u));
  return /* @__PURE__ */ J(wy, { "data-cy": o, ...c, children: [
    /* @__PURE__ */ x(xy, { "data-cy": e, children: e }),
    (l ?? n === void 0) && t && /* @__PURE__ */ J(Ey, { "data-cy": "button-container", children: [
      i,
      /* @__PURE__ */ x(
        fo,
        {
          dataCy: `button-${t}`,
          onClick: a,
          type: "button",
          styleType: s !== "admin" ? "default" : s,
          children: t
        }
      )
    ] })
  ] });
}, Cy = I(kf)`
  width: 28px;
  height: 28px;
  color: ${E.gray200};
`, Iy = I(_i)`
  width: 28px;
  height: 28px;
  color: ${E.gray200};

  &:hover {
    color: ${E.gray300};
  }
`;
I(fo)`
  border-top-right-radius: 14px;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
`;
const Ty = I.fieldset`
  all: unset;
  align-items: center;
  background-color: ${E.white300};
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  position: relative;
  border: 1px solid ${E.inputBorderLight};
  border-radius: 14px;
  padding-left: 12px;

  &:focus-within {
    border: 1px solid ${E.fieldFocus};
  }
`, Oy = I.input`
  -webkit-appearance: none;
  appearance: none;
  border: none;
  background-color: transparent;
  color: ${E.text};
  flex-grow: 1;
  font-size: 1rem;
  line-height: 1.1;
  outline: none;
  padding: 1rem 1rem 1rem 0.5rem;

  &::placeholder {
    color: ${E.inputPlaceholder};
  }

  @media (max-width: 337px) {
    width: 100%;
  }
`, Sy = I.button`
  background-color: transparent;
  border: none;
  margin-right: 12px;

  ${({ $visible: e = !1 }) => !e && j`
      display: none;
    `}
`, FC = ({
  search: e,
  placeholder: t = "Search",
  dataCy: n = t,
  loading: r = !1,
  onChange: o,
  onClearInput: i = null,
  ...a
}) => /* @__PURE__ */ J(Ty, { children: [
  /* @__PURE__ */ x(Cy, {}),
  /* @__PURE__ */ x(
    Oy,
    {
      ...a,
      placeholder: t,
      value: e,
      type: "text",
      onChange: o,
      "data-cy": n,
      readOnly: r
    }
  ),
  i && /* @__PURE__ */ x(Yt, { message: "Clear search", "data-cy": "tooltip-clear-search", children: /* @__PURE__ */ x(
    Sy,
    {
      onClick: (s) => {
        r || i(s);
      },
      $visible: e !== "",
      "data-cy": "button-cancel-search",
      children: /* @__PURE__ */ x(Iy, {})
    }
  ) })
] }), Ry = I.div`
  background: ${E.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  & > button {
    height: 3.25rem;
  }
`;
I(dd)`
  padding: 0.315rem;
`;
const $C = S(
  // eslint-disable-next-line no-restricted-syntax
  function({
    data: t,
    dataCy: n = "select-data",
    name: r = "select-name",
    placeholder: o = "",
    ...i
  }, a) {
    return /* @__PURE__ */ x(Ry, { "data-cy": "container-selectClient", ref: a, children: /* @__PURE__ */ J(
      ld,
      {
        dataCy: n,
        placeholder: o,
        name: r,
        ...i,
        children: [
          /* @__PURE__ */ x(o1, { "data-cy": "arrow-up" }),
          /* @__PURE__ */ x(s1, { "data-cy": "view-port", children: t.map(({ key: s, value: c }) => /* @__PURE__ */ J(c1, { value: `${s}`, "data-cy": `${s}`, children: [
            /* @__PURE__ */ x(r1, { children: c }),
            /* @__PURE__ */ x(a1, { "data-cy": "item-selected-indicator" })
          ] }, s)) }),
          /* @__PURE__ */ x(i1, { "data-cy": "arrow-down" })
        ]
      }
    ) });
  }
);
function Gs(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
function Py(e) {
  var t = e.lastRenderedStartIndex, n = e.lastRenderedStopIndex, r = e.startIndex, o = e.stopIndex;
  return !(r > n || o < t);
}
function Dy(e) {
  for (var t = e.isItemLoaded, n = e.itemCount, r = e.minimumBatchSize, o = e.startIndex, i = e.stopIndex, a = [], s = null, c = null, l = o; l <= i; l++) {
    var u = t(l);
    u ? c !== null && (a.push(s, c), s = c = null) : (c = l, s === null && (s = l));
  }
  if (c !== null) {
    for (var d = Math.min(Math.max(c, s + r - 1), n - 1), m = c + 1; m <= d && !t(m); m++)
      c = m;
    a.push(s, c);
  }
  if (a.length)
    for (; a[1] - a[0] + 1 < r && a[0] > 0; ) {
      var p = a[0] - 1;
      if (!t(p))
        a[0] = p;
      else
        break;
    }
  return a;
}
var My = function(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}, Ny = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}(), Fy = function(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}, Ys = function(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}, $y = function(e) {
  Fy(t, e);
  function t() {
    var n, r, o, i;
    My(this, t);
    for (var a = arguments.length, s = Array(a), c = 0; c < a; c++)
      s[c] = arguments[c];
    return i = (r = (o = Ys(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(s))), o), o._lastRenderedStartIndex = -1, o._lastRenderedStopIndex = -1, o._memoizedUnloadedRanges = [], o._onItemsRendered = function(l) {
      var u = l.visibleStartIndex, d = l.visibleStopIndex;
      process.env.NODE_ENV !== "production" && ((!Gs(u) || !Gs(d)) && console.warn("Invalid onItemsRendered signature; please refer to InfiniteLoader documentation."), typeof o.props.loadMoreRows == "function" && console.warn('InfiniteLoader "loadMoreRows" prop has been renamed to "loadMoreItems".')), o._lastRenderedStartIndex = u, o._lastRenderedStopIndex = d, o._ensureRowsLoaded(u, d);
    }, o._setRef = function(l) {
      o._listRef = l;
    }, r), Ys(o, i);
  }
  return Ny(t, [{
    key: "resetloadMoreItemsCache",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      this._memoizedUnloadedRanges = [], r && this._ensureRowsLoaded(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      process.env.NODE_ENV !== "production" && this._listRef == null && console.warn("Invalid list ref; please refer to InfiniteLoader documentation.");
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props.children;
      return r({
        onItemsRendered: this._onItemsRendered,
        ref: this._setRef
      });
    }
  }, {
    key: "_ensureRowsLoaded",
    value: function(r, o) {
      var i = this.props, a = i.isItemLoaded, s = i.itemCount, c = i.minimumBatchSize, l = c === void 0 ? 10 : c, u = i.threshold, d = u === void 0 ? 15 : u, m = Dy({
        isItemLoaded: a,
        itemCount: s,
        minimumBatchSize: l,
        startIndex: Math.max(0, r - d),
        stopIndex: Math.min(s - 1, o + d)
      });
      (this._memoizedUnloadedRanges.length !== m.length || this._memoizedUnloadedRanges.some(function(p, h) {
        return m[h] !== p;
      })) && (this._memoizedUnloadedRanges = m, this._loadUnloadedRanges(m));
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function(r) {
      for (var o = this, i = this.props.loadMoreItems || this.props.loadMoreRows, a = function(l) {
        var u = r[l], d = r[l + 1], m = i(u, d);
        m != null && m.then(function() {
          if (Py({
            lastRenderedStartIndex: o._lastRenderedStartIndex,
            lastRenderedStopIndex: o._lastRenderedStopIndex,
            startIndex: u,
            stopIndex: d
          })) {
            if (o._listRef == null)
              return;
            typeof o._listRef.resetAfterIndex == "function" ? o._listRef.resetAfterIndex(u, !0) : (typeof o._listRef._getItemStyleCache == "function" && o._listRef._getItemStyleCache(-1), o._listRef.forceUpdate());
          }
        });
      }, s = 0; s < r.length; s += 2)
        a(s);
    }
  }]), t;
}(wc);
function Oi() {
  return Oi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oi.apply(this, arguments);
}
function Hs(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Si(e, t) {
  return Si = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Si(e, t);
}
function ky(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Si(e, t);
}
var Us = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function By(e, t) {
  return !!(e === t || Us(e) && Us(t));
}
function Ly(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!By(e[n], t[n]))
      return !1;
  return !0;
}
function Vo(e, t) {
  t === void 0 && (t = Ly);
  var n, r = [], o, i = !1;
  function a() {
    for (var s = [], c = 0; c < arguments.length; c++)
      s[c] = arguments[c];
    return i && n === this && t(s, r) || (o = e.apply(this, s), i = !0, n = this, r = s), o;
  }
  return a;
}
var zy = typeof performance == "object" && typeof performance.now == "function", Ws = zy ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function Qs(e) {
  cancelAnimationFrame(e.id);
}
function Gy(e, t) {
  var n = Ws();
  function r() {
    Ws() - n >= t ? e.call(null) : o.id = requestAnimationFrame(r);
  }
  var o = {
    id: requestAnimationFrame(r)
  };
  return o;
}
var Xo = -1;
function js(e) {
  if (e === void 0 && (e = !1), Xo === -1 || e) {
    var t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", document.body.appendChild(t), Xo = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return Xo;
}
var ln = null;
function Ks(e) {
  if (e === void 0 && (e = !1), ln === null || e) {
    var t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    var r = document.createElement("div"), o = r.style;
    return o.width = "100px", o.height = "100px", t.appendChild(r), document.body.appendChild(t), t.scrollLeft > 0 ? ln = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? ln = "negative" : ln = "positive-ascending"), document.body.removeChild(t), ln;
  }
  return ln;
}
process.env.NODE_ENV;
var Yy = 150, Hy = function(t, n) {
  return t;
}, Er = null, Cr = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (Er = /* @__PURE__ */ new WeakSet(), Cr = /* @__PURE__ */ new WeakSet());
function Uy(e) {
  var t, n = e.getItemOffset, r = e.getEstimatedTotalSize, o = e.getItemSize, i = e.getOffsetForIndexAndAlignment, a = e.getStartIndexForOffset, s = e.getStopIndexForStartIndex, c = e.initInstanceProps, l = e.shouldResetStyleCacheOnItemSizeChange, u = e.validateProps;
  return t = /* @__PURE__ */ function(d) {
    ky(m, d);
    function m(h) {
      var f;
      return f = d.call(this, h) || this, f._instanceProps = c(f.props, Hs(f)), f._outerRef = void 0, f._resetIsScrollingTimeoutId = null, f.state = {
        instance: Hs(f),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof f.props.initialScrollOffset == "number" ? f.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, f._callOnItemsRendered = void 0, f._callOnItemsRendered = Vo(function(g, v, b, w) {
        return f.props.onItemsRendered({
          overscanStartIndex: g,
          overscanStopIndex: v,
          visibleStartIndex: b,
          visibleStopIndex: w
        });
      }), f._callOnScroll = void 0, f._callOnScroll = Vo(function(g, v, b) {
        return f.props.onScroll({
          scrollDirection: g,
          scrollOffset: v,
          scrollUpdateWasRequested: b
        });
      }), f._getItemStyle = void 0, f._getItemStyle = function(g) {
        var v = f.props, b = v.direction, w = v.itemSize, C = v.layout, T = f._getItemStyleCache(l && w, l && C, l && b), P;
        if (T.hasOwnProperty(g))
          P = T[g];
        else {
          var M = n(f.props, g, f._instanceProps), R = o(f.props, g, f._instanceProps), G = b === "horizontal" || C === "horizontal", Q = b === "rtl", U = G ? M : 0;
          T[g] = P = {
            position: "absolute",
            left: Q ? void 0 : U,
            right: Q ? U : void 0,
            top: G ? 0 : M,
            height: G ? "100%" : R,
            width: G ? R : "100%"
          };
        }
        return P;
      }, f._getItemStyleCache = void 0, f._getItemStyleCache = Vo(function(g, v, b) {
        return {};
      }), f._onScrollHorizontal = function(g) {
        var v = g.currentTarget, b = v.clientWidth, w = v.scrollLeft, C = v.scrollWidth;
        f.setState(function(T) {
          if (T.scrollOffset === w)
            return null;
          var P = f.props.direction, M = w;
          if (P === "rtl")
            switch (Ks()) {
              case "negative":
                M = -w;
                break;
              case "positive-descending":
                M = C - b - w;
                break;
            }
          return M = Math.max(0, Math.min(M, C - b)), {
            isScrolling: !0,
            scrollDirection: T.scrollOffset < M ? "forward" : "backward",
            scrollOffset: M,
            scrollUpdateWasRequested: !1
          };
        }, f._resetIsScrollingDebounced);
      }, f._onScrollVertical = function(g) {
        var v = g.currentTarget, b = v.clientHeight, w = v.scrollHeight, C = v.scrollTop;
        f.setState(function(T) {
          if (T.scrollOffset === C)
            return null;
          var P = Math.max(0, Math.min(C, w - b));
          return {
            isScrolling: !0,
            scrollDirection: T.scrollOffset < P ? "forward" : "backward",
            scrollOffset: P,
            scrollUpdateWasRequested: !1
          };
        }, f._resetIsScrollingDebounced);
      }, f._outerRefSetter = function(g) {
        var v = f.props.outerRef;
        f._outerRef = g, typeof v == "function" ? v(g) : v != null && typeof v == "object" && v.hasOwnProperty("current") && (v.current = g);
      }, f._resetIsScrollingDebounced = function() {
        f._resetIsScrollingTimeoutId !== null && Qs(f._resetIsScrollingTimeoutId), f._resetIsScrollingTimeoutId = Gy(f._resetIsScrolling, Yy);
      }, f._resetIsScrolling = function() {
        f._resetIsScrollingTimeoutId = null, f.setState({
          isScrolling: !1
        }, function() {
          f._getItemStyleCache(-1, null);
        });
      }, f;
    }
    m.getDerivedStateFromProps = function(f, g) {
      return Wy(f, g), u(f), null;
    };
    var p = m.prototype;
    return p.scrollTo = function(f) {
      f = Math.max(0, f), this.setState(function(g) {
        return g.scrollOffset === f ? null : {
          scrollDirection: g.scrollOffset < f ? "forward" : "backward",
          scrollOffset: f,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, p.scrollToItem = function(f, g) {
      g === void 0 && (g = "auto");
      var v = this.props, b = v.itemCount, w = v.layout, C = this.state.scrollOffset;
      f = Math.max(0, Math.min(f, b - 1));
      var T = 0;
      if (this._outerRef) {
        var P = this._outerRef;
        w === "vertical" ? T = P.scrollWidth > P.clientWidth ? js() : 0 : T = P.scrollHeight > P.clientHeight ? js() : 0;
      }
      this.scrollTo(i(this.props, f, g, C, this._instanceProps, T));
    }, p.componentDidMount = function() {
      var f = this.props, g = f.direction, v = f.initialScrollOffset, b = f.layout;
      if (typeof v == "number" && this._outerRef != null) {
        var w = this._outerRef;
        g === "horizontal" || b === "horizontal" ? w.scrollLeft = v : w.scrollTop = v;
      }
      this._callPropsCallbacks();
    }, p.componentDidUpdate = function() {
      var f = this.props, g = f.direction, v = f.layout, b = this.state, w = b.scrollOffset, C = b.scrollUpdateWasRequested;
      if (C && this._outerRef != null) {
        var T = this._outerRef;
        if (g === "horizontal" || v === "horizontal")
          if (g === "rtl")
            switch (Ks()) {
              case "negative":
                T.scrollLeft = -w;
                break;
              case "positive-ascending":
                T.scrollLeft = w;
                break;
              default:
                var P = T.clientWidth, M = T.scrollWidth;
                T.scrollLeft = M - P - w;
                break;
            }
          else
            T.scrollLeft = w;
        else
          T.scrollTop = w;
      }
      this._callPropsCallbacks();
    }, p.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && Qs(this._resetIsScrollingTimeoutId);
    }, p.render = function() {
      var f = this.props, g = f.children, v = f.className, b = f.direction, w = f.height, C = f.innerRef, T = f.innerElementType, P = f.innerTagName, M = f.itemCount, R = f.itemData, G = f.itemKey, Q = G === void 0 ? Hy : G, U = f.layout, te = f.outerElementType, X = f.outerTagName, F = f.style, L = f.useIsScrolling, z = f.width, Z = this.state.isScrolling, ne = b === "horizontal" || U === "horizontal", K = ne ? this._onScrollHorizontal : this._onScrollVertical, B = this._getRangeToRender(), ee = B[0], se = B[1], re = [];
      if (M > 0)
        for (var ie = ee; ie <= se; ie++)
          re.push(A(g, {
            data: R,
            key: Q(ie, R),
            index: ie,
            isScrolling: L ? Z : void 0,
            style: this._getItemStyle(ie)
          }));
      var ue = r(this.props, this._instanceProps);
      return A(te || X || "div", {
        className: v,
        onScroll: K,
        ref: this._outerRefSetter,
        style: Oi({
          position: "relative",
          height: w,
          width: z,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: b
        }, F)
      }, A(T || P || "div", {
        children: re,
        ref: C,
        style: {
          height: ne ? "100%" : ue,
          pointerEvents: Z ? "none" : void 0,
          width: ne ? ue : "100%"
        }
      }));
    }, p._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var f = this.props.itemCount;
        if (f > 0) {
          var g = this._getRangeToRender(), v = g[0], b = g[1], w = g[2], C = g[3];
          this._callOnItemsRendered(v, b, w, C);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var T = this.state, P = T.scrollDirection, M = T.scrollOffset, R = T.scrollUpdateWasRequested;
        this._callOnScroll(P, M, R);
      }
    }, p._getRangeToRender = function() {
      var f = this.props, g = f.itemCount, v = f.overscanCount, b = this.state, w = b.isScrolling, C = b.scrollDirection, T = b.scrollOffset;
      if (g === 0)
        return [0, 0, 0, 0];
      var P = a(this.props, T, this._instanceProps), M = s(this.props, P, T, this._instanceProps), R = !w || C === "backward" ? Math.max(1, v) : 1, G = !w || C === "forward" ? Math.max(1, v) : 1;
      return [Math.max(0, P - R), Math.max(0, Math.min(g - 1, M + G)), P, M];
    }, m;
  }(wc), t.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, t;
}
var Wy = function(t, n) {
  var r = t.children, o = t.direction, i = t.height, a = t.layout, s = t.innerTagName, c = t.outerTagName, l = t.width, u = n.instance;
  if (process.env.NODE_ENV !== "production") {
    (s != null || c != null) && Cr && !Cr.has(u) && (Cr.add(u), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var d = o === "horizontal" || a === "horizontal";
    switch (o) {
      case "horizontal":
      case "vertical":
        Er && !Er.has(u) && (Er.add(u), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + o + '" was specified.'));
    }
    switch (a) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + a + '" was specified.'));
    }
    if (r == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
    if (d && typeof l != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (l === null ? "null" : typeof l) + '" was specified.'));
    if (!d && typeof i != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (i === null ? "null" : typeof i) + '" was specified.'));
  }
}, Qy = /* @__PURE__ */ Uy({
  getItemOffset: function(t, n) {
    var r = t.itemSize;
    return n * r;
  },
  getItemSize: function(t, n) {
    var r = t.itemSize;
    return r;
  },
  getEstimatedTotalSize: function(t) {
    var n = t.itemCount, r = t.itemSize;
    return r * n;
  },
  getOffsetForIndexAndAlignment: function(t, n, r, o, i, a) {
    var s = t.direction, c = t.height, l = t.itemCount, u = t.itemSize, d = t.layout, m = t.width, p = s === "horizontal" || d === "horizontal", h = p ? m : c, f = Math.max(0, l * u - h), g = Math.min(f, n * u), v = Math.max(0, n * u - h + u + a);
    switch (r === "smart" && (o >= v - h && o <= g + h ? r = "auto" : r = "center"), r) {
      case "start":
        return g;
      case "end":
        return v;
      case "center": {
        var b = Math.round(v + (g - v) / 2);
        return b < Math.ceil(h / 2) ? 0 : b > f + Math.floor(h / 2) ? f : b;
      }
      case "auto":
      default:
        return o >= v && o <= g ? o : o < v ? v : g;
    }
  },
  getStartIndexForOffset: function(t, n) {
    var r = t.itemCount, o = t.itemSize;
    return Math.max(0, Math.min(r - 1, Math.floor(n / o)));
  },
  getStopIndexForStartIndex: function(t, n, r) {
    var o = t.direction, i = t.height, a = t.itemCount, s = t.itemSize, c = t.layout, l = t.width, u = o === "horizontal" || c === "horizontal", d = n * s, m = u ? l : i, p = Math.ceil((m + r - d) / s);
    return Math.max(0, Math.min(
      a - 1,
      n + p - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(t) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(t) {
    var n = t.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof n != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
  }
});
const jy = I.div`
  background: ${E.background};
  display: flex;
  flex-direction: column;
  height: 100%;

  & > button {
    min-width: 15rem;
  }
`, Ky = I.fieldset`
  all: unset;
  align-items: center;
  background-color: ${E.white300};
  border-radius: ${le.px};
  border: 1px solid ${E.inputBorderLight};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;

  &:focus-within {
    border: 1px solid ${E.fieldFocus};
  }
`, Vy = I.input`
  background-color: ${E.white300};
  border-radius: ${le.sm};
  border: none;
  color: ${E.text};
  flex-grow: 1;
  font-size: 1rem;
  height: 2rem;
  line-height: 1.1;
  outline: none;
  padding: 0 1rem;

  &::placeholder {
    color: ${E.inputPlaceholder};
  }
`;
I(sd)`
  align-items: center;
  background-color: ${E.white300};
  color: ${E.blue300};
  cursor: default;
  display: flex;
  height: 1.625rem;
  justify-content: center;

  &:hover {
    background-color: ${E.backgroundHover};
  }
`;
I(Nc)`
  height: 1rem;
  width: 1rem;
`;
const Xy = I(od)`
  overflow: hidden;
  padding: 0.315rem;
`, $d = j`
  all: unset;
  align-items: center;
  border-radius: ${le.px};
  color: ${E.text};
  display: block;
  font-size: 1rem;
  line-height: 1.1;
  overflow-x: hidden;
  padding: 0.375rem 5px 0.375rem 25px;
  pointer-events: all;
  position: relative;
  text-overflow: ellipsis;
  user-select: none;
  white-space: nowrap;
  width: 92%;
`, qy = I(id)`
  ${$d}

  &[data-disabled] {
    color: ${E.gray200};
    pointer-events: none;
  }

  &[data-highlighted],
  &:hover {
    background-color: ${E.backgroundHover};
  }
`;
I.div`
  ${$d}
`;
const kd = j`
  align-items: center;
  color: ${E.blue300};
  display: inline-flex;
  justify-content: center;
  left: 0px;
  position: absolute;
  width: 25px;
`, Jy = I(_l)`
  ${kd}
`;
I.span`
  ${kd}
`;
const Zy = I(Lf)`
  height: 1.125rem;
  width: 1.125rem;
`;
I(cd)`
  align-items: center;
  background-color: ${E.white300};
  color: ${E.blue300};
  cursor: default;
  display: flex;
  height: 25px;
  justify-content: center;

  &:hover {
    background-color: ${E.backgroundHover};
  }
`;
I(Jn)`
  height: 1rem;
  width: 1rem;
`;
const _y = I(Qy)`
  max-height: 100%;
  min-width: 400px;
  overflow-x: hidden;

  ${bn};
`, Bd = j`
  top: ${({ $top: e = 0, $itemOffset: t = 0 }) => parseInt(e.toString()) + t}px;
`, ew = I.div`
  box-sizing: border-box;

  ${Bd}
`, tw = I.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;

  ${Bd}
`, nw = I(tr)`
  ${({ $height: e = 30, $width: t = 30 }) => j`
    height: ${e}px;
    width: ${t}px;
  `}
`, rw = (e, { data: t }) => {
  var n;
  return ((n = t.at(e)) == null ? void 0 : n.id) ?? `not-found-${e}`;
}, ow = 1e3, Ld = 30, iw = 55, kC = ({
  attribute: e,
  children: t,
  data: n,
  dataCy: r = "select-filter",
  hasMore: o,
  itemHeight: i = Ld,
  next: a,
  onOpenChange: s,
  onSearch: c,
  onValueChange: l,
  pageSize: u,
  searchPlaceholder: d = "Search",
  value: m,
  ...p
}) => {
  const h = N(""), f = N(), g = N(null), v = N(null), b = N(NaN), w = N(!1), C = W(
    ({ target: L }) => {
      const z = L.value.trimStart();
      z.length <= 50 && (clearTimeout(f.current), (!z || h.current !== z) && (f.current = setTimeout(() => {
        h.current = z, c == null || c(z.trimEnd());
      }, ow)));
    },
    [c, h]
  ), T = ({
    key: L
  }) => {
    var z;
    (L === "Backspace" || /^([A-Za-z0-9_ ])$/.test(L)) && ((z = g.current) == null || z.focus());
  }, P = W(
    (L) => {
      var z;
      if (L)
        (z = g.current) == null || z.focus();
      else {
        const Z = "";
        clearTimeout(f.current), h.current !== Z && (h.current = Z, c == null || c(Z.trimEnd()));
      }
      s == null || s(L);
    },
    [s, c]
  ), M = W(
    ({ scrollOffset: L, scrollDirection: z }) => {
      const Z = v.current, ne = b.current;
      L < i && z === "backward" && Z && !isNaN(ne) && (Z.scrollTo(0, ne), b.current = NaN);
    },
    [i]
  ), R = W(
    async (L, z) => {
      var Z;
      w.current || (w.current = !0, await a(), b.current = m !== null ? ((Z = v.current) == null ? void 0 : Z.scrollTop) ?? NaN : NaN, w.current = !1);
    },
    [a, m]
  ), G = W(
    (L) => {
      const z = parseInt(L), Z = n.findIndex((K) => K.id === z), ne = Z === -1 ? null : {
        ...n[Z],
        index: Z
      };
      ne && (l == null || l(ne));
    },
    [n, l]
  ), Q = o ? n.length + 1 : n.length, U = i * u, te = Math.min(U, i * n.length), X = (L) => !o || L < n.length, F = {
    attribute: e,
    data: n,
    itemChild: t,
    value: m
  };
  return /* @__PURE__ */ x(jy, { "data-cy": `${r}-container`, children: /* @__PURE__ */ J(
    ld,
    {
      ...p,
      dataCy: `${r}-field`,
      onKeyPress: T,
      onOpenChange: P,
      onValueChange: G,
      overwritePortalHeight: te + iw,
      value: (m == null ? void 0 : m.id.toString()) ?? "",
      children: [
        /* @__PURE__ */ x(Ky, { children: /* @__PURE__ */ x(
          Vy,
          {
            "data-cy": `${r}-input-search`,
            onChange: C,
            placeholder: d,
            ref: g,
            type: "text"
          }
        ) }),
        /* @__PURE__ */ x(Xy, { "data-cy": "itens-container", children: /* @__PURE__ */ x(
          $y,
          {
            isItemLoaded: X,
            itemCount: Q,
            loadMoreItems: R,
            children: ({ onItemsRendered: L, ref: z }) => /* @__PURE__ */ x(Gd.Provider, { value: F, children: /* @__PURE__ */ x(
              _y,
              {
                height: te,
                innerElementType: (Z) => /* @__PURE__ */ x(
                  sw,
                  {
                    ...Z,
                    dataCy: r,
                    itemHeight: i
                  }
                ),
                itemCount: Q,
                itemData: F,
                itemKey: rw,
                itemSize: i,
                onItemsRendered: L,
                onScroll: M,
                outerRef: v,
                ref: z,
                width: "100%",
                children: ({
                  data: { attribute: Z, data: ne, itemChild: K, value: B },
                  index: ee,
                  style: se
                }) => ee === (B == null ? void 0 : B.index) ? null : /* @__PURE__ */ x(
                  zd,
                  {
                    attribute: Z,
                    data: ne.at(ee),
                    dataCy: r,
                    itemHeight: i,
                    itemOffset: ee < ((B == null ? void 0 : B.index) ?? NaN) ? i : 0,
                    itemStyle: se,
                    children: K
                  }
                )
              }
            ) })
          }
        ) })
      ]
    }
  ) });
}, aw = S(
  // eslint-disable-next-line no-restricted-syntax
  function({ dataCy: t = "select-filter-item", text: n, value: r, ...o }, i) {
    return /* @__PURE__ */ J(qy, { ...o, "data-cy": t, value: r, ref: i, children: [
      /* @__PURE__ */ x(ad, { "data-cy": "item-text", children: n }),
      /* @__PURE__ */ x(Jy, { "data-cy": "item-selected-indicator", children: /* @__PURE__ */ x(Zy, {}) })
    ] });
  }
), zd = S(
  // eslint-disable-next-line no-restricted-syntax
  function({
    attribute: t,
    children: n,
    data: r = null,
    dataCy: o,
    itemHeight: i,
    itemOffset: a = 0,
    itemStyle: { top: s = 0, ...c } = {},
    ...l
  }, u) {
    if (!r)
      return /* @__PURE__ */ x(
        tw,
        {
          ...l,
          $itemOffset: a,
          $top: s,
          "data-cy": `${o}-loading`,
          ref: u,
          style: c,
          children: /* @__PURE__ */ x(nw, { $height: i, $width: i })
        }
      );
    const d = r.id.toString(), m = t in r ? String(r[t]) : "-";
    return /* @__PURE__ */ x(
      ew,
      {
        ...l,
        $itemOffset: a,
        $top: s,
        "data-cy": `${o}-item`,
        ref: u,
        style: c,
        children: (n == null ? void 0 : n({
          value: d,
          dataCy: m,
          text: m,
          data: r
        })) ?? /* @__PURE__ */ x(aw, { value: d, dataCy: m, text: m })
      }
    );
  }
), Gd = $e(
  {}
), sw = S(
  // eslint-disable-next-line no-restricted-syntax
  function({
    children: t,
    dataCy: n = "select-filter",
    itemHeight: r = Ld,
    ...o
  }, i) {
    return /* @__PURE__ */ x(Gd.Consumer, { children: ({ attribute: a, data: s, itemChild: c, value: l }) => /* @__PURE__ */ J("div", { "data-cy": `${n}-inner`, ref: i, ...o, children: [
      (l == null ? void 0 : l.index) !== void 0 && /* @__PURE__ */ x(
        zd,
        {
          attribute: a,
          data: s.at(l.index),
          dataCy: `${n}-item-extra`,
          itemHeight: r,
          children: c
        }
      ),
      t
    ] }) });
  }
), cw = "data:image/png;base64,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";
var Ir = /* @__PURE__ */ ((e) => (e.SIDEBAR = "@gbs-monorepo/sidebar-shrunken", e))(Ir || {});
const Yd = (e, t, n = localStorage) => {
  const r = n.getItem(e);
  try {
    return JSON.parse(r ?? "null") ?? t ?? null;
  } catch {
    return t ?? null;
  }
}, Ri = (e, t, n = localStorage) => {
  const r = JSON.stringify(t);
  r !== void 0 && n.setItem(e, r);
}, lw = (e, t = localStorage) => {
  t.removeItem(e);
}, Hd = $e(
  {}
), BC = ({ children: e }) => {
  const [t, n] = V(
    Yd(Ir.SIDEBAR) ?? !1
  ), r = W((i) => {
    n(i), Ri(Ir.SIDEBAR, i);
  }, []), o = W(() => {
    n(!t), Ri(Ir.SIDEBAR, !t);
  }, [t]);
  return /* @__PURE__ */ x(
    Hd.Provider,
    {
      value: {
        handleShrinkSidebar: r,
        isShrunken: t,
        toggleSidebar: o
      },
      children: e
    }
  );
}, Ud = () => Je(Hd), ya = j`
  align-items: center;
  color: ${E.sidebarTextLight};
  display: flex;
  flex-direction: row;
  justify-content: ${({ $isShrunken: e = !1 }) => e ? "center" : "flex-start"};
  padding: 0.5rem 0.3125rem;
  position: relative;
  text-decoration: none;
  width: 100%;
  background-color: ${E.sidebarBackground};

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    justify-content: ${({ $isShrunken: e = !1 }) => e ? "flex-start" : "center"};
  }
`, Wd = j`
  color: ${E.sidebarText};
  background-color: ${E.sidebarBackgroundActive};

  &::after {
    background-color: ${E.blue300};
    border-bottom-right-radius: ${le.md};
    border-top-right-radius: ${le.md};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 0.25rem;
  }
`, kn = I(jf)`
  ${ya}
  border: none;
  padding: 1rem
    ${({ $isShrunken: e = !1 }) => e ? "0.75rem" : "1.875rem"};

  :hover {
    filter: brightness(0.9);
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 1rem
      ${({ $isShrunken: e = !1 }) => e ? "1.875rem" : "0.75rem"};
  }
`, Vs = I(Hr)`
  text-decoration: none;

  &.active ${kn} {
    ${Wd}
  }
`, br = I(Kf)`
  ${({ $isShrunken: e = !1 }) => e && j`
      display: none;
    `};
`, Xs = I.button`
  ${ya}
  border: none;
  padding: 1rem
    ${({ $isShrunken: e = !1 }) => e ? "0.75rem" : "1.875rem"};

  :hover {
    filter: brightness(0.9);
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 1rem
      ${({ $isShrunken: e = !1 }) => e ? "1.875rem" : "0.75rem"};
  }
`, qs = I(Hr)`
  ${ya}
  color: ${E.sidebarTextLight};
  padding: 0.875rem
    ${({ $isShrunken: e = !1 }) => e ? "0.75rem" : "1.875rem"};

  :hover {
    filter: brightness(0.9);
  }

  &.active {
    ${Wd}
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 0.875rem
      ${({ $isShrunken: e = !1 }) => e ? "1.875rem" : "0.75rem"};
  }
`, It = I.p`
  flex-grow: 1;
  font-size: 1rem;
  font-weight: 400;
  margin-left: 1rem;
  text-align: left;

  ${({ $isShrunken: e = !1 }) => e && j`
      display: none;
    `}
  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    display: block;

    ${({ $isShrunken: e = !1 }) => !e && j`
        display: none;
      `}
  }
`, dw = S(
  // eslint-disable-next-line no-restricted-syntax
  function({
    accordionValue: t,
    children: n,
    dataCy: r = "sidebar-item",
    end: o,
    icon: i,
    isShrunken: a = !1,
    onClick: s,
    title: c,
    to: l,
    type: u
  }, d) {
    return u === "accordion" && !a ? /* @__PURE__ */ J(lr, { value: t, "data-cy": r, ref: d, children: [
      /* @__PURE__ */ J(kn, { noArrow: a, $isShrunken: a, children: [
        i,
        /* @__PURE__ */ x(It, { $isShrunken: a, children: c })
      ] }),
      /* @__PURE__ */ x(br, { $isShrunken: a, children: n })
    ] }) : u === "accordion" ? /* @__PURE__ */ J(lr, { value: t, "data-cy": r, ref: d, children: [
      /* @__PURE__ */ x(Yt, { message: c, children: /* @__PURE__ */ J(kn, { noArrow: a, $isShrunken: a, children: [
        i,
        /* @__PURE__ */ x(It, { $isShrunken: a, children: c })
      ] }) }),
      /* @__PURE__ */ x(br, { $isShrunken: a, children: n })
    ] }) : u === "accordionLink" && !a ? /* @__PURE__ */ J(lr, { value: t, "data-cy": r, ref: d, children: [
      /* @__PURE__ */ x(Vs, { to: l, end: o, children: /* @__PURE__ */ J(kn, { noArrow: a, $isShrunken: a, children: [
        i,
        /* @__PURE__ */ x(It, { $isShrunken: a, children: c })
      ] }) }),
      /* @__PURE__ */ x(br, { $isShrunken: a, children: n })
    ] }) : u === "accordionLink" ? /* @__PURE__ */ J(lr, { value: t, "data-cy": r, ref: d, children: [
      /* @__PURE__ */ x(Yt, { message: c, children: /* @__PURE__ */ x(Vs, { to: l, end: o, children: /* @__PURE__ */ J(kn, { noArrow: a, $isShrunken: a, children: [
        i,
        /* @__PURE__ */ x(It, { $isShrunken: a, children: c })
      ] }) }) }),
      /* @__PURE__ */ x(br, { $isShrunken: a, children: n })
    ] }) : u === "button" && !a ? /* @__PURE__ */ J(
      Xs,
      {
        $isShrunken: a,
        "data-cy": r,
        onClick: s,
        ref: d,
        children: [
          i,
          /* @__PURE__ */ x(It, { $isShrunken: a, children: c ?? n })
        ]
      }
    ) : u === "button" ? /* @__PURE__ */ x(Yt, { message: c, children: /* @__PURE__ */ J(
      Xs,
      {
        $isShrunken: a,
        "data-cy": r,
        onClick: s,
        ref: d,
        children: [
          i,
          /* @__PURE__ */ x(It, { $isShrunken: a, children: c ?? n })
        ]
      }
    ) }) : u === "link" && !a ? /* @__PURE__ */ J(
      qs,
      {
        $isShrunken: a,
        "data-cy": r,
        end: o,
        ref: d,
        to: l,
        children: [
          i,
          /* @__PURE__ */ x(It, { $isShrunken: a, children: c ?? n })
        ]
      }
    ) : /* @__PURE__ */ x(Yt, { message: c, children: /* @__PURE__ */ J(
      qs,
      {
        $isShrunken: a,
        "data-cy": r,
        end: o,
        ref: d,
        to: l,
        children: [
          i,
          /* @__PURE__ */ x(It, { $isShrunken: a, children: c ?? n })
        ]
      }
    ) });
  }
);
function Qd(e) {
  return Ie({ tag: "svg", attr: { fill: "none", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { strokeLinecap: "round", strokeLinejoin: "round", d: "M4 6h16M4 12h16M4 18h7" } }] })(e);
}
function uw(e) {
  return Ie({ tag: "svg", attr: { fill: "none", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { strokeLinecap: "round", strokeLinejoin: "round", d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" } }] })(e);
}
function fw(e) {
  return Ie({ tag: "svg", attr: { fill: "none", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { strokeLinecap: "round", strokeLinejoin: "round", d: "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" } }] })(e);
}
function pw(e) {
  return Ie({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M3 18.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6.5C4.567 22 3 20.433 3 18.5ZM19 20V17H6.5C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20H19ZM5 15.3368C5.45463 15.1208 5.9632 15 6.5 15H19V4H6C5.44772 4 5 4.44772 5 5V15.3368Z" } }] })(e);
}
function hw(e) {
  return Ie({ tag: "svg", attr: { role: "img", viewBox: "0 0 24 24" }, child: [{ tag: "title", attr: {}, child: [] }, { tag: "path", attr: { d: "M.3013 17.6146c-.1299-.3387-.5228-1.5119-.1337-2.4314l9.8273 5.6738a.329.329 0 0 0 .3299 0L24 12.9616v2.3542l-13.8401 7.9906-9.8586-5.6918zM.1911 8.9628c-.2882.8769.0149 2.0581.1236 2.4261l9.8452 5.6841L24 9.0823V6.7275L10.3248 14.623a.329.329 0 0 1-.3299 0L.1911 8.9628zm13.1698-1.9361c-.1819.1113-.4394.0015-.4852-.2064l-.2805-1.1336-2.1254-.1752a.33.33 0 0 1-.1378-.6145l5.5782-3.2207-1.7021-.9826L.6979 8.4935l9.462 5.463 13.5104-7.8004-4.401-2.5407-5.9084 3.4113zm-.1821-1.7286.2321.938 5.1984-3.0014-2.0395-1.1775-4.994 2.8834 1.3099.108a.3302.3302 0 0 1 .2931.2495zM24 9.845l-13.6752 7.8954a.329.329 0 0 1-.3299 0L.1678 12.0667c-.3891.919.003 2.0914.1332 2.4311l9.8589 5.692L24 12.1993V9.845z" } }] })(e);
}
const mw = I.div`
  background-color: ${E.blackTranslucent400};
  display: none;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */

    ${({ $isShrunken: e = !1 }) => e && j`
        display: block;
      `}
  }
`, gw = I.nav`
  background: ${E.sidebarBackground};
  display: flex;
  position: relative;
  flex-direction: column;
  height: 100%;
  padding-top: 0.3125rem;
  border-right: 1px solid ${E.divider};
  width: ${({ $isShrunken: e = !1 }) => e ? "4.5rem" : "270px"};
  min-width: ${({ $isShrunken: e = !1 }) => e ? "4.5rem" : "270px"};

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    width: ${({ $isShrunken: e = !1 }) => e ? "270px" : "4.5rem"};
    min-width: ${({ $isShrunken: e = !1 }) => e ? "270px" : "4.5rem"};

    ${({ $isShrunken: e = !1 }) => e && j`
        position: absolute;
        z-index: 2;
      `}
  }
`, wa = j`
  align-items: center;
  color: ${E.sidebarTextLight};
  display: flex;
  flex-direction: row;
  justify-content: ${({ $isShrunken: e = !1 }) => e ? "center" : "flex-start"};
  padding: 0.5rem 0.3125rem;
  position: relative;
  text-decoration: none;
  width: 100%;
  background-color: ${E.sidebarBackground};

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    justify-content: ${({ $isShrunken: e = !1 }) => e ? "flex-start" : "center"};
  }
`, vw = I(Hr)`
  ${wa}
  padding: 0.5rem
    ${({ $isShrunken: e = !1 }) => e ? "0.3125rem" : "1.25rem"};

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 0.5rem
      ${({ $isShrunken: e = !1 }) => e ? "1.25rem" : "0.3125rem"};
  }
`, bw = I.img`
  width: 3rem;
`, Aw = I.h2`
  color: ${E.sidebarText};
  font-size: 1.125rem;
  font-weight: 700;
  margin-left: 0.5rem;

  ${({ $isShrunken: e = !1 }) => e && j`
      display: none;
    `}

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    display: block;

    ${({ $isShrunken: e = !1 }) => !e && j`
        display: none;
      `}
  }
`, yw = I.div`
  align-items: center;
  display: none;
  flex-direction: row;
  flex-grow: 1;
  justify-content: flex-end;

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */

    ${({ $isShrunken: e = !1 }) => e && j`
        display: flex;
      `}
  }
`, ww = I.button`
  all: unset;
  align-items: center;
  border-radius: ${le.full};
  color: ${E.headerText};
  cursor: pointer;
  display: none;
  font-family: inherit;
  height: 1.875rem;
  justify-content: center;
  width: 1.875rem;

  &:hover {
    background-color: ${E.white300};
    filter: brightness(0.9);
  }

  @media screen and (max-width: 600px) {
    display: flex;
  }
`, xw = I(Qd)`
  height: 1.3125rem;
  width: 1.3125rem;
`, Ew = I(Qf)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`, Cw = I.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-end;
  width: 100%;
`;
I(Hr)`
  ${wa}
  color: ${E.sidebarTextLight};
  padding: 0.875rem
    ${({ $isShrunken: e = !1 }) => e ? "0.75rem" : "1.875rem"};

  :hover {
    filter: brightness(0.9);
  }

  &.active {
    color: ${E.sidebarText};
    background-color: ${E.sidebarBackgroundActive};

    &::before {
      background-color: ${E.blue300};
      border-bottom-right-radius: 10px;
      border-top-right-radius: 10px;
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 0.25rem;
    }
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 0.875rem
      ${({ $isShrunken: e = !1 }) => e ? "1.875rem" : "0.75rem"};
  }
`;
I(Bf)`
  height: 1.5rem;
  width: 1.5rem;
`;
I(pw)`
  height: 1.5rem;
  width: 1.5rem;
`;
I(uw)`
  height: 1.5rem;
  width: 1.5rem;
`;
I(hw)`
  height: 1.5rem;
  width: 1.5rem;
  fill: transparent;
  stroke: currentColor;
  stroke-width: 1px;
`;
I(Yf)`
  height: 1.5rem;
  width: 1.5rem;
`;
I(Gf)`
  height: 1.5rem;
  width: 1.5rem;
`;
I.p`
  font-size: 1rem;
  font-weight: 400;
  margin-left: 1rem;

  ${({ $isShrunken: e = !1 }) => e && j`
      display: none;
    `}
  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    display: block;

    ${({ $isShrunken: e = !1 }) => !e && j`
        display: none;
      `}
  }
`;
I.button`
  ${wa}
  border: none;
  padding: 1rem
    ${({ $isShrunken: e = !1 }) => e ? "0.75rem" : "1.875rem"};
  position: relative;

  :hover {
    filter: brightness(0.9);
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 1rem
      ${({ $isShrunken: e = !1 }) => e ? "1.875rem" : "0.75rem"};
  }
`;
const Iw = I($f)`
  height: 1.5rem;
  width: 1.5rem;
`, Tw = "Log out", Ow = ({
  children: e,
  footerChildren: t,
  isShrunken: n = !1,
  logoRedirectTo: r = "",
  logoText: o = "Edge",
  onSignOut: i
}) => {
  const { handleShrinkSidebar: a } = Ud(), s = W(
    (d) => {
      d && a(!1);
    },
    [a]
  ), c = W(
    (d, m = !1) => {
      m && d.preventDefault(), d.stopPropagation(), window.matchMedia("(max-width: 600px)").matches && a(!1);
    },
    [a]
  ), l = W(
    (d) => {
      c(d, !0);
    },
    [c]
  ), u = W(() => {
    i == null || i();
  }, [i]);
  return /* @__PURE__ */ J(Qi, { children: [
    /* @__PURE__ */ x(
      mw,
      {
        $isShrunken: n,
        onClick: c
      }
    ),
    /* @__PURE__ */ J(gw, { $isShrunken: n, "data-cy": "sidebar", children: [
      /* @__PURE__ */ J(
        vw,
        {
          $isShrunken: n,
          "data-cy": "navLink-logo",
          onClick: c,
          to: r,
          children: [
            /* @__PURE__ */ x(bw, { src: cw }),
            /* @__PURE__ */ x(Aw, { $isShrunken: n, children: o }),
            /* @__PURE__ */ x(yw, { $isShrunken: n, children: /* @__PURE__ */ x(
              ww,
              {
                "data-cy": "button-menu",
                onClick: l,
                type: "button",
                children: /* @__PURE__ */ x(xw, {})
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ J(
        Ew,
        {
          type: "single",
          onValueChange: s,
          "data-cy": "extra-nav-link-container",
          children: [
            e,
            /* @__PURE__ */ x(Cw, { children: t })
          ]
        }
      ),
      /* @__PURE__ */ x(
        dw,
        {
          title: Tw,
          dataCy: "button-logout",
          isShrunken: n,
          onClick: u,
          type: "button",
          icon: /* @__PURE__ */ x(Iw, {})
        }
      )
    ] })
  ] });
}, Sw = I.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100vw;
`, Rw = I.div`
  align-items: center;
  border-bottom: 1px solid ${E.divider};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 1rem;
  max-width: 100%;
  padding: 0;
  margin: 0;
`, Pw = I.div`
  border-left: 1px solid ${E.divider};
  min-height: 3rem;
  text-align: center;
  display: flex;
  align-items: center;
  margin-right: 1rem;
`, Dw = I.div`
  display: flex;
  padding: 0.1rem 0.1rem;
  vertical-align: middle;
  width: 100%;
`, Mw = I.div`
  color: ${E.headerText};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`, Nw = I.header`
  align-items: center;
  border: none;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  min-height: 3rem;
`, Fw = I.button`
  all: unset;
  align-items: center;
  border-radius: 50%;
  color: ${E.headerText};
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  height: 1.875rem;
  justify-content: center;
  width: 1.875rem;

  &:hover {
    background-color: ${E.white300};
    filter: brightness(0.9);
  }
`, $w = I(Qd)`
  height: 1.3125rem;
  width: 1.3125rem;
`, kw = I(fw)`
  height: 2rem;
  width: 2rem;
`, Bw = I.p``, Lw = I.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  //background: ${E.lightGray50};
  overflow: auto;

  background: ${E.backgroundDarker};

  & > * {
    margin: 1.875rem;
  }
`, zw = I.div`
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: center;
  min-width: 100%;
`, Gw = I(fo)`
  color: ${E.headerText};
  background: transparent !important;
  width: 100%;
  justify-content: start;

  &:hover {
    background-color: ${E.backgroundHover} !important;
    filter: brightness(0.9);
  }
`, Yw = I.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`, Js = I.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 0.25rem;
`, Hw = I(H0)`
  & + & {
    margin-bottom: 0.25rem;
  }
`, Uw = I(Jn)`
  height: 1rem;
  width: 1rem;
`;
I(Yu)`
  color: ${E.text};
  display: flex;
  flex-grow: 1;
  padding: 1rem;
  text-decoration: none;

  &:visited {
    color: ${E.text};
  }
`;
const LC = ({
  children: e,
  headerChildren: t,
  logoRedirectTo: n,
  logoText: r,
  menuProfileChildren: o,
  onSignOut: i,
  sidebarChildren: a,
  sidebarFooterChildren: s,
  userName: c,
  notificationChildren: l
}) => {
  const { isShrunken: u, toggleSidebar: d } = Ud(), m = () => {
    d();
  };
  return /* @__PURE__ */ J(Sw, { "data-cy": "default-layout", children: [
    /* @__PURE__ */ x(
      Ow,
      {
        footerChildren: s == null ? void 0 : s(u),
        isShrunken: u,
        logoRedirectTo: n,
        logoText: r,
        onSignOut: i,
        children: a == null ? void 0 : a(u)
      }
    ),
    /* @__PURE__ */ J(Mw, { "data-cy": "page-with-header-container", children: [
      /* @__PURE__ */ J(Rw, { children: [
        /* @__PURE__ */ J(Nw, { "data-cy": "page-header", children: [
          /* @__PURE__ */ x(
            Fw,
            {
              "data-cy": "button-menu",
              onClick: m,
              type: "button",
              children: /* @__PURE__ */ x($w, {})
            }
          ),
          t
        ] }),
        l,
        /* @__PURE__ */ x(Pw, { children: /* @__PURE__ */ x(Dw, { children: /* @__PURE__ */ x(zw, { "data-cy": "profile-actions-container", children: /* @__PURE__ */ x(
          Y0,
          {
            customTrigger: /* @__PURE__ */ x(
              Gw,
              {
                dataCy: "dropdown-profileActions",
                noPaddingRight: !0,
                children: /* @__PURE__ */ J(Yw, { children: [
                  /* @__PURE__ */ x(Js, { children: /* @__PURE__ */ x(kw, {}) }),
                  c && /* @__PURE__ */ x(Bw, { "data-cy": c, children: c }),
                  /* @__PURE__ */ x(Js, { children: /* @__PURE__ */ x(Uw, {}) })
                ] })
              }
            ),
            disabled: o === void 0,
            zIndex: 10,
            children: o
          }
        ) }) }) })
      ] }),
      /* @__PURE__ */ x(Lw, { "data-cy": "container-pageDefault", children: e })
    ] })
  ] });
}, zC = Hw, GC = ({
  children: e,
  hiddenCloseButton: t = !0,
  dataCy: n = "side-modal",
  ...r
}) => /* @__PURE__ */ x(
  Gl,
  {
    dataCy: n,
    ...r,
    hiddenCloseButton: t,
    sideModal: !0,
    fullHeight: !0,
    children: e
  }
), Pi = I.div`
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1rem;
  text-transform: uppercase;
  padding: 0.5rem;
  padding-bottom: 0.75rem;
  position: sticky;
  top: 0;
  background-color: ${E.white300};
  z-index: 1;
`, Ww = j`
  & > div {
    border-bottom: 1px solid ${E.divider};
    ${({ $columns: e }) => j`
      &:hover:not(:nth-child(${e})) {
        filter: brightness(0.96);
        /* cursor: pointer; */
      }
    `};
  }
`, Qw = j`
  ${({ $themeStyle: e = "default" }) => e === "admin" && j`
      font-family: ${ea.admin};
    `}
`, jw = I.div`
  color: ${E.textLight};
  display: grid;
  grid-template-columns: ${({ $columns: e }) => `minmax(min(50px, 100%), 2fr) repeat(${e > 2 ? e - 2 : 0}, minmax(min(50px, 100%), 0.75fr)) auto`};
  width: 100%;

  ${bn}

  ${Ww};
  ${Qw};
`;
I(tr)`
  height: 3.25rem;
  margin-top: 1.5rem;
  width: 3.25rem;
`;
I.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;
const Kw = j`
  & > div:not(${Pi}) {
    border-bottom: 1px solid ${E.divider};
    width: 100%;
  }

  &:hover > div:not(${Pi}) {
    background-color: ${E.backgroundHover};
  }
`, Vw = I(mA)`
  cursor: ${({ $cursor: e }) => e};
  ${Kw};
`, YC = ({
  children: e,
  columns: t,
  loading: n = !1,
  dataLength: r,
  next: o,
  hasMore: i,
  endMessage: a = "You have seen it all",
  noItensMessage: s = "No items found",
  themeStyle: c = "default",
  tableStyles: l,
  ...u
}) => /* @__PURE__ */ x(
  _0,
  {
    ...u,
    dataLength: r,
    next: o,
    hasMore: i,
    loading: n,
    endMessage: r ? a : s,
    children: /* @__PURE__ */ J(
      jw,
      {
        "data-cy": "table-container",
        $columns: t.length,
        $themeStyle: c,
        style: l,
        children: [
          t.map((d) => /* @__PURE__ */ x(
            Pi,
            {
              "data-cy": "item-grid",
              style: {
                padding: d.name === "" ? "2rem 2rem 0.75rem" : "0.5rem 0.5rem 0.75rem"
              },
              children: /* @__PURE__ */ x(
                "p",
                {
                  style: {
                    textAlign: d.textAlign ?? "center"
                  },
                  "data-cy": `column-${d.name}`,
                  children: d.name
                }
              )
            },
            d.id
          )),
          e
        ]
      }
    )
  }
), HC = S(
  // eslint-disable-next-line no-restricted-syntax
  function({ cursor: t = "pointer", ...n }, r) {
    return /* @__PURE__ */ x(Vw, { ref: r, ...n, $cursor: t });
  }
), Xw = I.div`
  align-items: ${({ $alignItems: e }) => e ?? "flex-start"};
  display: flex;
  font-size: 0.75rem;
  justify-content: center;
  padding: 0.5rem;
  gap: 8px;
`, UC = ({
  dataCy: e = "table-button-action-cell",
  alignItems: t,
  children: n
}) => /* @__PURE__ */ x(Xw, { "data-cy": e, $alignItems: t, children: n }), qw = I.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 1rem;
  text-align: ${({ textAlign: e }) => e ?? "left"};
  padding: 0.5rem 0;
  justify-content: center;
  vertical-align: -webkit-baseline-middle;
`, Jw = I.p`
  color: ${E.gray350};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, Zw = I.a`
  color: ${E.gray350};
  text-decoration: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${Zf}
`, _w = I.p`
  color: ${E.gray250};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, ex = ({
  className: e,
  dataCy: t = "table-celll",
  style: n,
  subtitle: r,
  text: o,
  textAlign: i = "center",
  ...a
}) => /* @__PURE__ */ J(
  qw,
  {
    className: e,
    style: n,
    textAlign: i,
    "data-cy": o,
    children: [
      a.href ? /* @__PURE__ */ x(
        Zw,
        {
          ...a,
          title: o,
          target: "_blank",
          "data-cy": t,
          children: o
        }
      ) : /* @__PURE__ */ x(Jw, { title: o, "data-cy": `title-${t}`, children: o }),
      r && /* @__PURE__ */ x(_w, { title: r, "data-cy": `sub-title-${t}`, children: r })
    ]
  }
), tx = I.div`
  display: flex;
  width: 100%;

  ${({ center: e = !1 }) => e && j`
      align-items: center;
      justify-content: center;
    `}
`, nx = I.div`
  align-items: center;
  color: ${E.textLight};
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  width: 4rem;
`, rx = I.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${E.gray100};
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0.5rem;
`, ox = I.h1`
  color: ${E.text};
`, ix = I(iy)`
  border-radius: ${({ type: e }) => e === "icon" ? " 50%" : "none"};
  height: 40px;
  width: 40px;
  object-fit: cover;
`, ax = I(ex)`
  max-width: calc(100% - 4rem);
  width: auto;
`, WC = ({
  alt: e = "Table image",
  center: t = !1,
  children: n,
  dataCy: r = "table-image-cell",
  src: o,
  subtitle: i,
  text: a,
  textAlign: s = "left",
  type: c = "image",
  initialLikeImage: l
}) => /* @__PURE__ */ J(tx, { center: t, "data-cy": `${r}-container`, children: [
  /* @__PURE__ */ x(nx, { children: l ? /* @__PURE__ */ x(rx, { children: /* @__PURE__ */ x(ox, { children: l }) }) : /* @__PURE__ */ x(ix, { src: o, alt: e, type: c, children: n }) }),
  a && /* @__PURE__ */ x(
    ax,
    {
      text: a,
      "data-cy": r,
      subtitle: i,
      textAlign: s
    }
  )
] }), sx = I.p`
  border-radius: ${le.md};
  padding: 0.5em 0.875em;

  ${({ $type: e }) => {
  switch (e) {
    case "success":
      return j`
          background-color: ${E.statusSuccess};
          color: ${E.statusTextSuccess};
        `;
    case "accepted":
      return j`
          background-color: ${E.statusSuccess};
          color: ${E.statusTextSuccess};
        `;
    case "error":
      return j`
          background-color: ${E.statusError};
          color: ${E.statusTextError};
        `;
    case "warning":
      return j`
          background-color: ${E.statusWarning};
          color: ${E.statusTextWarning};
        `;
    case "info":
      return j`
          background-color: ${E.statusInfo};
          color: ${E.statusTextInfo};
        `;
  }
}}
`, cx = S(
  // eslint-disable-next-line no-restricted-syntax
  function({ dataCy: t = "text-status", type: n = "info", ...r }, o) {
    return /* @__PURE__ */ x(sx, { ...r, ref: o, $type: n, "data-cy": t });
  }
), lx = I.div`
  align-items: ${({ $alignItems: e }) => e ?? "flex-start"};
  display: flex;
  flex-direction: column;
  font-size: 0.75rem;
  justify-content: center;
  padding: 0.5rem;
`, QC = ({
  dataCy: e = "table-text-status",
  text: t,
  alignItems: n,
  type: r = "info",
  uppercaseFirstLetter: o = !0
}) => /* @__PURE__ */ x(lx, { "data-cy": e + "-cell", $alignItems: n, children: /* @__PURE__ */ x(cx, { type: r, dataCy: e, children: o && t ? t.charAt(0).toUpperCase() + t.slice(1) : t }) }), jC = 1, KC = 60, VC = 9999;
var XC = /* @__PURE__ */ ((e) => {
})(), qe = /* @__PURE__ */ ((e) => (e.ADMIN = "ROLE_ADMIN", e.MANAGER = "ROLE_MANAGER", e.STAFF = "ROLE_STAFF", e.CREW = "ROLE_CREW", e.VIEWER = "ROLE_VIEWER", e))(qe || {});
const qC = [
  { key: "ROLE_ADMIN", value: "Admin", level: 5 },
  { key: "ROLE_MANAGER", value: "Manager", level: 4 },
  { key: "ROLE_STAFF", value: "Staff", level: 3 },
  { key: "ROLE_CREW", value: "Crew", level: 2 },
  { key: "ROLE_VIEWER", value: "Viewer", level: 1 }
];
var jd = Symbol.for("immer-nothing"), Zs = Symbol.for("immer-draftable"), Le = Symbol.for("immer-state"), dx = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Fe(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = dx[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var mn = Object.getPrototypeOf;
function gn(e) {
  return !!e && !!e[Le];
}
function Kt(e) {
  var t;
  return e ? Kd(e) || Array.isArray(e) || !!e[Zs] || !!((t = e.constructor) != null && t[Zs]) || mo(e) || go(e) : !1;
}
var ux = Object.prototype.constructor.toString();
function Kd(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = mn(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === ux;
}
function jn(e, t) {
  ho(e) === 0 ? Object.entries(e).forEach(([n, r]) => {
    t(n, r, e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function ho(e) {
  const t = e[Le];
  return t ? t.type_ : Array.isArray(e) ? 1 : mo(e) ? 2 : go(e) ? 3 : 0;
}
function Di(e, t) {
  return ho(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Vd(e, t, n) {
  const r = ho(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function fx(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function mo(e) {
  return e instanceof Map;
}
function go(e) {
  return e instanceof Set;
}
function zt(e) {
  return e.copy_ || e.base_;
}
function Mi(e, t) {
  if (mo(e))
    return new Map(e);
  if (go(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  if (!t && Kd(e))
    return mn(e) ? { ...e } : Object.assign(/* @__PURE__ */ Object.create(null), e);
  const n = Object.getOwnPropertyDescriptors(e);
  delete n[Le];
  let r = Reflect.ownKeys(n);
  for (let o = 0; o < r.length; o++) {
    const i = r[o], a = n[i];
    a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (n[i] = {
      configurable: !0,
      writable: !0,
      // could live with !!desc.set as well here...
      enumerable: a.enumerable,
      value: e[i]
    });
  }
  return Object.create(mn(e), n);
}
function xa(e, t = !1) {
  return vo(e) || gn(e) || !Kt(e) || (ho(e) > 1 && (e.set = e.add = e.clear = e.delete = px), Object.freeze(e), t && jn(e, (n, r) => xa(r, !0))), e;
}
function px() {
  Fe(2);
}
function vo(e) {
  return Object.isFrozen(e);
}
var hx = {};
function Vt(e) {
  const t = hx[e];
  return t || Fe(0, e), t;
}
var Kn;
function Xd() {
  return Kn;
}
function mx(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function _s(e, t) {
  t && (Vt("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Ni(e) {
  Fi(e), e.drafts_.forEach(gx), e.drafts_ = null;
}
function Fi(e) {
  e === Kn && (Kn = e.parent_);
}
function ec(e) {
  return Kn = mx(Kn, e);
}
function gx(e) {
  const t = e[Le];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function tc(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[Le].modified_ && (Ni(t), Fe(4)), Kt(e) && (e = $r(t, e), t.parent_ || kr(t, e)), t.patches_ && Vt("Patches").generateReplacementPatches_(
    n[Le].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = $r(t, n, []), Ni(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== jd ? e : void 0;
}
function $r(e, t, n) {
  if (vo(t))
    return t;
  const r = t[Le];
  if (!r)
    return jn(
      t,
      (o, i) => nc(e, r, t, o, i, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return kr(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const o = r.copy_;
    let i = o, a = !1;
    r.type_ === 3 && (i = new Set(o), o.clear(), a = !0), jn(
      i,
      (s, c) => nc(e, r, o, s, c, n, a)
    ), kr(e, o, !1), n && e.patches_ && Vt("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function nc(e, t, n, r, o, i, a) {
  if (process.env.NODE_ENV !== "production" && o === n && Fe(5), gn(o)) {
    const s = i && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Di(t.assigned_, r) ? i.concat(r) : void 0, c = $r(e, o, s);
    if (Vd(n, r, c), gn(c))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    a && n.add(o);
  if (Kt(o) && !vo(o)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    $r(e, o), (!t || !t.scope_.parent_) && kr(e, o);
  }
}
function kr(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && xa(t, n);
}
function vx(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Xd(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = r, i = Ea;
  n && (o = [r], i = Vn);
  const { revoke: a, proxy: s } = Proxy.revocable(o, i);
  return r.draft_ = s, r.revoke_ = a, s;
}
var Ea = {
  get(e, t) {
    if (t === Le)
      return e;
    const n = zt(e);
    if (!Di(n, t))
      return bx(e, n, t);
    const r = n[t];
    return e.finalized_ || !Kt(r) ? r : r === qo(e.base_, t) ? (Jo(e), e.copy_[t] = ki(r, e)) : r;
  },
  has(e, t) {
    return t in zt(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(zt(e));
  },
  set(e, t, n) {
    const r = qd(zt(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const o = qo(zt(e), t), i = o == null ? void 0 : o[Le];
      if (i && i.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (fx(n, o) && (n !== void 0 || Di(e.base_, t)))
        return !0;
      Jo(e), $i(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return qo(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, Jo(e), $i(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = zt(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    Fe(11);
  },
  getPrototypeOf(e) {
    return mn(e.base_);
  },
  setPrototypeOf() {
    Fe(12);
  }
}, Vn = {};
jn(Ea, (e, t) => {
  Vn[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Vn.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Fe(13), Vn.set.call(this, e, t, void 0);
};
Vn.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Fe(14), Ea.set.call(this, e[0], t, n, e[0]);
};
function qo(e, t) {
  const n = e[Le];
  return (n ? zt(n) : e)[t];
}
function bx(e, t, n) {
  var o;
  const r = qd(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (o = r.get) == null ? void 0 : o.call(e.draft_)
  ) : void 0;
}
function qd(e, t) {
  if (!(t in e))
    return;
  let n = mn(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = mn(n);
  }
}
function $i(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && $i(e.parent_));
}
function Jo(e) {
  e.copy_ || (e.copy_ = Mi(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var Ax = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const i = n;
        n = t;
        const a = this;
        return function(c = i, ...l) {
          return a.produce(c, (u) => n.call(this, u, ...l));
        };
      }
      typeof n != "function" && Fe(6), r !== void 0 && typeof r != "function" && Fe(7);
      let o;
      if (Kt(t)) {
        const i = ec(this), a = ki(t, void 0);
        let s = !0;
        try {
          o = n(a), s = !1;
        } finally {
          s ? Ni(i) : Fi(i);
        }
        return _s(i, r), tc(o, i);
      } else if (!t || typeof t != "object") {
        if (o = n(t), o === void 0 && (o = t), o === jd && (o = void 0), this.autoFreeze_ && xa(o, !0), r) {
          const i = [], a = [];
          Vt("Patches").generateReplacementPatches_(t, o, i, a), r(i, a);
        }
        return o;
      } else
        Fe(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (a, ...s) => this.produceWithPatches(a, (c) => t(c, ...s));
      let r, o;
      return [this.produce(t, n, (a, s) => {
        r = a, o = s;
      }), r, o];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    Kt(e) || Fe(8), gn(e) && (e = yx(e));
    const t = ec(this), n = ki(e, void 0);
    return n[Le].isManual_ = !0, Fi(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[Le];
    (!n || !n.isManual_) && Fe(9);
    const { scope_: r } = n;
    return _s(r, t), tc(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const o = t[n];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = Vt("Patches").applyPatches_;
    return gn(e) ? r(e, t) : this.produce(
      e,
      (o) => r(o, t)
    );
  }
};
function ki(e, t) {
  const n = mo(e) ? Vt("MapSet").proxyMap_(e, t) : go(e) ? Vt("MapSet").proxySet_(e, t) : vx(e, t);
  return (t ? t.scope_ : Xd()).drafts_.push(n), n;
}
function yx(e) {
  return gn(e) || Fe(10, e), Jd(e);
}
function Jd(e) {
  if (!Kt(e) || vo(e))
    return e;
  const t = e[Le];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = Mi(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = Mi(e, !0);
  return jn(n, (r, o) => {
    Vd(n, r, Jd(o));
  }), t && (t.finalized_ = !1), n;
}
var ze = new Ax(), rc = ze.produce;
ze.produceWithPatches.bind(
  ze
);
ze.setAutoFreeze.bind(ze);
ze.setUseStrictShallowCopy.bind(ze);
ze.applyPatches.bind(ze);
ze.createDraft.bind(ze);
ze.finishDraft.bind(ze);
const Zd = $e(
  {}
), JC = ({ children: e }) => {
  const [t, n] = V([]), r = W((i) => {
    i.key = (/* @__PURE__ */ new Date()).getTime(), n(
      rc((a) => {
        a.push(i);
      })
    );
  }, []), o = (i, a) => {
    i || n(
      rc((s) => {
        s.splice(a, 1);
      })
    );
  };
  return /* @__PURE__ */ x(
    Zd.Provider,
    {
      value: {
        addToast: r
      },
      children: /* @__PURE__ */ J(j1, { children: [
        e,
        t.map(({ key: i, ...a }, s) => /* @__PURE__ */ A(
          cA,
          {
            ...a,
            key: i,
            onOpenChange: (c) => {
              o(c, s);
            }
          }
        )),
        /* @__PURE__ */ x(lA, {})
      ] })
    }
  );
}, ZC = () => Je(Zd);
function _d(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: wx } = Object.prototype, { getPrototypeOf: Ca } = Object, bo = ((e) => (t) => {
  const n = wx.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), lt = (e) => (e = e.toLowerCase(), (t) => bo(t) === e), Ao = (e) => (t) => typeof t === e, { isArray: Tn } = Array, Xn = Ao("undefined");
function xx(e) {
  return e !== null && !Xn(e) && e.constructor !== null && !Xn(e.constructor) && Qe(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const eu = lt("ArrayBuffer");
function Ex(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && eu(e.buffer), t;
}
const Cx = Ao("string"), Qe = Ao("function"), tu = Ao("number"), yo = (e) => e !== null && typeof e == "object", Ix = (e) => e === !0 || e === !1, Tr = (e) => {
  if (bo(e) !== "object")
    return !1;
  const t = Ca(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Tx = lt("Date"), Ox = lt("File"), Sx = lt("Blob"), Rx = lt("FileList"), Px = (e) => yo(e) && Qe(e.pipe), Dx = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Qe(e.append) && ((t = bo(e)) === "formdata" || // detect form-data instance
  t === "object" && Qe(e.toString) && e.toString() === "[object FormData]"));
}, Mx = lt("URLSearchParams"), Nx = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ir(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), Tn(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let s;
    for (r = 0; r < a; r++)
      s = i[r], t.call(null, e[s], s, e);
  }
}
function nu(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const ru = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), ou = (e) => !Xn(e) && e !== ru;
function Bi() {
  const { caseless: e } = ou(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && nu(t, o) || o;
    Tr(t[i]) && Tr(r) ? t[i] = Bi(t[i], r) : Tr(r) ? t[i] = Bi({}, r) : Tn(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && ir(arguments[r], n);
  return t;
}
const Fx = (e, t, n, { allOwnKeys: r } = {}) => (ir(t, (o, i) => {
  n && Qe(o) ? e[i] = _d(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), $x = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), kx = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Bx = (e, t, n, r) => {
  let o, i, a;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!r || r(a, e, t)) && !s[a] && (t[a] = e[a], s[a] = !0);
    e = n !== !1 && Ca(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Lx = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, zx = (e) => {
  if (!e)
    return null;
  if (Tn(e))
    return e;
  let t = e.length;
  if (!tu(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Gx = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Ca(Uint8Array)), Yx = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, Hx = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Ux = lt("HTMLFormElement"), Wx = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), oc = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Qx = lt("RegExp"), iu = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  ir(n, (o, i) => {
    t(o, i, e) !== !1 && (r[i] = o);
  }), Object.defineProperties(e, r);
}, jx = (e) => {
  iu(e, (t, n) => {
    if (Qe(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Qe(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Kx = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return Tn(e) ? r(e) : r(String(e).split(t)), n;
}, Vx = () => {
}, Xx = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Zo = "abcdefghijklmnopqrstuvwxyz", ic = "0123456789", au = {
  DIGIT: ic,
  ALPHA: Zo,
  ALPHA_DIGIT: Zo + Zo.toUpperCase() + ic
}, qx = (e = 16, t = au.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function Jx(e) {
  return !!(e && Qe(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Zx = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (yo(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = Tn(r) ? [] : {};
        return ir(r, (a, s) => {
          const c = n(a, o + 1);
          !Xn(c) && (i[s] = c);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, _x = lt("AsyncFunction"), eE = (e) => e && (yo(e) || Qe(e)) && Qe(e.then) && Qe(e.catch), D = {
  isArray: Tn,
  isArrayBuffer: eu,
  isBuffer: xx,
  isFormData: Dx,
  isArrayBufferView: Ex,
  isString: Cx,
  isNumber: tu,
  isBoolean: Ix,
  isObject: yo,
  isPlainObject: Tr,
  isUndefined: Xn,
  isDate: Tx,
  isFile: Ox,
  isBlob: Sx,
  isRegExp: Qx,
  isFunction: Qe,
  isStream: Px,
  isURLSearchParams: Mx,
  isTypedArray: Gx,
  isFileList: Rx,
  forEach: ir,
  merge: Bi,
  extend: Fx,
  trim: Nx,
  stripBOM: $x,
  inherits: kx,
  toFlatObject: Bx,
  kindOf: bo,
  kindOfTest: lt,
  endsWith: Lx,
  toArray: zx,
  forEachEntry: Yx,
  matchAll: Hx,
  isHTMLForm: Ux,
  hasOwnProperty: oc,
  hasOwnProp: oc,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: iu,
  freezeMethods: jx,
  toObjectSet: Kx,
  toCamelCase: Wx,
  noop: Vx,
  toFiniteNumber: Xx,
  findKey: nu,
  global: ru,
  isContextDefined: ou,
  ALPHABET: au,
  generateString: qx,
  isSpecCompliantForm: Jx,
  toJSONObject: Zx,
  isAsyncFn: _x,
  isThenable: eE
};
function pe(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o);
}
D.inherits(pe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: D.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const su = pe.prototype, cu = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  cu[e] = { value: e };
});
Object.defineProperties(pe, cu);
Object.defineProperty(su, "isAxiosError", { value: !0 });
pe.from = (e, t, n, r, o, i) => {
  const a = Object.create(su);
  return D.toFlatObject(e, a, function(c) {
    return c !== Error.prototype;
  }, (s) => s !== "isAxiosError"), pe.call(a, e.message, t, n, r, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const tE = null;
function Li(e) {
  return D.isPlainObject(e) || D.isArray(e);
}
function lu(e) {
  return D.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ac(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = lu(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function nE(e) {
  return D.isArray(e) && !e.some(Li);
}
const rE = D.toFlatObject(D, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function wo(e, t, n) {
  if (!D.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = D.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(f, g) {
    return !D.isUndefined(g[f]);
  });
  const r = n.metaTokens, o = n.visitor || u, i = n.dots, a = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && D.isSpecCompliantForm(t);
  if (!D.isFunction(o))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null)
      return "";
    if (D.isDate(h))
      return h.toISOString();
    if (!c && D.isBlob(h))
      throw new pe("Blob is not supported. Use a Buffer instead.");
    return D.isArrayBuffer(h) || D.isTypedArray(h) ? c && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function u(h, f, g) {
    let v = h;
    if (h && !g && typeof h == "object") {
      if (D.endsWith(f, "{}"))
        f = r ? f : f.slice(0, -2), h = JSON.stringify(h);
      else if (D.isArray(h) && nE(h) || (D.isFileList(h) || D.endsWith(f, "[]")) && (v = D.toArray(h)))
        return f = lu(f), v.forEach(function(w, C) {
          !(D.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? ac([f], C, i) : a === null ? f : f + "[]",
            l(w)
          );
        }), !1;
    }
    return Li(h) ? !0 : (t.append(ac(g, f, i), l(h)), !1);
  }
  const d = [], m = Object.assign(rE, {
    defaultVisitor: u,
    convertValue: l,
    isVisitable: Li
  });
  function p(h, f) {
    if (!D.isUndefined(h)) {
      if (d.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      d.push(h), D.forEach(h, function(v, b) {
        (!(D.isUndefined(v) || v === null) && o.call(
          t,
          v,
          D.isString(b) ? b.trim() : b,
          f,
          m
        )) === !0 && p(v, f ? f.concat(b) : [b]);
      }), d.pop();
    }
  }
  if (!D.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function sc(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Ia(e, t) {
  this._pairs = [], e && wo(e, this, t);
}
const du = Ia.prototype;
du.append = function(t, n) {
  this._pairs.push([t, n]);
};
du.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, sc);
  } : sc;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function oE(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function uu(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || oE, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = D.isURLSearchParams(t) ? t.toString() : new Ia(t, n).toString(r), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class iE {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    D.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const cc = iE, fu = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, aE = typeof URLSearchParams < "u" ? URLSearchParams : Ia, sE = typeof FormData < "u" ? FormData : null, cE = typeof Blob < "u" ? Blob : null, lE = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), dE = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), it = {
  isBrowser: !0,
  classes: {
    URLSearchParams: aE,
    FormData: sE,
    Blob: cE
  },
  isStandardBrowserEnv: lE,
  isStandardBrowserWebWorkerEnv: dE,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function uE(e, t) {
  return wo(e, new it.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return it.isNode && D.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function fE(e) {
  return D.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function pE(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function pu(e) {
  function t(n, r, o, i) {
    let a = n[i++];
    const s = Number.isFinite(+a), c = i >= n.length;
    return a = !a && D.isArray(o) ? o.length : a, c ? (D.hasOwnProp(o, a) ? o[a] = [o[a], r] : o[a] = r, !s) : ((!o[a] || !D.isObject(o[a])) && (o[a] = []), t(n, r, o[a], i) && D.isArray(o[a]) && (o[a] = pE(o[a])), !s);
  }
  if (D.isFormData(e) && D.isFunction(e.entries)) {
    const n = {};
    return D.forEachEntry(e, (r, o) => {
      t(fE(r), o, n, 0);
    }), n;
  }
  return null;
}
const hE = {
  "Content-Type": void 0
};
function mE(e, t, n) {
  if (D.isString(e))
    try {
      return (t || JSON.parse)(e), D.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const xo = {
  transitional: fu,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, i = D.isObject(t);
    if (i && D.isHTMLForm(t) && (t = new FormData(t)), D.isFormData(t))
      return o && o ? JSON.stringify(pu(t)) : t;
    if (D.isArrayBuffer(t) || D.isBuffer(t) || D.isStream(t) || D.isFile(t) || D.isBlob(t))
      return t;
    if (D.isArrayBufferView(t))
      return t.buffer;
    if (D.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return uE(t, this.formSerializer).toString();
      if ((s = D.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return wo(
          s ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), mE(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || xo.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (t && D.isString(t) && (r && !this.responseType || o)) {
      const a = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (a)
          throw s.name === "SyntaxError" ? pe.from(s, pe.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: it.classes.FormData,
    Blob: it.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
D.forEach(["delete", "get", "head"], function(t) {
  xo.headers[t] = {};
});
D.forEach(["post", "put", "patch"], function(t) {
  xo.headers[t] = D.merge(hE);
});
const Ta = xo, gE = D.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), vE = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), n = a.substring(0, o).trim().toLowerCase(), r = a.substring(o + 1).trim(), !(!n || t[n] && gE[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, lc = Symbol("internals");
function Nn(e) {
  return e && String(e).trim().toLowerCase();
}
function Or(e) {
  return e === !1 || e == null ? e : D.isArray(e) ? e.map(Or) : String(e);
}
function bE(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const AE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function _o(e, t, n, r, o) {
  if (D.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!D.isString(t)) {
    if (D.isString(r))
      return t.indexOf(r) !== -1;
    if (D.isRegExp(r))
      return r.test(t);
  }
}
function yE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function wE(e, t) {
  const n = D.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, a) {
        return this[r].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
class Eo {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(s, c, l) {
      const u = Nn(c);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = D.findKey(o, u);
      (!d || o[d] === void 0 || l === !0 || l === void 0 && o[d] !== !1) && (o[d || c] = Or(s));
    }
    const a = (s, c) => D.forEach(s, (l, u) => i(l, u, c));
    return D.isPlainObject(t) || t instanceof this.constructor ? a(t, n) : D.isString(t) && (t = t.trim()) && !AE(t) ? a(vE(t), n) : t != null && i(n, t, r), this;
  }
  get(t, n) {
    if (t = Nn(t), t) {
      const r = D.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return bE(o);
        if (D.isFunction(n))
          return n.call(this, o, r);
        if (D.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Nn(t), t) {
      const r = D.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || _o(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(a) {
      if (a = Nn(a), a) {
        const s = D.findKey(r, a);
        s && (!n || _o(r, r[s], s, n)) && (delete r[s], o = !0);
      }
    }
    return D.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || _o(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return D.forEach(this, (o, i) => {
      const a = D.findKey(r, i);
      if (a) {
        n[a] = Or(o), delete n[i];
        return;
      }
      const s = t ? yE(i) : String(i).trim();
      s !== i && delete n[i], n[s] = Or(o), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return D.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && D.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[lc] = this[lc] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(a) {
      const s = Nn(a);
      r[s] || (wE(o, a), r[s] = !0);
    }
    return D.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
Eo.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
D.freezeMethods(Eo.prototype);
D.freezeMethods(Eo);
const vt = Eo;
function ei(e, t) {
  const n = this || Ta, r = t || n, o = vt.from(r.headers);
  let i = r.data;
  return D.forEach(e, function(s) {
    i = s.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function hu(e) {
  return !!(e && e.__CANCEL__);
}
function ar(e, t, n) {
  pe.call(this, e ?? "canceled", pe.ERR_CANCELED, t, n), this.name = "CanceledError";
}
D.inherits(ar, pe, {
  __CANCEL__: !0
});
function xE(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new pe(
    "Request failed with status code " + n.status,
    [pe.ERR_BAD_REQUEST, pe.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const EE = it.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(n, r, o, i, a, s) {
        const c = [];
        c.push(n + "=" + encodeURIComponent(r)), D.isNumber(o) && c.push("expires=" + new Date(o).toGMTString()), D.isString(i) && c.push("path=" + i), D.isString(a) && c.push("domain=" + a), s === !0 && c.push("secure"), document.cookie = c.join("; ");
      },
      read: function(n) {
        const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function CE(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function IE(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function mu(e, t) {
  return e && !CE(t) ? IE(e, t) : t;
}
const TE = it.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function o(i) {
      let a = i;
      return t && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(a) {
      const s = D.isString(a) ? o(a) : a;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function OE(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function SE(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const l = Date.now(), u = r[i];
    a || (a = l), n[o] = c, r[o] = l;
    let d = i, m = 0;
    for (; d !== o; )
      m += n[d++], d = d % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), l - a < t)
      return;
    const p = u && l - u;
    return p ? Math.round(m * 1e3 / p) : void 0;
  };
}
function dc(e, t) {
  let n = 0;
  const r = SE(50, 250);
  return (o) => {
    const i = o.loaded, a = o.lengthComputable ? o.total : void 0, s = i - n, c = r(s), l = i <= a;
    n = i;
    const u = {
      loaded: i,
      total: a,
      progress: a ? i / a : void 0,
      bytes: s,
      rate: c || void 0,
      estimated: c && a && l ? (a - i) / c : void 0,
      event: o
    };
    u[t ? "download" : "upload"] = !0, e(u);
  };
}
const RE = typeof XMLHttpRequest < "u", PE = RE && function(e) {
  return new Promise(function(n, r) {
    let o = e.data;
    const i = vt.from(e.headers).normalize(), a = e.responseType;
    let s;
    function c() {
      e.cancelToken && e.cancelToken.unsubscribe(s), e.signal && e.signal.removeEventListener("abort", s);
    }
    D.isFormData(o) && (it.isStandardBrowserEnv || it.isStandardBrowserWebWorkerEnv ? i.setContentType(!1) : i.setContentType("multipart/form-data;", !1));
    let l = new XMLHttpRequest();
    if (e.auth) {
      const p = e.auth.username || "", h = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      i.set("Authorization", "Basic " + btoa(p + ":" + h));
    }
    const u = mu(e.baseURL, e.url);
    l.open(e.method.toUpperCase(), uu(u, e.params, e.paramsSerializer), !0), l.timeout = e.timeout;
    function d() {
      if (!l)
        return;
      const p = vt.from(
        "getAllResponseHeaders" in l && l.getAllResponseHeaders()
      ), f = {
        data: !a || a === "text" || a === "json" ? l.responseText : l.response,
        status: l.status,
        statusText: l.statusText,
        headers: p,
        config: e,
        request: l
      };
      xE(function(v) {
        n(v), c();
      }, function(v) {
        r(v), c();
      }, f), l = null;
    }
    if ("onloadend" in l ? l.onloadend = d : l.onreadystatechange = function() {
      !l || l.readyState !== 4 || l.status === 0 && !(l.responseURL && l.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, l.onabort = function() {
      l && (r(new pe("Request aborted", pe.ECONNABORTED, e, l)), l = null);
    }, l.onerror = function() {
      r(new pe("Network Error", pe.ERR_NETWORK, e, l)), l = null;
    }, l.ontimeout = function() {
      let h = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const f = e.transitional || fu;
      e.timeoutErrorMessage && (h = e.timeoutErrorMessage), r(new pe(
        h,
        f.clarifyTimeoutError ? pe.ETIMEDOUT : pe.ECONNABORTED,
        e,
        l
      )), l = null;
    }, it.isStandardBrowserEnv) {
      const p = (e.withCredentials || TE(u)) && e.xsrfCookieName && EE.read(e.xsrfCookieName);
      p && i.set(e.xsrfHeaderName, p);
    }
    o === void 0 && i.setContentType(null), "setRequestHeader" in l && D.forEach(i.toJSON(), function(h, f) {
      l.setRequestHeader(f, h);
    }), D.isUndefined(e.withCredentials) || (l.withCredentials = !!e.withCredentials), a && a !== "json" && (l.responseType = e.responseType), typeof e.onDownloadProgress == "function" && l.addEventListener("progress", dc(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && l.upload && l.upload.addEventListener("progress", dc(e.onUploadProgress)), (e.cancelToken || e.signal) && (s = (p) => {
      l && (r(!p || p.type ? new ar(null, e, l) : p), l.abort(), l = null);
    }, e.cancelToken && e.cancelToken.subscribe(s), e.signal && (e.signal.aborted ? s() : e.signal.addEventListener("abort", s)));
    const m = OE(u);
    if (m && it.protocols.indexOf(m) === -1) {
      r(new pe("Unsupported protocol " + m + ":", pe.ERR_BAD_REQUEST, e));
      return;
    }
    l.send(o || null);
  });
}, Sr = {
  http: tE,
  xhr: PE
};
D.forEach(Sr, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const DE = {
  getAdapter: (e) => {
    e = D.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    for (let o = 0; o < t && (n = e[o], !(r = D.isString(n) ? Sr[n.toLowerCase()] : n)); o++)
      ;
    if (!r)
      throw r === !1 ? new pe(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        D.hasOwnProp(Sr, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!D.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: Sr
};
function ti(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ar(null, e);
}
function uc(e) {
  return ti(e), e.headers = vt.from(e.headers), e.data = ei.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), DE.getAdapter(e.adapter || Ta.adapter)(e).then(function(r) {
    return ti(e), r.data = ei.call(
      e,
      e.transformResponse,
      r
    ), r.headers = vt.from(r.headers), r;
  }, function(r) {
    return hu(r) || (ti(e), r && r.response && (r.response.data = ei.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = vt.from(r.response.headers))), Promise.reject(r);
  });
}
const fc = (e) => e instanceof vt ? e.toJSON() : e;
function vn(e, t) {
  t = t || {};
  const n = {};
  function r(l, u, d) {
    return D.isPlainObject(l) && D.isPlainObject(u) ? D.merge.call({ caseless: d }, l, u) : D.isPlainObject(u) ? D.merge({}, u) : D.isArray(u) ? u.slice() : u;
  }
  function o(l, u, d) {
    if (D.isUndefined(u)) {
      if (!D.isUndefined(l))
        return r(void 0, l, d);
    } else
      return r(l, u, d);
  }
  function i(l, u) {
    if (!D.isUndefined(u))
      return r(void 0, u);
  }
  function a(l, u) {
    if (D.isUndefined(u)) {
      if (!D.isUndefined(l))
        return r(void 0, l);
    } else
      return r(void 0, u);
  }
  function s(l, u, d) {
    if (d in t)
      return r(l, u);
    if (d in e)
      return r(void 0, l);
  }
  const c = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s,
    headers: (l, u) => o(fc(l), fc(u), !0)
  };
  return D.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = c[u] || o, m = d(e[u], t[u], u);
    D.isUndefined(m) && d !== s || (n[u] = m);
  }), n;
}
const gu = "1.4.0", Oa = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Oa[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const pc = {};
Oa.transitional = function(t, n, r) {
  function o(i, a) {
    return "[Axios v" + gu + "] Transitional option '" + i + "'" + a + (r ? ". " + r : "");
  }
  return (i, a, s) => {
    if (t === !1)
      throw new pe(
        o(a, " has been removed" + (n ? " in " + n : "")),
        pe.ERR_DEPRECATED
      );
    return n && !pc[a] && (pc[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, a, s) : !0;
  };
};
function ME(e, t, n) {
  if (typeof e != "object")
    throw new pe("options must be an object", pe.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], a = t[i];
    if (a) {
      const s = e[i], c = s === void 0 || a(s, i, e);
      if (c !== !0)
        throw new pe("option " + i + " must be " + c, pe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new pe("Unknown option " + i, pe.ERR_BAD_OPTION);
  }
}
const zi = {
  assertOptions: ME,
  validators: Oa
}, Tt = zi.validators;
class Br {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new cc(),
      response: new cc()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = vn(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && zi.assertOptions(r, {
      silentJSONParsing: Tt.transitional(Tt.boolean),
      forcedJSONParsing: Tt.transitional(Tt.boolean),
      clarifyTimeoutError: Tt.transitional(Tt.boolean)
    }, !1), o != null && (D.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : zi.assertOptions(o, {
      encode: Tt.function,
      serialize: Tt.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a;
    a = i && D.merge(
      i.common,
      i[n.method]
    ), a && D.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete i[h];
      }
    ), n.headers = vt.concat(a, i);
    const s = [];
    let c = !0;
    this.interceptors.request.forEach(function(f) {
      typeof f.runWhen == "function" && f.runWhen(n) === !1 || (c = c && f.synchronous, s.unshift(f.fulfilled, f.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(f) {
      l.push(f.fulfilled, f.rejected);
    });
    let u, d = 0, m;
    if (!c) {
      const h = [uc.bind(this), void 0];
      for (h.unshift.apply(h, s), h.push.apply(h, l), m = h.length, u = Promise.resolve(n); d < m; )
        u = u.then(h[d++], h[d++]);
      return u;
    }
    m = s.length;
    let p = n;
    for (d = 0; d < m; ) {
      const h = s[d++], f = s[d++];
      try {
        p = h(p);
      } catch (g) {
        f.call(this, g);
        break;
      }
    }
    try {
      u = uc.call(this, p);
    } catch (h) {
      return Promise.reject(h);
    }
    for (d = 0, m = l.length; d < m; )
      u = u.then(l[d++], l[d++]);
    return u;
  }
  getUri(t) {
    t = vn(this.defaults, t);
    const n = mu(t.baseURL, t.url);
    return uu(n, t.params, t.paramsSerializer);
  }
}
D.forEach(["delete", "get", "head", "options"], function(t) {
  Br.prototype[t] = function(n, r) {
    return this.request(vn(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
D.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, a, s) {
      return this.request(vn(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  Br.prototype[t] = n(), Br.prototype[t + "Form"] = n(!0);
});
const Rr = Br;
class Sa {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(o);
      return a.cancel = function() {
        r.unsubscribe(i);
      }, a;
    }, t(function(i, a, s) {
      r.reason || (r.reason = new ar(i, a, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Sa(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const NE = Sa;
function FE(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function $E(e) {
  return D.isObject(e) && e.isAxiosError === !0;
}
const Gi = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Gi).forEach(([e, t]) => {
  Gi[t] = e;
});
const kE = Gi;
function vu(e) {
  const t = new Rr(e), n = _d(Rr.prototype.request, t);
  return D.extend(n, Rr.prototype, t, { allOwnKeys: !0 }), D.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return vu(vn(e, o));
  }, n;
}
const Ee = vu(Ta);
Ee.Axios = Rr;
Ee.CanceledError = ar;
Ee.CancelToken = NE;
Ee.isCancel = hu;
Ee.VERSION = gu;
Ee.toFormData = wo;
Ee.AxiosError = pe;
Ee.Cancel = Ee.CanceledError;
Ee.all = function(t) {
  return Promise.all(t);
};
Ee.spread = FE;
Ee.isAxiosError = $E;
Ee.mergeConfig = vn;
Ee.AxiosHeaders = vt;
Ee.formToJSON = (e) => pu(D.isHTMLForm(e) ? new FormData(e) : e);
Ee.HttpStatusCode = kE;
Ee.default = Ee;
const BE = Ee, _C = "AVOID_CONCURRENCY", eI = (e = !1) => {
  const t = new AbortController();
  return {
    abort: (n) => {
      t.abort(n);
    },
    avoidConcurrency: e,
    getReason: () => t.signal.reason,
    signal: t.signal
  };
}, tI = (e) => e instanceof Error && e.name === "CanceledError", nI = (e, t) => e.getReason() === t, rI = (e, t, n) => n ? e.filter(
  (r) => r[t].trim().toLowerCase().includes(n.toLowerCase())
) : e;
function Lr(e) {
  "@babel/helpers - typeof";
  return Lr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Lr(e);
}
function Xt(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Pe(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Ge(e) {
  Pe(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Lr(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function LE(e, t) {
  Pe(2, arguments);
  var n = Ge(e).getTime(), r = Xt(t);
  return new Date(n + r);
}
var zE = {};
function Co() {
  return zE;
}
function GE(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function YE(e, t) {
  Pe(2, arguments);
  var n = Ge(e), r = Ge(t), o = n.getTime() - r.getTime();
  return o > 0 ? -1 : o < 0 ? 1 : o;
}
function HE(e) {
  return Pe(1, arguments), e instanceof Date || Lr(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function UE(e) {
  if (Pe(1, arguments), !HE(e) && typeof e != "number")
    return !1;
  var t = Ge(e);
  return !isNaN(Number(t));
}
function WE(e, t) {
  Pe(2, arguments);
  var n = Xt(t);
  return LE(e, -n);
}
var QE = 864e5;
function jE(e) {
  Pe(1, arguments);
  var t = Ge(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), o = n - r;
  return Math.floor(o / QE) + 1;
}
function zr(e) {
  Pe(1, arguments);
  var t = 1, n = Ge(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function bu(e) {
  Pe(1, arguments);
  var t = Ge(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = zr(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var a = zr(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function KE(e) {
  Pe(1, arguments);
  var t = bu(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = zr(n);
  return r;
}
var VE = 6048e5;
function XE(e) {
  Pe(1, arguments);
  var t = Ge(e), n = zr(t).getTime() - KE(t).getTime();
  return Math.round(n / VE) + 1;
}
function Gr(e, t) {
  var n, r, o, i, a, s, c, l;
  Pe(1, arguments);
  var u = Co(), d = Xt((n = (r = (o = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = Ge(e), p = m.getUTCDay(), h = (p < d ? 7 : 0) + p - d;
  return m.setUTCDate(m.getUTCDate() - h), m.setUTCHours(0, 0, 0, 0), m;
}
function Au(e, t) {
  var n, r, o, i, a, s, c, l;
  Pe(1, arguments);
  var u = Ge(e), d = u.getUTCFullYear(), m = Co(), p = Xt((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : m.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = m.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(d + 1, 0, p), h.setUTCHours(0, 0, 0, 0);
  var f = Gr(h, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(d, 0, p), g.setUTCHours(0, 0, 0, 0);
  var v = Gr(g, t);
  return u.getTime() >= f.getTime() ? d + 1 : u.getTime() >= v.getTime() ? d : d - 1;
}
function qE(e, t) {
  var n, r, o, i, a, s, c, l;
  Pe(1, arguments);
  var u = Co(), d = Xt((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), m = Au(e, t), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(m, 0, d), p.setUTCHours(0, 0, 0, 0);
  var h = Gr(p, t);
  return h;
}
var JE = 6048e5;
function ZE(e, t) {
  Pe(1, arguments);
  var n = Ge(e), r = Gr(n, t).getTime() - qE(n, t).getTime();
  return Math.round(r / JE) + 1;
}
function me(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var _E = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return me(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : me(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return me(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return me(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return me(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return me(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return me(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, o = t.getUTCMilliseconds(), i = Math.floor(o * Math.pow(10, r - 3));
    return me(i, n.length);
  }
};
const Ot = _E;
var dn = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, e2 = {
  // Era
  G: function(t, n, r) {
    var o = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var o = t.getUTCFullYear(), i = o > 0 ? o : 1 - o;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Ot.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, o) {
    var i = Au(t, o), a = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var s = a % 100;
      return me(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(a, {
      unit: "year"
    }) : me(a, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = bu(t);
    return me(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return me(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return me(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return me(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Ot.M(t, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return me(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, o) {
    var i = ZE(t, o);
    return n === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : me(i, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var o = XE(t);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : me(o, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Ot.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var o = jE(t);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : me(o, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var o = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, o) {
    var i = t.getUTCDay(), a = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(a);
      case "ee":
        return me(a, 2);
      case "eo":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, o) {
    var i = t.getUTCDay(), a = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(a);
      case "cc":
        return me(a, n.length);
      case "co":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var o = t.getUTCDay(), i = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(i);
      case "ii":
        return me(i, n.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var o = t.getUTCHours(), i = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var o = t.getUTCHours(), i;
    switch (o === 12 ? i = dn.noon : o === 0 ? i = dn.midnight : i = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var o = t.getUTCHours(), i;
    switch (o >= 17 ? i = dn.evening : o >= 12 ? i = dn.afternoon : o >= 4 ? i = dn.morning : i = dn.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var o = t.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return Ot.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Ot.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var o = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : me(o, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var o = t.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : me(o, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Ot.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Ot.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Ot.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      case "X":
        return mc(a);
      case "XXXX":
      case "XX":
        return Gt(a);
      case "XXXXX":
      case "XXX":
      default:
        return Gt(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTimezoneOffset();
    switch (n) {
      case "x":
        return mc(a);
      case "xxxx":
      case "xx":
        return Gt(a);
      case "xxxxx":
      case "xxx":
      default:
        return Gt(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + hc(a, ":");
      case "OOOO":
      default:
        return "GMT" + Gt(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + hc(a, ":");
      case "zzzz":
      default:
        return "GMT" + Gt(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, o) {
    var i = o._originalDate || t, a = Math.floor(i.getTime() / 1e3);
    return me(a, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTime();
    return me(a, n.length);
  }
};
function hc(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(o);
  var a = t || "";
  return n + String(o) + a + me(i, 2);
}
function mc(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + me(Math.abs(e) / 60, 2);
  }
  return Gt(e, t);
}
function Gt(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e), i = me(Math.floor(o / 60), 2), a = me(o % 60, 2);
  return r + i + n + a;
}
const t2 = e2;
var gc = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, yu = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, n2 = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], o = r[1], i = r[2];
  if (!i)
    return gc(t, n);
  var a;
  switch (o) {
    case "P":
      a = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = n.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", gc(o, n)).replace("{{time}}", yu(i, n));
}, r2 = {
  p: yu,
  P: n2
};
const o2 = r2;
var i2 = ["D", "DD"], a2 = ["YY", "YYYY"];
function s2(e) {
  return i2.indexOf(e) !== -1;
}
function c2(e) {
  return a2.indexOf(e) !== -1;
}
function vc(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var l2 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, d2 = function(t, n, r) {
  var o, i = l2[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const u2 = d2;
function ni(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var f2 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, p2 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, h2 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, m2 = {
  date: ni({
    formats: f2,
    defaultWidth: "full"
  }),
  time: ni({
    formats: p2,
    defaultWidth: "full"
  }),
  dateTime: ni({
    formats: h2,
    defaultWidth: "full"
  })
};
const g2 = m2;
var v2 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, b2 = function(t, n, r, o) {
  return v2[t];
};
const A2 = b2;
function Fn(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[a] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[c] || e.values[s];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[l];
  };
}
var y2 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, w2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, x2 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, E2 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, C2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, I2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, T2 = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, O2 = {
  ordinalNumber: T2,
  era: Fn({
    values: y2,
    defaultWidth: "wide"
  }),
  quarter: Fn({
    values: w2,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Fn({
    values: x2,
    defaultWidth: "wide"
  }),
  day: Fn({
    values: E2,
    defaultWidth: "wide"
  }),
  dayPeriod: Fn({
    values: C2,
    defaultWidth: "wide",
    formattingValues: I2,
    defaultFormattingWidth: "wide"
  })
};
const S2 = O2;
function $n(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    var a = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? P2(s, function(d) {
      return d.test(a);
    }) : R2(s, function(d) {
      return d.test(a);
    }), l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
    var u = t.slice(a.length);
    return {
      value: l,
      rest: u
    };
  };
}
function R2(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function P2(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function D2(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var o = r[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var s = t.slice(o.length);
    return {
      value: a,
      rest: s
    };
  };
}
var M2 = /^(\d+)(th|st|nd|rd)?/i, N2 = /\d+/i, F2 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, $2 = {
  any: [/^b/i, /^(a|c)/i]
}, k2 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, B2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, L2 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, z2 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, G2 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Y2 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, H2 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, U2 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, W2 = {
  ordinalNumber: D2({
    matchPattern: M2,
    parsePattern: N2,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $n({
    matchPatterns: F2,
    defaultMatchWidth: "wide",
    parsePatterns: $2,
    defaultParseWidth: "any"
  }),
  quarter: $n({
    matchPatterns: k2,
    defaultMatchWidth: "wide",
    parsePatterns: B2,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $n({
    matchPatterns: L2,
    defaultMatchWidth: "wide",
    parsePatterns: z2,
    defaultParseWidth: "any"
  }),
  day: $n({
    matchPatterns: G2,
    defaultMatchWidth: "wide",
    parsePatterns: Y2,
    defaultParseWidth: "any"
  }),
  dayPeriod: $n({
    matchPatterns: H2,
    defaultMatchWidth: "any",
    parsePatterns: U2,
    defaultParseWidth: "any"
  })
};
const Q2 = W2;
var j2 = {
  code: "en-US",
  formatDistance: u2,
  formatLong: g2,
  formatRelative: A2,
  localize: S2,
  match: Q2,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const K2 = j2;
var V2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, X2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, q2 = /^'([^]*?)'?$/, J2 = /''/g, Z2 = /[a-zA-Z]/;
function _2(e, t, n) {
  var r, o, i, a, s, c, l, u, d, m, p, h, f, g, v, b, w, C;
  Pe(2, arguments);
  var T = String(t), P = Co(), M = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : P.locale) !== null && r !== void 0 ? r : K2, R = Xt((i = (a = (s = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (l = n.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : P.firstWeekContainsDate) !== null && a !== void 0 ? a : (d = P.locale) === null || d === void 0 || (m = d.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(R >= 1 && R <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var G = Xt((p = (h = (f = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (v = n.locale) === null || v === void 0 || (b = v.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && f !== void 0 ? f : P.weekStartsOn) !== null && h !== void 0 ? h : (w = P.locale) === null || w === void 0 || (C = w.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(G >= 0 && G <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!M.localize)
    throw new RangeError("locale must contain localize property");
  if (!M.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var Q = Ge(e);
  if (!UE(Q))
    throw new RangeError("Invalid time value");
  var U = GE(Q), te = WE(Q, U), X = {
    firstWeekContainsDate: R,
    weekStartsOn: G,
    locale: M,
    _originalDate: Q
  }, F = T.match(X2).map(function(L) {
    var z = L[0];
    if (z === "p" || z === "P") {
      var Z = o2[z];
      return Z(L, M.formatLong);
    }
    return L;
  }).join("").match(V2).map(function(L) {
    if (L === "''")
      return "'";
    var z = L[0];
    if (z === "'")
      return eC(L);
    var Z = t2[z];
    if (Z)
      return !(n != null && n.useAdditionalWeekYearTokens) && c2(L) && vc(L, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && s2(L) && vc(L, t, String(e)), Z(te, L, M.localize, X);
    if (z.match(Z2))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + z + "`");
    return L;
  }).join("");
  return F;
}
function eC(e) {
  var t = e.match(q2);
  return t ? t[1].replace(J2, "'") : e;
}
function Yi(e) {
  if (Pe(1, arguments), typeof e == "string") {
    var t = e.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    return t ? new Date(Date.UTC(+t[1], +t[2] - 1, +t[3], +t[4] - (+t[9] || 0) * (t[8] == "-" ? -1 : 1), +t[5] - (+t[10] || 0) * (t[8] == "-" ? -1 : 1), +t[6], +((t[7] || "0") + "00").substring(0, 3))) : /* @__PURE__ */ new Date(NaN);
  }
  return Ge(e);
}
const oI = (e, t = "MM/dd/yyyy", n = "UTC") => (typeof e == "object" && (e = tC(e, n)), _2(Yi(e), t)), tC = (e, t) => typeof e == "string" ? new Date(
  new Date(e).toLocaleString("en-US", {
    timeZone: t
  })
) : new Date(
  e.toLocaleString("en-US", {
    timeZone: t
  })
), iI = (e, t = " ") => e.split(t).join("-").toLowerCase(), aI = (e) => {
  const t = e.trim().replace(/\D/g, ""), n = t.match(/^(\d)(\d{3})(\d{3})(\d{4})$/), r = t.match(/^(\d{3})(\d{3})(\d{4})$/), o = t.match(/^(\d{3})(\d{4})$/);
  return n ? n[1] + " (" + n[2] + ") " + n[3] + "-" + n[4] : r ? "(" + r[1] + ") " + r[2] + "-" + r[3] : o ? o[1] + "-" + o[2] : e;
}, sI = (e) => {
  const t = new URLSearchParams();
  for (const n in e) {
    const r = e[n];
    r !== null && t.append(n, r.toString());
  }
  return t.toString();
}, cI = () => {
  const e = (/* @__PURE__ */ new Date()).getTime();
  return e < 0 ? e : -e;
}, lI = ({
  fromSearchParams: e,
  key: t,
  removeEmpty: n = !1,
  value: r
}) => {
  const o = e ?? new URLSearchParams();
  return n && !r ? o.delete(t) : o.set(t, r), o;
};
function nt(e) {
  if (typeof e != "string")
    throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
}
function bc(e, t) {
  for (var n = "", r = 0, o = -1, i = 0, a, s = 0; s <= e.length; ++s) {
    if (s < e.length)
      a = e.charCodeAt(s);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(o === s - 1 || i === 1))
        if (o !== s - 1 && i === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              var c = n.lastIndexOf("/");
              if (c !== n.length - 1) {
                c === -1 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), o = s, i = 0;
                continue;
              }
            } else if (n.length === 2 || n.length === 1) {
              n = "", r = 0, o = s, i = 0;
              continue;
            }
          }
          t && (n.length > 0 ? n += "/.." : n = "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(o + 1, s) : n = e.slice(o + 1, s), r = s - o - 1;
      o = s, i = 0;
    } else
      a === 46 && i !== -1 ? ++i : i = -1;
  }
  return n;
}
function nC(e, t) {
  var n = t.dir || t.root, r = t.base || (t.name || "") + (t.ext || "");
  return n ? n === t.root ? n + r : n + e + r : r;
}
var pn = {
  // path.resolve([from ...], to)
  resolve: function() {
    for (var t = "", n = !1, r, o = arguments.length - 1; o >= -1 && !n; o--) {
      var i;
      o >= 0 ? i = arguments[o] : (r === void 0 && (r = process.cwd()), i = r), nt(i), i.length !== 0 && (t = i + "/" + t, n = i.charCodeAt(0) === 47);
    }
    return t = bc(t, !n), n ? t.length > 0 ? "/" + t : "/" : t.length > 0 ? t : ".";
  },
  normalize: function(t) {
    if (nt(t), t.length === 0)
      return ".";
    var n = t.charCodeAt(0) === 47, r = t.charCodeAt(t.length - 1) === 47;
    return t = bc(t, !n), t.length === 0 && !n && (t = "."), t.length > 0 && r && (t += "/"), n ? "/" + t : t;
  },
  isAbsolute: function(t) {
    return nt(t), t.length > 0 && t.charCodeAt(0) === 47;
  },
  join: function() {
    if (arguments.length === 0)
      return ".";
    for (var t, n = 0; n < arguments.length; ++n) {
      var r = arguments[n];
      nt(r), r.length > 0 && (t === void 0 ? t = r : t += "/" + r);
    }
    return t === void 0 ? "." : pn.normalize(t);
  },
  relative: function(t, n) {
    if (nt(t), nt(n), t === n || (t = pn.resolve(t), n = pn.resolve(n), t === n))
      return "";
    for (var r = 1; r < t.length && t.charCodeAt(r) === 47; ++r)
      ;
    for (var o = t.length, i = o - r, a = 1; a < n.length && n.charCodeAt(a) === 47; ++a)
      ;
    for (var s = n.length, c = s - a, l = i < c ? i : c, u = -1, d = 0; d <= l; ++d) {
      if (d === l) {
        if (c > l) {
          if (n.charCodeAt(a + d) === 47)
            return n.slice(a + d + 1);
          if (d === 0)
            return n.slice(a + d);
        } else
          i > l && (t.charCodeAt(r + d) === 47 ? u = d : d === 0 && (u = 0));
        break;
      }
      var m = t.charCodeAt(r + d), p = n.charCodeAt(a + d);
      if (m !== p)
        break;
      m === 47 && (u = d);
    }
    var h = "";
    for (d = r + u + 1; d <= o; ++d)
      (d === o || t.charCodeAt(d) === 47) && (h.length === 0 ? h += ".." : h += "/..");
    return h.length > 0 ? h + n.slice(a + u) : (a += u, n.charCodeAt(a) === 47 && ++a, n.slice(a));
  },
  _makeLong: function(t) {
    return t;
  },
  dirname: function(t) {
    if (nt(t), t.length === 0)
      return ".";
    for (var n = t.charCodeAt(0), r = n === 47, o = -1, i = !0, a = t.length - 1; a >= 1; --a)
      if (n = t.charCodeAt(a), n === 47) {
        if (!i) {
          o = a;
          break;
        }
      } else
        i = !1;
    return o === -1 ? r ? "/" : "." : r && o === 1 ? "//" : t.slice(0, o);
  },
  basename: function(t, n) {
    if (n !== void 0 && typeof n != "string")
      throw new TypeError('"ext" argument must be a string');
    nt(t);
    var r = 0, o = -1, i = !0, a;
    if (n !== void 0 && n.length > 0 && n.length <= t.length) {
      if (n.length === t.length && n === t)
        return "";
      var s = n.length - 1, c = -1;
      for (a = t.length - 1; a >= 0; --a) {
        var l = t.charCodeAt(a);
        if (l === 47) {
          if (!i) {
            r = a + 1;
            break;
          }
        } else
          c === -1 && (i = !1, c = a + 1), s >= 0 && (l === n.charCodeAt(s) ? --s === -1 && (o = a) : (s = -1, o = c));
      }
      return r === o ? o = c : o === -1 && (o = t.length), t.slice(r, o);
    } else {
      for (a = t.length - 1; a >= 0; --a)
        if (t.charCodeAt(a) === 47) {
          if (!i) {
            r = a + 1;
            break;
          }
        } else
          o === -1 && (i = !1, o = a + 1);
      return o === -1 ? "" : t.slice(r, o);
    }
  },
  extname: function(t) {
    nt(t);
    for (var n = -1, r = 0, o = -1, i = !0, a = 0, s = t.length - 1; s >= 0; --s) {
      var c = t.charCodeAt(s);
      if (c === 47) {
        if (!i) {
          r = s + 1;
          break;
        }
        continue;
      }
      o === -1 && (i = !1, o = s + 1), c === 46 ? n === -1 ? n = s : a !== 1 && (a = 1) : n !== -1 && (a = -1);
    }
    return n === -1 || o === -1 || // We saw a non-dot character immediately before the dot
    a === 0 || // The (right-most) trimmed path component is exactly '..'
    a === 1 && n === o - 1 && n === r + 1 ? "" : t.slice(n, o);
  },
  format: function(t) {
    if (t === null || typeof t != "object")
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof t);
    return nC("/", t);
  },
  parse: function(t) {
    nt(t);
    var n = { root: "", dir: "", base: "", ext: "", name: "" };
    if (t.length === 0)
      return n;
    var r = t.charCodeAt(0), o = r === 47, i;
    o ? (n.root = "/", i = 1) : i = 0;
    for (var a = -1, s = 0, c = -1, l = !0, u = t.length - 1, d = 0; u >= i; --u) {
      if (r = t.charCodeAt(u), r === 47) {
        if (!l) {
          s = u + 1;
          break;
        }
        continue;
      }
      c === -1 && (l = !1, c = u + 1), r === 46 ? a === -1 ? a = u : d !== 1 && (d = 1) : a !== -1 && (d = -1);
    }
    return a === -1 || c === -1 || // We saw a non-dot character immediately before the dot
    d === 0 || // The (right-most) trimmed path component is exactly '..'
    d === 1 && a === c - 1 && a === s + 1 ? c !== -1 && (s === 0 && o ? n.base = n.name = t.slice(1, c) : n.base = n.name = t.slice(s, c)) : (s === 0 && o ? (n.name = t.slice(1, a), n.base = t.slice(1, c)) : (n.name = t.slice(s, a), n.base = t.slice(s, c)), n.ext = t.slice(a, c)), s > 0 ? n.dir = t.slice(0, s - 1) : o && (n.dir = "/"), n;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
pn.posix = pn;
var rC = pn;
const wu = /* @__PURE__ */ Hu(rC), dI = ({ prefixPath: e, path: t }) => wu.join(e, t), uI = (e) => e.map(
  ({ prefixPath: t, path: n }) => wu.join(t, n)
);
var xu = {}, Ra = {}, Pa = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), function(t) {
    t[t.EMERGENCY = 600] = "EMERGENCY", t[t.ALERT = 550] = "ALERT", t[t.CRITICAL = 500] = "CRITICAL", t[t.ERROR = 400] = "ERROR", t[t.WARNING = 300] = "WARNING", t[t.NOTICE = 250] = "NOTICE", t[t.INFO = 200] = "INFO", t[t.DEBUG = 100] = "DEBUG", t[t.SUCCESS = 0] = "SUCCESS";
  }(e.Level || (e.Level = {}));
})(Pa);
Object.defineProperty(Ra, "__esModule", { value: !0 });
const rt = Pa;
let oC = class {
  constructor() {
    this._verbosity = rt.Level.DEBUG;
  }
  set verbosity(t) {
    this._verbosity = t;
  }
  get verbosity() {
    return this._verbosity;
  }
  innerLog(t) {
  }
  log(t, n, r) {
    this.innerLog({ message: n, level: t, context: r });
  }
  emergency(t, n) {
    this.log(rt.Level.EMERGENCY, t, n);
  }
  alert(t, n) {
    this.log(rt.Level.ALERT, t, n);
  }
  critical(t, n) {
    this.log(rt.Level.CRITICAL, t, n);
  }
  error(t, n) {
    this.log(rt.Level.ERROR, t, n);
  }
  warning(t, n) {
    this.log(rt.Level.WARNING, t, n);
  }
  notice(t, n) {
    this.log(rt.Level.NOTICE, t, n);
  }
  info(t, n) {
    this.log(rt.Level.INFO, t, n);
  }
  debug(t, n) {
    this.log(rt.Level.DEBUG, t, n);
  }
  success(t, n) {
    this.log(rt.Level.SUCCESS, t, n);
  }
};
Ra.Logger = oC;
var Da = {};
Object.defineProperty(Da, "__esModule", { value: !0 });
class iC {
  constructor() {
    let t;
    this._storeAvailable = !1, this._store = null;
    try {
      t = window.localStorage;
      const n = "__storage_test__";
      t.setItem(n, n), t.removeItem(n), this._storeAvailable = !0;
    } catch {
      this._storeAvailable = !1;
    }
  }
  get(t) {
    return this._storeAvailable && this._store !== null ? JSON.parse(this._store.getItem(t)) : null;
  }
}
Da.localStorage = new iC();
Object.defineProperty(xu, "__esModule", { value: !0 });
const aC = Ra, pt = Pa, Ac = Da;
class sC extends aC.Logger {
  logOnLoad() {
    const t = document.querySelectorAll("[data-plopix-console]");
    if (t === null)
      return;
    const n = (o) => {
      const i = o.getAttribute("data-verbosity");
      return i === null ? 0 : +i;
    }, r = (o) => {
      const i = o.getAttribute("data-context");
      if (i === null)
        return null;
      try {
        return JSON.parse(i);
      } catch {
        return i;
      }
    };
    for (const o of t)
      this.log(n(o), o.textContent === null ? "Unkown message" : o.textContent, r(o));
  }
  innerLog(t) {
    const n = Ac.localStorage.get("plopix.console.verbosity") != null ? Ac.localStorage.get("plopix.console.verbosity") : this._verbosity;
    t.level >= n && this.show(t);
  }
  styleForLevel(t) {
    switch (t) {
      case pt.Level.SUCCESS:
        return "color: #fff; background-color: green; padding: 4px";
      case pt.Level.DEBUG:
        return "";
      case pt.Level.INFO:
        return "font-weight:bold";
      case pt.Level.NOTICE:
        return "color: yellow";
      case pt.Level.WARNING:
        return "color: #ff9900";
      case pt.Level.ERROR:
        return "color: red";
      case pt.Level.CRITICAL:
        return "color: red; font-weight: bold";
      case pt.Level.ALERT:
        return "color: #fff; background-color: red; padding: 4px";
      case pt.Level.EMERGENCY:
        return "color: #fff; background-color: red; padding: 4px; font-weight: bold";
    }
    return "";
  }
  showStyledLog(t) {
    let n = [];
    t.context !== null && typeof t.context < "u" && (n = t.context, Array.isArray(n) || (n = [n])), console.log("%c" + t.message, this.styleForLevel(t.level), ...n);
  }
  show(t) {
    typeof console.log < "u" && this.showStyledLog(t);
  }
  groupStart(t) {
    typeof console.group < "u" && console.group(t);
  }
  groupEnd() {
    typeof console.groupEnd < "u" && console.groupEnd();
  }
  dir(t) {
    typeof console.dir < "u" && console.dir(t);
  }
  table(t) {
    typeof console.table < "u" && console.table(t);
  }
  clear() {
    typeof console.clear < "u" && console.clear();
  }
  memory() {
  }
  trace() {
    typeof console.trace < "u" && console.trace();
  }
}
var cC = xu.Console = sC;
const Io = new cC();
Io.verbosity = 400;
Io.logOnLoad();
const pI = (e = !0) => {
  Io.verbosity = e ? 400 : 0;
}, hI = (e, t) => Yd(e, t, sessionStorage), mI = (e, t) => {
  Ri(e, t, sessionStorage);
}, gI = (e) => {
  lw(e, sessionStorage);
}, vI = (e, t, n) => e[n].toUpperCase().localeCompare(t[n].toUpperCase()), bI = (e, t, n) => e[n] - t[n], AI = (e, t, n) => YE(Yi(e[n]), Yi(t[n])), sr = {};
sr[qe.ADMIN] = {
  key: qe.ADMIN,
  value: "Admin",
  level: 5
};
sr[qe.MANAGER] = {
  key: qe.MANAGER,
  value: "Manager",
  level: 4
};
sr[qe.STAFF] = {
  key: qe.STAFF,
  value: "Staff",
  level: 3
};
sr[qe.CREW] = {
  key: qe.CREW,
  value: "Crew",
  level: 2
};
sr[qe.VIEWER] = {
  key: qe.VIEWER,
  value: "Viewer",
  level: 1
};
const yI = ({
  baseURL: e,
  customUrls: t,
  debug: n = !1,
  events: r,
  handlerRejection: o,
  handlerRequest: i,
  ...a
}) => {
  const s = BE.create({
    baseURL: e,
    withCredentials: !0,
    ...a
  });
  return s.interceptors.request.use(
    async (c) => await i(c),
    async (c) => await Promise.reject(c)
  ), s.interceptors.response.use(
    (c) => (n && Io.debug("interceptors ok:", c), c),
    async (c) => await (o == null ? void 0 : o(c, {
      axiosInstance: s,
      baseURL: e,
      customUrls: t,
      debug: n,
      events: r
    }))
  ), s;
};
export {
  _C as ABORT_REQUEST_REASON,
  Qf as BaseAccordion,
  Kf as BaseAccordionContent,
  lr as BaseAccordionItem,
  jf as BaseAccordionTrigger,
  mC as BaseCheckbox,
  Y0 as BaseDropdown,
  H0 as BaseDropdownItem,
  _0 as BaseInfiniteScroll,
  tr as BaseLoading,
  Gl as BaseModal,
  yC as BasePopover,
  ld as BaseSelect,
  i1 as BaseSelectArrowDown,
  o1 as BaseSelectArrowUp,
  a1 as BaseSelectIndicator,
  c1 as BaseSelectItem,
  r1 as BaseSelectItemText,
  s1 as BaseSelectViewport,
  xC as BaseSkeleton,
  dd as BaseSlot,
  CC as BaseSwitch,
  cA as BaseToast,
  lA as BaseToastViewport,
  Yt as BaseTooltip,
  G0 as BaseTriggerDropdown,
  fo as Button,
  TC as ContentPagination,
  mA as DisplayContent,
  Ls as FormBase,
  OC as FormModal,
  jC as INIT_PAGE,
  KC as LIMIT_PAGE,
  iy as LazyImage,
  X0 as ListLoading,
  Io as Logger,
  RC as MainContainer,
  VC as NO_LIMIT_PAGE,
  MC as PageContent,
  NC as PageHeader,
  XC as Permissions,
  qe as Roles,
  FC as SearchBar,
  $C as SelectData,
  kC as SelectFilter,
  aw as SelectFilterItem,
  zd as SelectFilterListItem,
  GC as SideModal,
  Ow as Sidebar,
  Hd as SidebarContext,
  LC as SidebarHeader,
  zC as SidebarHeaderMenuProfileItem,
  dw as SidebarItem,
  BC as SidebarProvider,
  Ir as StorageKey,
  DC as Tab,
  Ay as TabFilterGroup,
  YC as Table,
  UC as TableButtonActionsCell,
  ex as TableCell,
  WC as TableImageCell,
  HC as TableRow,
  QC as TableStatusCell,
  cx as TextStatus,
  Zd as ToastContext,
  JC as ToastProvider,
  nI as assertAbortReason,
  yI as createApi,
  oI as dateFormatFromJSON,
  rI as filterByAttribute,
  iI as formatKebabCase,
  aI as formatPhoneNumber,
  eI as generateAbortRequest,
  cI as generateNegativeTimestamp,
  lI as generateUrlSearchParams,
  dI as getRouteFrom,
  uI as getRoutesFrom,
  hI as getSessionStorage,
  Yd as getStorage,
  pI as handlerOmitComments,
  tI as isAbortError,
  sI as queryStringFormat,
  gI as removeSessionStorage,
  lw as removeStorage,
  qC as rolesWithLevel,
  mI as setSessionStorage,
  Ri as setStorage,
  AI as sortByDateAttribute,
  bI as sortByNumberAttribute,
  vI as sortByStringAttribute,
  sr as translateUserRoleInRole,
  Ud as useSidebar,
  ZC as useToast
};
